
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("6nmjq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a8bb8d32b28b76e3$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $6GvED = parcelRequire("6GvED");

var $aI0YR = parcelRequire("aI0YR");

var $9W8Q3 = parcelRequire("9W8Q3");
const $a8bb8d32b28b76e3$var$selector = (0, $BOq7h.createSelector)((0, $6GvED.getFabricEmojiUrl), (0, $aI0YR.getAccountId), (fabricEmojiUrl, accountId)=>({
        fabricEmojiUrl: fabricEmojiUrl,
        accountId: accountId
    }));
var $a8bb8d32b28b76e3$export$2e2bcd8739ae039 = (0, $egQxE.connect)($a8bb8d32b28b76e3$var$selector, {})((0, $9W8Q3.default));

});
parcelRegister("9W8Q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb3a672c99c33420$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $jcRK7 = parcelRequire("jcRK7");

var $l5bvm = parcelRequire("l5bvm");

var $hJ95b = parcelRequire("hJ95b");
var $eFyLM = parcelRequire("eFyLM");
var $9uL9A = parcelRequire("9uL9A");

var $fK3tS = parcelRequire("fK3tS");

var $cOf1A = parcelRequire("cOf1A");
parcelRequire("hBGB6");
var $lupK8 = parcelRequire("lupK8");

var $e82zF = parcelRequire("e82zF");
parcelRequire("cOxsJ");
var $gI0L8 = parcelRequire("gI0L8");
parcelRequire("d5XfI");
var $189PI = parcelRequire("189PI");

var $dwOcU = parcelRequire("dwOcU");

var $4WMGM = parcelRequire("4WMGM");

var $4ZoR6 = parcelRequire("4ZoR6");

var $6eumI = parcelRequire("6eumI");

var $iM9ST = parcelRequire("iM9ST");

var $c6WhP = parcelRequire("c6WhP");

var $64ZSD = parcelRequire("64ZSD");
const $bb3a672c99c33420$var$autoformattingProvider = new (0, $hJ95b.PortalAutoformattingProvider)();
const $bb3a672c99c33420$var$smartCardClient = new (0, $eFyLM.PortalCardClient)();
class $bb3a672c99c33420$export$62defb9a02d4952c extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        LoadingComponent: ()=>null
    };
    componentDidMount() {
        this.props.shouldFocus && this.focusOnEditor();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.shouldFocus && this.props.shouldFocus) this.focusOnEditor();
    }
    render() {
        const { editorType: editorType, mediaContext: mediaContext } = this.props;
        const editor = mediaContext ? this.renderEditorWithMediaContext(mediaContext) : this.renderEditor(this.props.customMediaOptions);
        return /*#__PURE__*/ $bSJIT.createElement((0, $lupK8.default), {
            type: editorType
        }, editor);
    }
    constructor(...args){
        super(...args), this.cardProvider = new (0, $9uL9A.PortalCardProviderNew)(), this.transformer = new (0, $c6WhP.JSONTransformer)(), this.editorActions = undefined, this.mentionProvider = this.props.accountId ? Promise.resolve((0, $gI0L8.getMentionProvider)(this.props.accountId, this.props.requestKey, this.props.fieldConfigs)) : undefined, this.focusOnEditor = ()=>{
            //we need to use the setTimeout here, otherwise focusing on the editor immediately will cause the caret to flash
            //50ms seem like our magic number, but it might varies on browsers
            setTimeout(()=>{
                this.editorActions && this.editorActions.focus();
            }, 50);
        }, this.onSave = (editorView, actions)=>{
            const { onSave: onSave } = this.props;
            if (onSave) onSave(this.transformer.encode(editorView.state.doc), actions);
        }, this.renderEditorWithMediaContext = (mediaContext)=>{
            const { portalId: portalId, requestId: requestId } = mediaContext;
            return /*#__PURE__*/ $bSJIT.createElement((0, $189PI.WithUploadCredentials), {
                portalId: portalId,
                requestId: requestId
            }, (provider)=>this.renderEditorWithMediaProvider(provider));
        }, this.renderEditorWithMediaProvider = (mediaProvider)=>{
            const mediaOptions = {
                provider: mediaProvider,
                allowMediaSingle: true
            };
            return this.renderEditor(mediaOptions);
        }, this.internalOnChange = (editorView)=>{
            const { onChange: onChange } = this.props;
            if (onChange) onChange(this.transformer.encode(editorView.state.doc));
        }, this.renderEditor = (mediaOptions)=>{
            const renderFunction = (actions)=>this.internalRenderEditor(actions, mediaOptions);
            return /*#__PURE__*/ $bSJIT.createElement((0, $iM9ST.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $6eumI.default), {
                render: renderFunction
            }));
        }, this.internalOnCancel = ()=>{
            if (this.editorActions) {
                var _this$props$onCancel, _this$props;
                (_this$props$onCancel = (_this$props = this.props).onCancel) === null || _this$props$onCancel === void 0 || _this$props$onCancel.call(_this$props, this.editorActions);
            }
        }, this.internalOnSave = (editorView)=>{
            if (this.editorActions) this.onSave(editorView, this.editorActions);
        }, this.internalRenderEditor = (actions, mediaOptions)=>{
            const { placeholderWhenCollapsed: placeholderWhenCollapsed, isExpanded: isExpanded, expandEditor: expandEditor, placeholderWhenExpanded: placeholderWhenExpanded, onCancel: onCancel, disabled: disabled, isEmojiEnabled: isEmojiEnabled, defaultValue: defaultValue, fabricEmojiUrl: fabricEmojiUrl, onSave: onSave, ariaLabel: ariaLabel, ariaDescribedby: ariaDescribedby, customSecondaryToolbar: customSecondaryToolbar } = this.props;
            const internalOnCancel = onCancel === undefined ? undefined : ()=>this.internalOnCancel();
            const internalOnSave = onSave === undefined ? undefined : (editorView)=>this.internalOnSave(editorView);
            this.editorActions = actions;
            if (this.props.onInternalRender) this.props.onInternalRender(this.editorActions);
            const tableConfig = {
                allowColumnResizing: true,
                allowControls: true,
                allowHeaderRow: true,
                allowHeaderColumn: true,
                allowNumberColumn: true
            };
            return /*#__PURE__*/ $bSJIT.createElement($bb3a672c99c33420$var$EditorWrapper, null, /*#__PURE__*/ $bSJIT.createElement((0, $e82zF.MediaWrapper), {
                mediaOptions: mediaOptions
            }, /*#__PURE__*/ $bSJIT.createElement((0, $64ZSD.SmartCardProvider), {
                client: $bb3a672c99c33420$var$smartCardClient
            }, /*#__PURE__*/ $bSJIT.createElement((0, $4WMGM.default), {
                placeholder: placeholderWhenCollapsed,
                isExpanded: isExpanded,
                onFocus: expandEditor
            }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
                data: {
                    attributes: {
                        mediaSource: 'inline'
                    }
                }
            }, /*#__PURE__*/ $bSJIT.createElement((0, $4ZoR6.default), {
                allowAnalyticsGASV3: true,
                defaultValue: defaultValue,
                appearance: "comment",
                placeholder: placeholderWhenExpanded,
                assistiveLabel: ariaLabel,
                assistiveDescribedBy: ariaDescribedby,
                onSave: internalOnSave,
                onCancel: internalOnCancel,
                onChange: this.internalOnChange,
                allowTextColor: true,
                allowRule: true,
                allowPanel: true,
                allowTables: tableConfig,
                allowDate: false,
                UNSAFE_cards: {
                    provider: Promise.resolve(this.cardProvider)
                },
                autoformattingProvider: Promise.resolve($bb3a672c99c33420$var$autoformattingProvider),
                emojiProvider: (0, $l5bvm.getEmojiProvider)(isEmojiEnabled, fabricEmojiUrl),
                media: mediaOptions,
                disabled: disabled,
                waitForMediaUpload: true,
                mentionProvider: this.mentionProvider,
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                popupsBoundariesElement: document.documentElement
            })), customSecondaryToolbar === null || customSecondaryToolbar === void 0 ? void 0 : customSecondaryToolbar(this.editorActions))))));
        };
    }
}
var $bb3a672c99c33420$export$2e2bcd8739ae039 = (0, $cOf1A.withBrowserMetricSubmitter)((0, $jcRK7.BrowserMetricViewName).COMMENT_EDITOR_VIEW, (0, $fK3tS.default)($bb3a672c99c33420$export$62defb9a02d4952c));
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb3a672c99c33420$var$EditorWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-slb8ra-0"
})`.akEditor{.less-margin .ProseMirror{margin:${"var(--ds-space-150, 12px)"};padding:0 ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 2px)"};}}`;

});
parcelRegister("l5bvm", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $bb029d09482d8a6b$export$8210f5f78c0bcf27);

var $etCmN = parcelRequire("etCmN");

var $ePuyT = parcelRequire("ePuyT");

var $a6ENB = parcelRequire("a6ENB");
const $bb029d09482d8a6b$export$8210f5f78c0bcf27 = (0, $ePuyT.default)((isEmojiEnabled, fabricEmojiUrl)=>{
    if (isEmojiEnabled && fabricEmojiUrl) {
        const emojiResource = new (0, $etCmN.default)({
            providers: [
                {
                    url: `${fabricEmojiUrl}/emoji/standard`
                },
                {
                    url: `${fabricEmojiUrl}/emoji/atlassian`
                }
            ],
            allowUpload: false
        });
        return emojiResource.fetchEmojiProvider().then(()=>Promise.resolve(emojiResource)).catch((e)=>{
            (0, $a6ENB.reportError)(e);
            return Promise.reject(e);
        });
    }
    return undefined;
});

});

parcelRegister("eFyLM", function(module, exports) {
$parcel$export(module.exports, "PortalCardClient", () => $2b117e521c9167cf$export$f9fc5c7aa80e3e65);

var $tLWYq = parcelRequire("tLWYq");

var $oORS9 = parcelRequire("oORS9");

var $kUtMt = parcelRequire("kUtMt");
class $2b117e521c9167cf$export$f9fc5c7aa80e3e65 extends (0, $tLWYq.default) {
    async fetchData(url) {
        const issueKey = (0, $oORS9.parseIssueKeyFromUrl)(url);
        if (issueKey === null) // This doesn't look like Jira URL, so let's use native resolver
        return super.fetchData(url);
        // Suppressing existing violation. Please fix this.
        return (0, $kUtMt.getRequestSmartCardData)(issueKey).then(// eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (response)=>this.createResolveResponse(issueKey, response));
    }
    prefetchData() {
        return Promise.resolve(undefined);
    }
    constructor(...args){
        super(...args), /* eslint-disable  @typescript-eslint/no-explicit-any */ this.createResolveResponse = (issueKey, response)=>{
            return {
                meta: {
                    visibility: 'restricted',
                    access: 'granted',
                    auth: [],
                    definitionId: 'jira-native-resolve'
                },
                data: {
                    '@context': {
                        '@vocab': 'https://www.w3.org/ns/activitystreams#',
                        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                        schema: 'http://schema.org/'
                    },
                    '@type': [
                        'atlassian:Task',
                        'Object'
                    ],
                    name: `${issueKey}: ${response.summary}`,
                    tag: {
                        name: response.status,
                        appearance: 'default'
                    },
                    url: response.url,
                    taskType: {
                        '@type': [
                            'Object',
                            'atlassian:TaskType'
                        ],
                        '@id': 'https://www.atlassian.com/#JiraCustomTaskType',
                        name: response.requestType.name
                    },
                    icon: {
                        '@type': 'Image',
                        url: response.requestType.iconUrl
                    },
                    generator: {
                        '@type': 'Application',
                        '@id': 'https://www.atlassian.com/#Jira',
                        name: 'Jira'
                    }
                }
            };
        };
    }
}

});
parcelRegister("kUtMt", function(module, exports) {
$parcel$export(module.exports, "canViewRequest", () => $459653c0427bd542$export$fcf9cdaf6dacff17);
$parcel$export(module.exports, "getRequestSmartCardData", () => $459653c0427bd542$export$7c3f0476ba399805);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $459653c0427bd542$export$fcf9cdaf6dacff17 = (requestKey, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard/canviewrequest`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.canViewRequest;
    }).toPromise().catch((e)=>Promise.reject(e));
};
const $459653c0427bd542$export$7c3f0476ba399805 = (requestKey, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).toPromise().catch((e)=>Promise.reject(e));
};

});


parcelRegister("cOf1A", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricProvider", () => $cfbb3711e9d19aab$export$650dc360d03e8221);
$parcel$export(module.exports, "withBrowserMetricSubmitter", () => $cfbb3711e9d19aab$export$1eeea2e4542f98cf);

var $bSJIT = parcelRequire("bSJIT");

var $db841 = parcelRequire("db841");

var $iydAA = parcelRequire("iydAA");
const $cfbb3711e9d19aab$var$context = /*#__PURE__*/ $bSJIT.createContext({
    updateRendered: ()=>null
});
const $cfbb3711e9d19aab$var$allComponentRendered = (renderedList)=>{
    return Object.values(renderedList).every(Boolean);
};
const $cfbb3711e9d19aab$var$getInitialState = (requiredComponent)=>{
    return requiredComponent.reduce((acc, componentKey)=>{
        acc[componentKey] = false;
        return acc;
    }, {});
};
const $cfbb3711e9d19aab$export$650dc360d03e8221 = ({ requiredComponents: requiredComponents, additionalAttributes: additionalAttributes, children: children })=>{
    const [renderedComponents, setRenderedComponents] = $bSJIT.useState($cfbb3711e9d19aab$var$getInitialState(requiredComponents));
    const updateRendered = $bSJIT.useCallback((componentName)=>{
        if (!renderedComponents[componentName]) setRenderedComponents((state)=>({
                ...state,
                [componentName]: true
            }));
    }, [
        renderedComponents
    ]);
    const content = $cfbb3711e9d19aab$var$allComponentRendered(renderedComponents) ? /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), {
        customData: additionalAttributes
    }) : null;
    return /*#__PURE__*/ $bSJIT.createElement($cfbb3711e9d19aab$var$context.Provider, {
        value: {
            updateRendered: updateRendered
        }
    }, content, children);
};
const $cfbb3711e9d19aab$export$d3284227ea46da67 = ({ componentName: componentName })=>{
    const { updateRendered: updateRendered } = $bSJIT.useContext($cfbb3711e9d19aab$var$context);
    $bSJIT.useEffect(()=>{
        (0, $db841.perfMark)(`rendered.${componentName}`);
        updateRendered(componentName);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $cfbb3711e9d19aab$export$1eeea2e4542f98cf = (componentName, WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>{
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($cfbb3711e9d19aab$export$d3284227ea46da67, {
            componentName: componentName
        }), /*#__PURE__*/ $bSJIT.createElement(WrappedComponent, props));
    };

});

parcelRegister("hBGB6", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("lupK8")).default);

var $lupK8 = parcelRequire("lupK8");

});
parcelRegister("lupK8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cd69aaa00a76680$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $fK3tS = parcelRequire("fK3tS");

var $buKRr = parcelRequire("buKRr");

var $aOysP = parcelRequire("aOysP");
const $1cd69aaa00a76680$export$2a39522663534d6 = (0, $fK3tS.default)(({ type: type, intl: intl })=>/*#__PURE__*/ $bSJIT.createElement((0, $buKRr.default), {
        appearance: "error"
    }, intl.formatMessage($1cd69aaa00a76680$var$typeToMessage(type))));
const $1cd69aaa00a76680$var$typeToMessage = (type)=>{
    if (type === 'field') return (0, $aOysP.default).failedToRenderField;
    if (type === 'comment') return (0, $aOysP.default).failedToRenderComment;
    if (type === 'comment-editor') return (0, $aOysP.default).failedToRenderCommentEditor;
    return (0, $aOysP.default).unknownError;
};
const $1cd69aaa00a76680$var$ErrorBoundaryMessage = ({ type: type, children: children })=>{
    const renderError = $bSJIT.useCallback(()=>/*#__PURE__*/ $bSJIT.createElement($1cd69aaa00a76680$export$2a39522663534d6, {
            type: type
        }), [
        type
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
        renderError: renderError
    }, children);
};
var $1cd69aaa00a76680$export$2e2bcd8739ae039 = $1cd69aaa00a76680$var$ErrorBoundaryMessage;

});
parcelRegister("aOysP", function(module, exports) {
$parcel$export(module.exports, "default", () => $31fd330e3d2fa733$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $31fd330e3d2fa733$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    unknownError: {
        id: 'error.boundary.title',
        defaultMessage: 'An unknown error occurred.',
        description: 'Title for an error box saying that something went wrong'
    },
    failedToRenderField: {
        id: 'error.boundary.failed.to.render.field',
        defaultMessage: "We couldn't display this field.",
        description: 'Title for an error box saying that something went wrong while rendering a field'
    },
    failedToRenderComment: {
        id: 'error.boundary.failed.to.render.comment',
        defaultMessage: "We couldn't display this comment.",
        description: 'Title for an error box saying that something went wrong while rendering a comment'
    },
    failedToRenderCommentEditor: {
        id: 'error.boundary.failed.to.render.rich.text.editor',
        defaultMessage: "We couldn't display the comment editor.",
        description: 'Title for an error box saying that something went wrong while rendering the comment editor'
    }
});

});



parcelRegister("cOxsJ", function(module, exports) {
$parcel$export(module.exports, "getMentionProvider", () => (parcelRequire("gI0L8")).getMentionProvider);

var $gI0L8 = parcelRequire("gI0L8");

});
parcelRegister("gI0L8", function(module, exports) {
$parcel$export(module.exports, "getMentionProvider", () => $907bb1b2b95723ce$export$6742408d91365687);

var $jcRK7 = parcelRequire("jcRK7");

var $4ZMmh = parcelRequire("4ZMmh");

var $dGoYQ = parcelRequire("dGoYQ");

var $dp27t = parcelRequire("dp27t");

var $hKJUh = parcelRequire("hKJUh");
const $907bb1b2b95723ce$export$6742408d91365687 = (loggedInUserAccountId, requestKey, fieldConfigs)=>new $907bb1b2b95723ce$var$MentionProviderSelector(loggedInUserAccountId, requestKey, fieldConfigs);
class $907bb1b2b95723ce$var$MentionProviderSelector extends (0, $hKJUh.AbstractMentionResource) {
    constructor(loggedInAccountId, issueKey, fieldConfigs){
        super(), this.isFiltering = (query)=>{
            var _this$activeSearches;
            return (_this$activeSearches = this.activeSearches) === null || _this$activeSearches === void 0 ? void 0 : _this$activeSearches.has(query);
        }, this.filter = (query)=>{
            return this.debouncedFilter(query);
        }, this.notifyListeners = (mentionResult, duration)=>{
            this._notifyListeners(mentionResult, {
                duration: duration
            });
        }, this.notifyAllResultsListeners = (mentionResult)=>{
            this._notifyListeners(mentionResult);
        }, this.notifyErrorListeners = (error)=>{
            this._notifyErrorListeners(error);
        }, this.debouncedFilter = (0, $4ZMmh.debounce)((query = '')=>{
            const currentSearchTime = Date.now();
            return this.search(query).then((mentionResult)=>{
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this.notifyListeners(mentionResult, Date.now() - currentSearchTime);
                }
                this.notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, $4ZMmh.isNil)(query) && query.length > 0) this.activeSearches.delete(query);
                this.notifyErrorListeners(e);
            });
        }, (0, $jcRK7.USER_TYPING_DEBOUNCE_TIME)), this.shouldHighlightMention = (mention)=>mention.id === this.loggedInAccountId, this.search = (query = '')=>{
            this.activeSearches.add(query);
            if (this.issueKey) return (0, $dGoYQ.fetchUsersJsonWithIssueKey)(this.issueKey, query).mergeMap((users)=>users).reduce((allMentions, mention)=>[
                    ...allMentions,
                    mention
                ], []).map((mentions)=>({
                    mentions: mentions,
                    query: query
                })).toPromise();
            if (this.fieldConfigs) return (0, $dp27t.searchUser)({
                query: query,
                ...this.fieldConfigs
            }).map((response)=>response.map((user)=>({
                        id: user.id,
                        name: user.displayName,
                        avatarUrl: user.avatar
                    }))).mergeMap((users)=>users).reduce((allMentions, mention)=>[
                    ...allMentions,
                    mention
                ], []).map((mentions)=>({
                    mentions: mentions,
                    query: query
                })).toPromise();
            return Promise.resolve({
                query: query,
                mentions: []
            });
        };
        if (issueKey) this.issueKey = issueKey;
        if (fieldConfigs) this.fieldConfigs = fieldConfigs;
        this.loggedInAccountId = loggedInAccountId;
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
    }
}
var $907bb1b2b95723ce$export$2e2bcd8739ae039 = $907bb1b2b95723ce$var$MentionProviderSelector;

});
parcelRegister("dGoYQ", function(module, exports) {
$parcel$export(module.exports, "fetchUsersJsonWithIssueKey", () => $e4af74899a3f80de$export$f36aebb8caf83a59);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $e4af74899a3f80de$export$f36aebb8caf83a59 = (issueKey, query, context = (0, $eDcdn.contextPath))=>{
    const headers = {
        Accept: 'application/json'
    };
    const uri = `${context}/rest/servicedesk/1/customer/mention/${issueKey}/search?q=${query}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};

});

parcelRegister("hKJUh", function(module, exports) {
$parcel$export(module.exports, "AbstractMentionResource", () => $3393534fab1acad4$export$8576ba1ed2760927);

var $9uMC1 = parcelRequire("9uMC1");

var $6g80G = parcelRequire("6g80G");
const $3393534fab1acad4$var$MAX_NOTIFIED_ITEMS = 20;
class $3393534fab1acad4$export$8576ba1ed2760927 extends (0, $6g80G.AbstractResource) {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $9uMC1.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $3393534fab1acad4$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $9uMC1.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $9uMC1.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $3393534fab1acad4$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $9uMC1.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $9uMC1.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $9uMC1.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $9uMC1.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}

});
parcelRegister("9uMC1", function(module, exports) {
$parcel$export(module.exports, "default", () => $be691fe4208dbff9$export$2e2bcd8739ae039);
let $be691fe4208dbff9$var$debugEnabled = false;
let $be691fe4208dbff9$var$stacktracesEnabled = false;
function $be691fe4208dbff9$export$748ada60eaf985cc(enable) {
    $be691fe4208dbff9$var$debugEnabled = enable;
}
function $be691fe4208dbff9$export$4f7017086af31c25(enable) {
    $be691fe4208dbff9$var$stacktracesEnabled = enable;
}
function $be691fe4208dbff9$export$2a858f450a2f66d() {
    if ($be691fe4208dbff9$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $be691fe4208dbff9$export$2e2bcd8739ae039(msg, ...args) {
    if ($be691fe4208dbff9$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("6g80G", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $7155cf66fa379446$export$4529f10aed0950d4);
class $7155cf66fa379446$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}

});




parcelRegister("d5XfI", function(module, exports) {
$parcel$export(module.exports, "WithUploadCredentials", () => (parcelRequire("189PI")).WithUploadCredentials);

var $189PI = parcelRequire("189PI");

});
parcelRegister("189PI", function(module, exports) {
$parcel$export(module.exports, "WithUploadCredentials", () => $a9eaeb51833e53d5$export$3e1efba3d85149ea);

var $bSJIT = parcelRequire("bSJIT");

var $eNRmj = parcelRequire("eNRmj");

var $87QgR = parcelRequire("87QgR");
const $a9eaeb51833e53d5$var$credentialsAreValid = (credentials)=>{
    // We check that the credentials exist and they won't expire within the next 15 seconds to ensure they won't expire during the upload (most likely)
    const fifteenSecondsAfterNow = new Date().getTime() + 15000;
    return credentials.expiryEpoch > fifteenSecondsAfterNow;
};
const $a9eaeb51833e53d5$export$3e1efba3d85149ea = ({ portalId: portalId, requestId: requestId, children: children })=>{
    const credentialsRef = $bSJIT.useRef(null);
    const lastFetchedPortalIdRef = $bSJIT.useRef(portalId);
    const lastFetchedRequestIdRef = $bSJIT.useRef(requestId);
    const getCredentials = $bSJIT.useCallback(async ()=>{
        // If we haven't fetched credentials or they're no longer valid, update them
        if (!credentialsRef.current || !$a9eaeb51833e53d5$var$credentialsAreValid(credentialsRef.current) || lastFetchedPortalIdRef.current !== portalId || lastFetchedRequestIdRef.current !== requestId) {
            lastFetchedPortalIdRef.current = portalId;
            lastFetchedRequestIdRef.current = requestId;
            if ((0, $87QgR.default).checkGate('request_create_inline_attachment') && !requestId) {
                credentialsRef.current = await (0, $eNRmj.getCredentialsForMediaRequest)(portalId);
                return credentialsRef.current;
            }
            // Request Id can be undefined but with removal of request_create_inline_attachment type casting can be removed
            credentialsRef.current = await (0, $eNRmj.getUploadCredentialsForRequest)(portalId, requestId);
        }
        return credentialsRef.current;
    }, [
        portalId,
        requestId
    ]);
    const getMediaProvider = $bSJIT.useCallback(async ()=>{
        const authProvider = async ()=>{
            const latestCredentials = await getCredentials();
            return {
                clientId: latestCredentials.clientId,
                token: latestCredentials.token,
                baseUrl: latestCredentials.endpointUrl
            };
        };
        const credentials = await getCredentials();
        return {
            uploadParams: {
                collection: credentials.targetCollection
            },
            viewMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
            },
            uploadMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
            }
        };
    }, [
        getCredentials
    ]);
    const mediaProviderPromise = $bSJIT.useMemo(()=>getMediaProvider(), [
        getMediaProvider
    ]);
    return children(mediaProviderPromise);
};

});


parcelRegister("4WMGM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7a2b4b916dba5fa$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7ys7E = parcelRequire("7ys7E");

var $d8zoL = parcelRequire("d8zoL");
class $c7a2b4b916dba5fa$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidUpdate() {
        if (this.props.isExpanded && (this.editorComponent || this.functionalEditor) && (!this.previouslyExpanded || this.previouslyExpanded === undefined)) {
            var _this$props$onExpand, _this$props;
            (_this$props$onExpand = (_this$props = this.props).onExpand) === null || _this$props$onExpand === void 0 || _this$props$onExpand.call(_this$props);
        }
        this.previouslyExpanded = this.props.isExpanded;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render() {
        const child = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(this.props.children);
        this.functionalEditor = typeof child.type === 'function';
        if (!this.props.isExpanded) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $d8zoL.IntlProviderIfMissingWrapper), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7ys7E.default), {
                onFocus: this.props.onFocus,
                text: this.props.placeholder,
                label: this.props.assistiveLabel
            })
        });
        // Let's avoid ref logic for functional Editor
        if (this.functionalEditor) return child;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(child, {
            ref: (editorComponent)=>this.handleEditorRef(editorComponent, child.ref)
        });
    }
    constructor(...args){
        super(...args), this.handleEditorRef = (editorRef, editorRefCallback)=>{
            if (editorRefCallback && typeof editorRefCallback === 'function') editorRefCallback(editorRef);
            this.editorComponent = editorRef;
        };
    }
}

});
parcelRegister("7ys7E", function(module, exports) {
$parcel$export(module.exports, "default", () => $1230c837fa23271e$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $iQoBb = parcelRequire("iQoBb");

var $6nVNk = parcelRequire("6nVNk");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1230c837fa23271e$var$ChromeCollapsed extends (0, $bSJIT.PureComponent) {
    render() {
        const placeholder = this.props.text || this.props.intl.formatMessage((0, $6nVNk.messages).chromeCollapsedPlaceholder);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iQoBb.ChromeCollapsedCompiled), {
            "data-testid": "chrome-collapsed",
            ref: this.handleInputRef,
            onFocus: this.focusHandler,
            placeholder: placeholder,
            "aria-label": this.props.label
        });
    }
    constructor(...args){
        super(...args), this.focusHandler = (evt)=>{
            /**
     * We need this magic for FireFox.
     * The reason we need it is, when, in FireFox, we have focus inside input,
     * and then we remove that input and move focus to another place programmatically,
     * for whatever reason UP/DOWN arrows don't work until you blur and focus editor manually.
     */ if (this.input) this.input.blur();
            if (this.props.onFocus) this.props.onFocus(evt);
        }, this.handleInputRef = (ref)=>{
            this.input = ref;
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $1230c837fa23271e$var$_default_1 = (0, $fK3tS.default)($1230c837fa23271e$var$ChromeCollapsed);
var $1230c837fa23271e$export$2e2bcd8739ae039 = $1230c837fa23271e$var$_default_1;

});
parcelRegister("iQoBb", function(module, exports) {
$parcel$export(module.exports, "ChromeCollapsedCompiled", () => $0dd8fb5abc9f0a51$export$217a642101384fe6);
/* ChromeCollapsed-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $0dd8fb5abc9f0a51$var$inputCompiledStyles = {
    root: "_19it19hj _2rkofajl _bfhk1j9a _vchhusvi _4t3i1ylp _19bvv47k _ca0qutpp _n3tdutpp _1wyboxwj _1bsb1osq _k48pi7a9 _vwz41aog _1dyzdjp5 _syaz1rpy _4cvxrsbi _irr3l4ek _d0al1kdv"
};
const $0dd8fb5abc9f0a51$export$217a642101384fe6 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(// eslint-disable-next-line react/jsx-props-no-spreading
({ ...rest }, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)("input", {
        ref: ref,
        ...rest,
        className: (0, $9fU1q.default)([
            $0dd8fb5abc9f0a51$var$inputCompiledStyles.root
        ])
    }));

});

parcelRegister("6nVNk", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c30757b04ac6fe37$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c30757b04ac6fe37$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    chromeCollapsedPlaceholder: {
        id: 'fabric.editor.chromeCollapsedPlaceholder',
        defaultMessage: "Type something\u2026",
        description: 'placeholder for an input where users insert text'
    }
});

});



parcelRegister("4ZoR6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b259aeb79eec0ae6$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $2iptY = parcelRequire("2iptY");

var $aKY64 = parcelRequire("aKY64");

var $8pcPC = parcelRequire("8pcPC");
const $b259aeb79eec0ae6$var$ComposableEditorWrapper = ({ props: props, initialPluginConfiguration: initialPluginConfiguration })=>{
    const preset = (0, $aKY64.default)({
        props: props,
        initialPluginConfiguration: initialPluginConfiguration
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $2iptY.ComposableEditor), {
        preset: preset,
        ...props
    });
};
class $b259aeb79eec0ae6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        appearance: 'comment',
        disabled: false,
        extensionHandlers: {},
        allowHelpDialog: true,
        quickInsert: true
    };
    constructor(props){
        super(props);
        (0, $8pcPC.default)(props);
    }
    render() {
        return /*#__PURE__*/ (0, $9dQre.jsx)($b259aeb79eec0ae6$var$ComposableEditorWrapper, {
            props: this.props,
            initialPluginConfiguration: this.props.initialPluginConfiguration
        });
    }
}

});
parcelRegister("8pcPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ed7f8b419fff187$export$2e2bcd8739ae039);
function $5ed7f8b419fff187$export$2e2bcd8739ae039(props) {
    return;
}

});


parcelRegister("6eumI", function(module, exports) {
$parcel$export(module.exports, "default", () => $595a0c4a96471381$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hclJ1 = parcelRequire("hclJ1");
class $595a0c4a96471381$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props);
    }
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $dc70d.jsx)($595a0c4a96471381$var$WithEditorActionsNew, {
            ...this.props
        });
    }
}
function $595a0c4a96471381$var$WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $hclJ1.EditorContext));
    return /*#__PURE__*/ (0, $dc70d.jsx)($595a0c4a96471381$var$WithEditorActionsInner, {
        render: render,
        editorActions: context === null || context === void 0 ? void 0 : context.editorActions
    });
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $595a0c4a96471381$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}

});



parcelRegister("lwnsx", function(module, exports) {
$parcel$export(module.exports, "default", () => $115c65a2fb6b5b6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $dhGpL = parcelRequire("dhGpL");

var $ceb9s = parcelRequire("ceb9s");
const $115c65a2fb6b5b6d$var$baseImageStyles = null;
function $115c65a2fb6b5b6d$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $bSJIT.useRef)(null);
    const providedColorMode = (0, $dhGpL.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $ceb9s.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $bSJIT.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("dhGpL", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $ccdf2dd4caece932$export$ce91654eb9fea460);

var $bSJIT = parcelRequire("bSJIT");

var $dqIYa = parcelRequire("dqIYa");
function $ccdf2dd4caece932$export$ce91654eb9fea460() {
    const value = (0, $bSJIT.useContext)((0, $dqIYa.ColorModeContext));
    return value;
}

});


parcelRegister("a7bUp", function(module, exports) {
$parcel$export(module.exports, "getATLContextDomain", () => $7a7a8451178540ac$export$b5ce351acdc48c2a);

var $72VHd = parcelRequire("72VHd");

var $lwmdR = parcelRequire("lwmdR");

var $4Wdcn = parcelRequire("4Wdcn");

var $frwpw = parcelRequire("frwpw");

var $jv51p = parcelRequire("jv51p");

var $YnnkN = parcelRequire("YnnkN");
function $7a7a8451178540ac$var$isValidDomainKey(domainKey) {
    if (!(0, $jv51p.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $7a7a8451178540ac$export$b5ce351acdc48c2a(domain, environment) {
    var _domainMap$perimeter;
    // Validate this is a valid domain
    if (!$7a7a8451178540ac$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $jv51p.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? (0, $YnnkN._getEnvironmentFromDomain)();
    // Second priority, return if there is a full domain override
    const override = (0, $4Wdcn.fullDomainOverride)[domain];
    if (override) {
        var _override$perimeter;
        return(// Exact match preferred
        ((_override$perimeter = override[perimeter]) === null || _override$perimeter === void 0 ? void 0 : _override$perimeter[env]) ?? override[0, $72VHd.COMMERCIAL][0, $72VHd.PRODUCTION] // Fallback to mandatory commercial production
        );
    }
    // Third priority, join the subdomain
    const tld = ((_domainMap$perimeter = (0, $lwmdR.domainMap)[perimeter]) === null || _domainMap$perimeter === void 0 ? void 0 : _domainMap$perimeter[env]) ?? (0, $lwmdR.domainMap)[0, $72VHd.COMMERCIAL][0, $72VHd.PRODUCTION];
    const subdomain = (0, $frwpw.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}

});
parcelRegister("lwmdR", function(module, exports) {
$parcel$export(module.exports, "domainMap", () => $0faadea1d94d06fb$export$6836b090dbaa813a);

var $72VHd = parcelRequire("72VHd");
const $0faadea1d94d06fb$export$6836b090dbaa813a = {
    [(0, $72VHd.COMMERCIAL)]: {
        [(0, $72VHd.STAGING)]: 'stg.atlassian.com',
        [(0, $72VHd.PRODUCTION)]: 'atlassian.com'
    },
    [(0, $72VHd.FEDRAMP_FEDEX)]: {
        [(0, $72VHd.STAGING)]: 'atlassian-fex.com'
    },
    [(0, $72VHd.FEDRAMP_MODERATE)]: {
        [(0, $72VHd.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $72VHd.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};

});

parcelRegister("4Wdcn", function(module, exports) {
$parcel$export(module.exports, "fullDomainOverride", () => $bdb75b9363679e20$export$4723232b625f823e);

var $72VHd = parcelRequire("72VHd");
const $bdb75b9363679e20$export$4723232b625f823e = {
    analytics: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'start.atlassian.com',
            [(0, $72VHd.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, $72VHd.FEDRAMP_MODERATE)]: {
            [(0, $72VHd.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, $72VHd.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'id.atlassian.com',
            [(0, $72VHd.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $72VHd.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $72VHd.FEDRAMP_MODERATE)]: {
            [(0, $72VHd.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $72VHd.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $72VHd.COMMERCIAL)]: {
            [(0, $72VHd.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("frwpw", function(module, exports) {
$parcel$export(module.exports, "subdomainOverride", () => $ba7ff9e4cb8e889a$export$c6ab20d0ac4d06b2);
const $ba7ff9e4cb8e889a$export$c6ab20d0ac4d06b2 = {};

});

parcelRegister("jv51p", function(module, exports) {
$parcel$export(module.exports, "AllowedDomains", () => $adb986798b62cfe4$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $adb986798b62cfe4$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});

parcelRegister("YnnkN", function(module, exports) {
$parcel$export(module.exports, "_getEnvironmentFromDomain", () => $0f391d615c023737$export$509d18a5fd824839);

var $72VHd = parcelRequire("72VHd");
function $0f391d615c023737$export$509d18a5fd824839() {
    var _globalThis$location;
    const hostname = (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $72VHd.PRODUCTION),
        (0, $72VHd.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $72VHd.STAGING),
        (0, $72VHd.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $72VHd.STAGING),
        (0, $72VHd.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $72VHd.STAGING),
        (0, $72VHd.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $72VHd.PRODUCTION),
        (0, $72VHd.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $72VHd.STAGING),
        (0, $72VHd.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $72VHd.STAGING),
        (0, $72VHd.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, $72VHd.PRODUCTION),
        (0, $72VHd.COMMERCIAL)
    ];
}

});


parcelRegister("f7uwJ", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $8f44d69b3fd92bcc$export$cf56d0f54cfcce4);

var $gdUUy = parcelRequire("gdUUy");

var $3aMs2 = parcelRequire("3aMs2");
const $8f44d69b3fd92bcc$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $3aMs2.componentWithCondition)(()=>(0, $gdUUy.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});

parcelRegister("iJ0mL", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $953a3a773ff7955a$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $953a3a773ff7955a$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}

});

parcelRegister("jKzBk", function(module, exports) {
$parcel$export(module.exports, "isolatedCloudDomain", () => $152c180f7661277f$export$80638ee198476daf);

var $5GrQ1 = parcelRequire("5GrQ1");
function $152c180f7661277f$export$80638ee198476daf() {
    if (typeof document === 'undefined') {
        var _globalThis$location;
        return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
    }
    const atlCtxCookieValues = (0, $5GrQ1.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}

});

parcelRegister("a6Zkp", function(module, exports) {
$parcel$export(module.exports, "useIsReducedMotion", () => $8fc5731ecb4f5753$export$c537e63161742ce3);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $4we3j = parcelRequire("4we3j");

var $iWZGm = parcelRequire("iWZGm");
const $8fc5731ecb4f5753$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $bSJIT.useState)((0, $iWZGm.isReducedMotion));
    (0, $bSJIT.useEffect)(()=>{
        if (!(0, $4we3j.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $bAB3U.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};

});

parcelRegister("kYRn0", function(module, exports) {
$parcel$export(module.exports, "extractClosestEdge", () => $91cdc3355cc4a56d$export$945a571f3b658bf);

var $3lYj5 = parcelRequire("3lYj5");
function $91cdc3355cc4a56d$export$945a571f3b658bf(userData) {
    return userData[0, $3lYj5.uniqueKey] ?? null;
}

});
parcelRegister("3lYj5", function(module, exports) {
$parcel$export(module.exports, "uniqueKey", () => $05ee9d887e7af126$export$4032e2468b38573b);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $iXLgr = parcelRequire("iXLgr");

var $kYRn0 = parcelRequire("kYRn0");
const $05ee9d887e7af126$export$4032e2468b38573b = Symbol('closestEdge');

});
parcelRegister("iXLgr", function(module, exports) {
$parcel$export(module.exports, "attachClosestEdge", () => $0f282c7071e10006$export$f0cafff222395e89);

var $3lYj5 = parcelRequire("3lYj5");
const $0f282c7071e10006$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
function $0f282c7071e10006$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    var _entries$sort$;
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $0f282c7071e10006$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = ((_entries$sort$ = entries.sort((a, b)=>a.value - b.value)[0]) === null || _entries$sort$ === void 0 ? void 0 : _entries$sort$.edge) ?? null;
    return {
        ...userData,
        [(0, $3lYj5.uniqueKey)]: addClosestEdge
    };
}

});



parcelRegister("3xrOF", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => $a18b78587ff68ec4$export$453c0582481cc59d);

var $bAB3U = parcelRequire("bAB3U");

var $lHuFH = parcelRequire("lHuFH");
function $a18b78587ff68ec4$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $a18b78587ff68ec4$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $a18b78587ff68ec4$var$start() {
    $a18b78587ff68ec4$var$cleanup();
    $a18b78587ff68ec4$var$unbindEvents = (0, $bAB3U.bindAll)(window, [
        {
            type: 'dragover',
            listener: $a18b78587ff68ec4$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $a18b78587ff68ec4$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $a18b78587ff68ec4$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $a18b78587ff68ec4$var$cleanup
        },
        ...(0, $lHuFH.getBindingsForBrokenDrags)({
            onDragEnd: $a18b78587ff68ec4$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $a18b78587ff68ec4$var$cleanup() {
    var _unbindEvents;
    (_unbindEvents = $a18b78587ff68ec4$var$unbindEvents) === null || _unbindEvents === void 0 || _unbindEvents();
    $a18b78587ff68ec4$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $a18b78587ff68ec4$var$stop() {
    var _window$event;
    /**
   * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
   * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
   * ("drop" events caused by dropping over a drop target)
   * `preventUnhandled()` causes every element to become a drop target (according to the browser)
   *
   * To opt out of the default behaviour for a `"drop"` event, we need to make sure
   * that we cancel it.
   *
   * The `"drop"` event listener in core is in the `capture` phase, so people calling
   * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
   * file before it has the chance to cancel the event.
   *
   * Being sneaky and using the `window.event` global to sniff out the current event
   */ if (((_window$event = window.event) === null || _window$event === void 0 ? void 0 : _window$event.type) === 'drop') {
        var _window$event2;
        (_window$event2 = window.event) === null || _window$event2 === void 0 || _window$event2.preventDefault();
    }
    $a18b78587ff68ec4$var$cleanup();
}
const $a18b78587ff68ec4$export$453c0582481cc59d = {
    start: $a18b78587ff68ec4$var$start,
    stop: $a18b78587ff68ec4$var$stop
};

});

parcelRegister("eVfoE", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => $aef2c58d60252b9b$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $aef2c58d60252b9b$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $aef2c58d60252b9b$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $aef2c58d60252b9b$var$tinyTransparentImage) nativeSetDragImage($aef2c58d60252b9b$var$tinyTransparentImage, 0, 0);
}

});

parcelRegister("583Mc", function(module, exports) {
$parcel$export(module.exports, "codeBlockButtonMessages", () => $ee3de2d14086b7a0$export$74e304339778e94d);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ee3de2d14086b7a0$export$74e304339778e94d = (0, $f0Pt4.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copyCodeSnippetToClipboard: {
        id: 'editor-common.messages.codeBlockButton.copyCodeSnippetToClipboard',
        defaultMessage: 'Copy code text',
        description: 'Copy the code text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Label for a toolbar button in the code block that enables line wrapping so long lines of code wrap to the next line instead of overflowing.'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Label for a toolbar button in the code block that disables line wrapping so long lines of code extend horizontally without breaking.'
    },
    wrapCodeLabel: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCode',
        defaultMessage: 'Wrap code',
        description: 'Tooltip for a code block toolbar button that turns on line wrapping. This is shown when code is not wrapped.'
    },
    unwrapCodeLabel: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCode',
        defaultMessage: 'Unwrap code',
        description: 'Tooltip for a code block toolbar button that turns off line wrapping. This is shown when code is wrapped.'
    },
    showLineNumbersLabel: {
        id: 'fabric.editor.codeBlockLineNumbersButton.showLineNumbers',
        defaultMessage: 'Show line numbers',
        description: 'Tooltip for a code block toolbar button that shows line numbers. This is shown when line numbers are hidden.'
    },
    hideLineNumbersLabel: {
        id: 'fabric.editor.codeBlockLineNumbersButton.hideLineNumbers',
        defaultMessage: 'Hide line numbers',
        description: 'Tooltip for a code block toolbar button that hides line numbers. This is shown when line numbers are visible.'
    },
    formatCode: {
        id: 'fabric.editor.codeBlockFormatButton.formatCode',
        defaultMessage: 'Format code',
        description: 'Tooltip for a code block toolbar button that formats code block content.'
    },
    formatCodeUnavailable: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeUnavailable',
        defaultMessage: 'Formatting not available for this language',
        description: 'Tooltip for a disabled code block toolbar button when formatting is not available for the selected language.'
    },
    formatCodeFailed: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeFailed',
        defaultMessage: 'Code formatting failed',
        description: 'Title for an error flag shown when code formatting fails.'
    },
    formatCodeFailedDescription: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeFailedDescription',
        defaultMessage: 'Review the content or change the selected language.',
        description: 'Description for an error flag shown when code formatting fails for a selected language.'
    },
    formatCodeFailedAutoDetectedDescription: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription',
        defaultMessage: 'Review the content or select a specific language.',
        description: 'Description for an error flag shown when code formatting fails for an automatically detected language.'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    },
    detectLanguage: {
        id: 'fabric.editor.codeBlock.detectLanguage',
        defaultMessage: 'Detect language',
        description: 'Option in the code block language picker that clears the selected language so the editor can detect it automatically.'
    },
    detectedLanguage: {
        id: 'fabric.editor.codeBlock.detectedLanguage',
        defaultMessage: '{language} (detected)',
        description: 'Label in the code block language picker trigger when the editor detected the code language. The language placeholder is the detected language name, such as JavaScript.'
    },
    noneDetected: {
        id: 'fabric.editor.codeBlock.noneDetected',
        defaultMessage: '(None detected)',
        description: 'Label in the code block language picker trigger when the editor could not detect a code language.'
    },
    recentlyUsed: {
        id: 'fabric.editor.codeBlock.recentlyUsed',
        defaultMessage: 'Recently used',
        description: 'Section heading for recently used languages in the code block language picker.'
    },
    all: {
        id: 'fabric.editor.codeBlock.all',
        defaultMessage: 'All',
        description: 'Section heading for all languages in the code block language picker.'
    },
    downloadCodeBlock: {
        id: 'fabric.editor.codeBlockDownloadButton.downloadCodeBlock',
        defaultMessage: 'Download',
        description: 'Download the content of the code block as a file'
    }
});

});

parcelRegister("c81bI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e792daab030bd512da02c59fc29db1c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d47274b3ad1fed4$var$_react = $8d47274b3ad1fed4$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8d47274b3ad1fed4$var$_iconNew = $8d47274b3ad1fed4$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8d47274b3ad1fed4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/copy
 * Usage guidance:
 * Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d47274b3ad1fed4$var$CopyIcon = (props)=>/*#__PURE__*/ $8d47274b3ad1fed4$var$_react.default.createElement($8d47274b3ad1fed4$var$_iconNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$8d47274b3ad1fed4$var$CopyIcon.displayName = 'CopyIcon';
var $8d47274b3ad1fed4$var$_default = module.exports.default = $8d47274b3ad1fed4$var$CopyIcon;

});

parcelRegister("5fP6U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb536940475a84529fdd1d2bdcae7e65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d35ffe99b0d3a23$var$_react = $3d35ffe99b0d3a23$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3d35ffe99b0d3a23$var$_iconNew = $3d35ffe99b0d3a23$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3d35ffe99b0d3a23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-wrap
 * Usage guidance:
 * Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d35ffe99b0d3a23$var$TextWrapIcon = (props)=>/*#__PURE__*/ $3d35ffe99b0d3a23$var$_react.default.createElement($3d35ffe99b0d3a23$var$_iconNew.default, Object.assign({
        name: "TextWrapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$3d35ffe99b0d3a23$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $3d35ffe99b0d3a23$var$_default = module.exports.default = $3d35ffe99b0d3a23$var$TextWrapIcon;

});

parcelRegister("jMMBQ", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $754f4addac459c11$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages
const $754f4addac459c11$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});

parcelRegister("85hX5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59407a4d31ae5eb9aed1a8c4f5bc83e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e2cb73fbe68c676$var$_react = $5e2cb73fbe68c676$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5e2cb73fbe68c676$var$_iconNew = $5e2cb73fbe68c676$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5e2cb73fbe68c676$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/checkbox-checked
 * Usage guidance:
 * Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e2cb73fbe68c676$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $5e2cb73fbe68c676$var$_react.default.createElement($5e2cb73fbe68c676$var$_iconNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$5e2cb73fbe68c676$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $5e2cb73fbe68c676$var$_default = module.exports.default = $5e2cb73fbe68c676$var$CheckboxCheckedIcon;

});

parcelRegister("92iMp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4fb5985ea59ca2817ccd54e91e2500f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6942de35fecde702$var$_react = $6942de35fecde702$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6942de35fecde702$var$_iconNew = $6942de35fecde702$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6942de35fecde702$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/decision
 * Usage guidance:
 * Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6942de35fecde702$var$DecisionIcon = (props)=>/*#__PURE__*/ $6942de35fecde702$var$_react.default.createElement($6942de35fecde702$var$_iconNew.default, Object.assign({
        name: "DecisionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$6942de35fecde702$var$DecisionIcon.displayName = 'DecisionIcon';
var $6942de35fecde702$var$_default = module.exports.default = $6942de35fecde702$var$DecisionIcon;

});

parcelRegister("cOmYT", function(module, exports) {
$parcel$export(module.exports, "timestampToUTCDate", () => $d3cd7f046d8c0eb9$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $d3cd7f046d8c0eb9$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $d3cd7f046d8c0eb9$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $d3cd7f046d8c0eb9$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $d3cd7f046d8c0eb9$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $d3cd7f046d8c0eb9$export$fbc04a9e57b04a80);

var $bAER0 = parcelRequire("bAER0");

var $aZpea = parcelRequire("aZpea");
var $d3cd7f046d8c0eb9$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($d3cd7f046d8c0eb9$var$FORMATS || {});
const $d3cd7f046d8c0eb9$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $d3cd7f046d8c0eb9$export$6297728405c48562 = (timeZone)=>{
    const today = new Date(Date.now());
    if (timeZone) {
        var _parts$find, _parts$find2, _parts$find3;
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(today);
        const year = Number((_parts$find = parts.find((p)=>p.type === 'year')) === null || _parts$find === void 0 ? void 0 : _parts$find.value);
        const month = Number((_parts$find2 = parts.find((p)=>p.type === 'month')) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value) - 1;
        const day = Number((_parts$find3 = parts.find((p)=>p.type === 'day')) === null || _parts$find3 === void 0 ? void 0 : _parts$find3.value);
        return Date.UTC(year, month, day).toString();
    }
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $d3cd7f046d8c0eb9$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $d3cd7f046d8c0eb9$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $d3cd7f046d8c0eb9$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $d3cd7f046d8c0eb9$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $d3cd7f046d8c0eb9$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$d3cd7f046d8c0eb9$var$addLeadingZero(date.getUTCMonth() + 1)}-${$d3cd7f046d8c0eb9$var$addLeadingZero(date.getUTCDate())}`;
};
const $d3cd7f046d8c0eb9$export$e6cc7bfc6e0e363e = (timestamp, timeZone)=>{
    return (0, $aZpea.default)(new Date(Number(timestamp)), new Date(Number($d3cd7f046d8c0eb9$export$6297728405c48562(timeZone))));
};
const $d3cd7f046d8c0eb9$export$fbc04a9e57b04a80 = (timestamp, intl, timeZone)=>{
    const curDate = new Date(Number($d3cd7f046d8c0eb9$export$6297728405c48562(timeZone)));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $bAER0.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $d3cd7f046d8c0eb9$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $d3cd7f046d8c0eb9$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});
parcelRegister("aZpea", function(module, exports) {
$parcel$export(module.exports, "default", () => $80032b8ed7e331a2$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $80032b8ed7e331a2$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $OPOsJ.default)(2, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var dateToCompare = (0, $897M5.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});


parcelRegister("asIyf", function(module, exports) {
$parcel$export(module.exports, "Status", () => $8b1d857dc49dac6c$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIbto = parcelRequire("kIbto");

var $1emO3 = parcelRequire("1emO3");

var $2bx1i = parcelRequire("2bx1i");

var $bbdYx = parcelRequire("bbdYx");

var $lKGUH = parcelRequire("lKGUH");
const $8b1d857dc49dac6c$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $8b1d857dc49dac6c$var$inlineBlockStyles = null;
// Bound the Lozenge to its parent while keeping short statuses content-sized.
const $8b1d857dc49dac6c$var$constrainedToParentStyles = null;
// eg. Version/4.0 Chrome/95.0.4638.50
const $8b1d857dc49dac6c$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $8b1d857dc49dac6c$var$StatusInternal extends (0, $bSJIT.PureComponent) {
    static #_ = this.displayName = 'StatusInternal';
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $lKGUH.getLozengeAppearance)(color);
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $bSJIT.createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9fU1q.default)([
                $8b1d857dc49dac6c$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                isConstrainedToParent && "_1e0c1o8l _p12f1osq",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $lKGUH.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1emO3.default), {
            appearance: appearance,
            maxWidth: $8b1d857dc49dac6c$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $bbdYx.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        }, this.handleKeyDown = (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        }, this.handleFocus = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleBlur = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $bbdYx.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $8b1d857dc49dac6c$export$96e9906d6d93a972 = (0, $kIbto.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $2bx1i.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $2bx1i.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($8b1d857dc49dac6c$var$StatusInternal);

});
parcelRegister("2bx1i", function(module, exports) {
$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $453cb797c6489118$export$aa98853957f9f5aa);
const $453cb797c6489118$export$d821aa4c8afb384e = 'fabric-elements';
const $453cb797c6489118$var$packageName = undefined;
const $453cb797c6489118$var$packageVersion = undefined;
const $453cb797c6489118$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $453cb797c6489118$var$packageName;
        statusPayload.attributes.packageVersion = $453cb797c6489118$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($453cb797c6489118$export$d821aa4c8afb384e);
        return event;
    };

});

parcelRegister("bbdYx", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_HOVER_DELAY", () => $3bc6b0160566f699$export$7452d7062a4d0634);
const $3bc6b0160566f699$export$7452d7062a4d0634 = 1000;

});

parcelRegister("lKGUH", function(module, exports) {
$parcel$export(module.exports, "SWATCH_ICON_COLOR", () => $78f4ae08a9ba0850$export$692279d423b4caab);
$parcel$export(module.exports, "COLORS", () => $78f4ae08a9ba0850$export$56d196d2844d1ca1);
$parcel$export(module.exports, "PICKER_SWATCHES", () => $78f4ae08a9ba0850$export$d42d7c94d7629c23);
$parcel$export(module.exports, "normalizeColor", () => $78f4ae08a9ba0850$export$4cde5df63f53f473);
$parcel$export(module.exports, "getColorLabelKey", () => $78f4ae08a9ba0850$export$4bc90a066e1dabc3);
$parcel$export(module.exports, "isSwatchSelected", () => $78f4ae08a9ba0850$export$13752f03fbf881b8);
$parcel$export(module.exports, "getLozengeAppearance", () => $78f4ae08a9ba0850$export$4d9e331cafeacb9d);

var $3zzvD = parcelRequire("3zzvD");
const $78f4ae08a9ba0850$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $78f4ae08a9ba0850$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $78f4ae08a9ba0850$export$acfdfc8c64e6747 = 'neutral';
const $78f4ae08a9ba0850$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $78f4ae08a9ba0850$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $78f4ae08a9ba0850$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $78f4ae08a9ba0850$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $78f4ae08a9ba0850$export$ee5a21461d1db57c = (color)=>$78f4ae08a9ba0850$export$c6adb6b4e776f0d5.includes(color);
const $78f4ae08a9ba0850$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $78f4ae08a9ba0850$var$specFor = (color)=>$78f4ae08a9ba0850$export$56d196d2844d1ca1[$78f4ae08a9ba0850$export$4cde5df63f53f473(color)];
const $78f4ae08a9ba0850$export$4bc90a066e1dabc3 = (color)=>{
    var _specFor;
    return ((_specFor = $78f4ae08a9ba0850$var$specFor(color)) === null || _specFor === void 0 ? void 0 : _specFor.labelKey) ?? 'neutralColor';
};
const $78f4ae08a9ba0850$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    var _specFor2, _specFor3;
    if (!selectedColor) return false;
    if ($78f4ae08a9ba0850$export$4cde5df63f53f473(swatchValue) === $78f4ae08a9ba0850$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = (_specFor2 = $78f4ae08a9ba0850$var$specFor(swatchValue)) === null || _specFor2 === void 0 ? void 0 : _specFor2.appearance;
    return swatchAppearance !== undefined && swatchAppearance === ((_specFor3 = $78f4ae08a9ba0850$var$specFor(selectedColor)) === null || _specFor3 === void 0 ? void 0 : _specFor3.appearance);
};
const $78f4ae08a9ba0850$export$4d9e331cafeacb9d = (color)=>{
    var _specFor4;
    const isUpdateStatusColorsEnabled = (0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    // Named colours are recoloured only by the experiment, so they must never reach the
    // hex mapping below.
    if ($78f4ae08a9ba0850$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $78f4ae08a9ba0850$export$56d196d2844d1ca1[color].appearance : $78f4ae08a9ba0850$export$645e10b5a408e986[color];
    return ((_specFor4 = $78f4ae08a9ba0850$var$specFor(color)) === null || _specFor4 === void 0 ? void 0 : _specFor4.appearance) ?? $78f4ae08a9ba0850$export$acfdfc8c64e6747;
};

});


parcelRegister("rL8kb", function(module, exports) {
$parcel$export(module.exports, "getEmojiCustomFallback", () => $b83c0ae587eb93ce$export$e6e9c38db7e6b0b1);

var $j7bkr = parcelRequire("j7bkr");
function $b83c0ae587eb93ce$export$e6e9c38db7e6b0b1(fallbackText) {
    return (0, $j7bkr.isSingleEmoji)(fallbackText) ? undefined : '\uFFFD';
}

});
parcelRegister("j7bkr", function(module, exports) {
$parcel$export(module.exports, "isSingleEmoji", () => $92d4d4d9fa7613ca$export$1d677781db73ff20);
const $92d4d4d9fa7613ca$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
/^(\p{Emoji_Presentation}(?:[\u{1F3FB}-\u{1F3FF}])?|\p{Extended_Pictographic}\u{FE0F}(?:[\u{1F3FB}-\u{1F3FF}])?(?:\u{200D}\p{Extended_Pictographic}\u{FE0F}?(?:[\u{1F3FB}-\u{1F3FF}])?)*|\p{Extended_Pictographic}\u{FE0F}?(?:[\u{1F3FB}-\u{1F3FF}])?(?:\u{200D}\p{Extended_Pictographic}\u{FE0F}?(?:[\u{1F3FB}-\u{1F3FF}])?)+|\p{Regional_Indicator}\p{Regional_Indicator})$/u;
function $92d4d4d9fa7613ca$export$1d677781db73ff20(fallbackText) {
    return $92d4d4d9fa7613ca$var$SINGLE_EMOJI_REGEX.test(fallbackText ?? '');
}

});


parcelRegister("gfs9q", function(module, exports) {
$parcel$export(module.exports, "messages", () => $78c82c20dd9ce378$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $78c82c20dd9ce378$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    emojiNodeLabel: {
        id: 'fabric.emoji.label',
        defaultMessage: 'Emoji',
        description: 'Label to indicate emoji node to Screen reader users'
    }
});

});

parcelRegister("6AKcC", function(module, exports) {
$parcel$export(module.exports, "PanelErrorIcon", () => $3669086a91a6c467$export$76fa6c311f4e2871);
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $3669086a91a6c467$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $3669086a91a6c467$var$PanelErrorGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $3669086a91a6c467$export$76fa6c311f4e2871 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3669086a91a6c467$var$PanelErrorGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("5tPrE", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => $b6aac96b0cf9469d$export$2187dc2d495c3efc);
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $b6aac96b0cf9469d$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $b6aac96b0cf9469d$var$PanelInfoGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $b6aac96b0cf9469d$export$2187dc2d495c3efc = ({ label: label })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($b6aac96b0cf9469d$var$PanelInfoGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("8yPGx", function(module, exports) {
$parcel$export(module.exports, "PanelNoteIcon", () => $ab090a891bbd71ce$export$d4f894f0c3f0db6);
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $ab090a891bbd71ce$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $ab090a891bbd71ce$var$PanelNoteGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $ab090a891bbd71ce$export$d4f894f0c3f0db6 = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($ab090a891bbd71ce$var$PanelNoteGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("jmsFJ", function(module, exports) {
$parcel$export(module.exports, "PanelSuccessIcon", () => $3646d91e281d3c7e$export$a5a5162e21242c3c);
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $3646d91e281d3c7e$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $3646d91e281d3c7e$var$PanelSuccessGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $3646d91e281d3c7e$export$a5a5162e21242c3c = ({ label: label })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3646d91e281d3c7e$var$PanelSuccessGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("3zmLN", function(module, exports) {
$parcel$export(module.exports, "PanelWarningIcon", () => $56ceb4c1a60a17f2$export$246c5468186717b7);
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $56ceb4c1a60a17f2$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $56ceb4c1a60a17f2$var$PanelWarningGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $56ceb4c1a60a17f2$export$246c5468186717b7 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($56ceb4c1a60a17f2$var$PanelWarningGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("9uOZB", function(module, exports) {
$parcel$export(module.exports, "PanelSharedCssClassName", () => $366a279298f470b7$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $366a279298f470b7$export$8099afddf1b1be78);

var $gAe8g = parcelRequire("gAe8g");

var $e4OZJ = parcelRequire("e4OZJ");
const $366a279298f470b7$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $366a279298f470b7$var$prefix = 'ak-editor-panel';
const $366a279298f470b7$export$6dd740b6c888e050 = {
    prefix: $366a279298f470b7$var$prefix,
    content: `${$366a279298f470b7$var$prefix}__content`,
    icon: `${$366a279298f470b7$var$prefix}__icon`,
    noIcon: `${$366a279298f470b7$var$prefix}__no-icon`
};
const $366a279298f470b7$export$b0ee08fae091706a = {
    infoPanel: `.${$366a279298f470b7$var$prefix}[data-panel-type=${(0, $gAe8g.PanelType).INFO}]`,
    notePanel: `.${$366a279298f470b7$var$prefix}[data-panel-type=${(0, $gAe8g.PanelType).NOTE}]`,
    warningPanel: `.${$366a279298f470b7$var$prefix}[data-panel-type=${(0, $gAe8g.PanelType).WARNING}]`,
    errorPanel: `.${$366a279298f470b7$var$prefix}[data-panel-type=${(0, $gAe8g.PanelType).ERROR}]`,
    successPanel: `.${$366a279298f470b7$var$prefix}[data-panel-type=${(0, $gAe8g.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[data-testid="popup-wrapper"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $366a279298f470b7$export$8099afddf1b1be78 = (panelType)=>$366a279298f470b7$var$lightPanelColors[panelType] || 'none';
const $366a279298f470b7$export$dd3f0fd482ae7ccc = (panelType)=>(0, $e4OZJ.hexToEditorBackgroundPaletteColor)($366a279298f470b7$var$lightPanelColors[panelType]) || 'none';

});

parcelRegister("9YTEJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::544012b3ed4fc4d2fd72613d04239f83>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7444e3c48051bd89$var$_react = $7444e3c48051bd89$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $7444e3c48051bd89$var$_iconNew = $7444e3c48051bd89$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $7444e3c48051bd89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji
 * Usage guidance:
 * Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7444e3c48051bd89$var$EmojiIcon = (props)=>/*#__PURE__*/ $7444e3c48051bd89$var$_react.default.createElement($7444e3c48051bd89$var$_iconNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$7444e3c48051bd89$var$EmojiIcon.displayName = 'EmojiIcon';
var $7444e3c48051bd89$var$_default = module.exports.default = $7444e3c48051bd89$var$EmojiIcon;

});

parcelRegister("6YN8G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a7325677fe98dd4eea44aa4b991818a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $514e76ad4db08950$var$_react = $514e76ad4db08950$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $514e76ad4db08950$var$_iconNew = $514e76ad4db08950$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $514e76ad4db08950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lightbulb
 * Usage guidance:
 * Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $514e76ad4db08950$var$LightbulbIcon = (props)=>/*#__PURE__*/ $514e76ad4db08950$var$_react.default.createElement($514e76ad4db08950$var$_iconNew.default, Object.assign({
        name: "LightbulbIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$514e76ad4db08950$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $514e76ad4db08950$var$_default = module.exports.default = $514e76ad4db08950$var$LightbulbIcon;

});

parcelRegister("1mebE", function(module, exports) {
$parcel$export(module.exports, "default", () => $42947a9c5f168370$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $2YfQG = parcelRequire("2YfQG");

var $5bbjm = parcelRequire("5bbjm");

var $gdUUy = parcelRequire("gdUUy");

var $dMuAK = parcelRequire("dMuAK");

var $29qUP = parcelRequire("29qUP");

var $b4Rwt = parcelRequire("b4Rwt");

var $bdpTj = parcelRequire("bdpTj");

var $4v4Uu = parcelRequire("4v4Uu");
function $42947a9c5f168370$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = (size === null || size === void 0 ? void 0 : size.widthType) === 'pixel';
    let mediaSingleWidth = (size === null || size === void 0 ? void 0 : size.width) || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $bdpTj.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $b4Rwt.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size === null || size === void 0 ? void 0 : size.widthType, (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $5bbjm.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH) - (0, $5bbjm.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100)) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $4v4Uu.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $gdUUy.fg)('media-perf-uplift-mutation-fix')
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": (size === null || size === void 0 ? void 0 : size.widthType) || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $dMuAK.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $4v4Uu.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("2YfQG", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("29qUP", function(module, exports) {
$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $1103bf951d859e59$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $1103bf951d859e59$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $1103bf951d859e59$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $1103bf951d859e59$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $1103bf951d859e59$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $1103bf951d859e59$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $1103bf951d859e59$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $1103bf951d859e59$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $1103bf951d859e59$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $1103bf951d859e59$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $1103bf951d859e59$export$b4b560efd3c61856);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $1103bf951d859e59$export$5937600f4cc784f0 = 24;
const $1103bf951d859e59$export$71d660e8ca5b8f73 = 320;
const $1103bf951d859e59$export$cd11d7d46412c89b = 3;
const $1103bf951d859e59$export$71482734bb54ac3 = 10;
const $1103bf951d859e59$export$fd2b09475ada41cc = 12;
const $1103bf951d859e59$export$8c5ac0b0c62a3d21 = 8;
const $1103bf951d859e59$export$68d0abe4f03863fb = $1103bf951d859e59$export$fd2b09475ada41cc * 2;
const $1103bf951d859e59$export$d722b7527b1834a8 = 250;
const $1103bf951d859e59$export$da894f7669b4e67c = 200;
const $1103bf951d859e59$export$e13825c38da2ce1 = 100;
var $1103bf951d859e59$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $1103bf951d859e59$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $1103bf951d859e59$export$4d41d008e9cd4f34 = 0.5;
const $1103bf951d859e59$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("b4Rwt", function(module, exports) {
$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $9eea3f15d1a56cdd$export$a6f4ec2edd25b07e);
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $9eea3f15d1a56cdd$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}

});

parcelRegister("bdpTj", function(module, exports) {
$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $7b3acc7dc5af54c6$export$7cd5aab2c4f1fb1e);

var $76GIX = parcelRequire("76GIX");
const $7b3acc7dc5af54c6$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $76GIX.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};

});
parcelRegister("76GIX", function(module, exports) {
$parcel$export(module.exports, "wrappedLayouts", () => $51a364bec35dbca1$export$405baca3d8bc263d);
const $51a364bec35dbca1$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];

});


parcelRegister("4v4Uu", function(module, exports) {
$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $9b81a8e972aa7020$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $9b81a8e972aa7020$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $9b81a8e972aa7020$export$e18e95249d813157);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");

var $6B1yf = parcelRequire("6B1yf");

var $bjG1c = parcelRequire("bjG1c");

var $cTnsM = parcelRequire("cTnsM");

var $jJddd = parcelRequire("jJddd");
function $9b81a8e972aa7020$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $9b81a8e972aa7020$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $9b81a8e972aa7020$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $5bbjm.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $5bbjm.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $5bbjm.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $9b81a8e972aa7020$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $5bbjm.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $5bbjm.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $5bbjm.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $9b81a8e972aa7020$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $bjG1c.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $bjG1c.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bjG1c.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $9b81a8e972aa7020$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $9b81a8e972aa7020$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $9b81a8e972aa7020$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $bjG1c.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $bjG1c.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $9b81a8e972aa7020$var$getWidthIfFullWidthMode(width, containerWidth) : $9b81a8e972aa7020$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $9b81a8e972aa7020$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $9b81a8e972aa7020$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $9b81a8e972aa7020$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $9b81a8e972aa7020$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $9b81a8e972aa7020$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $9b81a8e972aa7020$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $jJddd.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $cTnsM.calcResizedWidth)(layout, width || 0, containerWidth) : $9b81a8e972aa7020$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $9b81a8e972aa7020$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $9dQre.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $9b81a8e972aa7020$var$_ref2, " ", isInRenderer ? $9b81a8e972aa7020$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $6B1yf.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $9b81a8e972aa7020$var$float(layout), ";margin:", $9b81a8e972aa7020$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $6B1yf.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $9b81a8e972aa7020$var$isImageAligned(layout), ";");
};
const $9b81a8e972aa7020$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $9dQre.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $9b81a8e972aa7020$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $9dQre.css)("position:relative;", $9b81a8e972aa7020$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $9b81a8e972aa7020$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $9b81a8e972aa7020$export$9e3fd9f6215dd7b6(rest)
    }, children);
$9b81a8e972aa7020$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $9b81a8e972aa7020$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    const borderRadius = "var(--ds-radius-large, 8px)";
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};

});
parcelRegister("6B1yf", function(module, exports) {
$parcel$export(module.exports, "nonWrappedLayouts", () => $376ce788d91befdb$export$607795ead6e50626);
const $376ce788d91befdb$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];

});

parcelRegister("cTnsM", function(module, exports) {
$parcel$export(module.exports, "calcResizedWidth", () => $715dc75022e7ab8d$export$d48e8f24f681763e);

var $bjG1c = parcelRequire("bjG1c");
function $715dc75022e7ab8d$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $bjG1c.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bjG1c.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}

});

parcelRegister("jJddd", function(module, exports) {
$parcel$export(module.exports, "roundToClosestEvenPxValue", () => $f40b763b568f0dc6$export$c832331b07480714);
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $f40b763b568f0dc6$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}

});



parcelRegister("jdnVq", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => $7f76b621c00e437e$export$52d889c66db0f96e);

var $ejG4k = parcelRequire("ejG4k");

var $iyNC6 = parcelRequire("iyNC6");

var $iPkpW = parcelRequire("iPkpW");

var $VjcI7 = parcelRequire("VjcI7");

var $lLguj = parcelRequire("lLguj");
/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $7f76b621c00e437e$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $7f76b621c00e437e$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $7f76b621c00e437e$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $lLguj.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $lLguj.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $VjcI7.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $iPkpW.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $lLguj.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
   * Some frameworks (eg `react`) don't render into the container until the next microtask.
   * - This will run before the browser takes it's picture of the element
   * - This will run before the animation frame that removes `container`.
   * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
     * **Problem**
     * On `Safari@17.1` if a drag preview element has some opacity,
     * Safari will include elements behind the drag preview element
     * in the drag preview.
     * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
     *
     * **Fix**
     * We push the drag preview so it is _almost_ completely offscreen so that
     * there won't be any elements behind the drag preview element.
     * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
     *
     * Using `-0.0001` so that any potential "see through" on the drag preview element
     * is effectively invisible 👻
     *
     * **Unsuccessful alternatives**
     * Setting a background color (eg "white") on the `container`
     * → Wrecks the opacity of the drag preview element
     *
     * Adding a parent element of the `container` with a background color (eg "white")
     * → Wrecks the opacity of the drag preview element
     */ /**
     * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
     * We can remove it in a future release
     */ if ((0, $iyNC6.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage === null || nativeSetDragImage === void 0 || nativeSetDragImage(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount === null || unmount === void 0 || unmount();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $ejG4k.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});

parcelRegister("dETMy", function(module, exports) {
$parcel$export(module.exports, "Card", () => $d3908a2451a76fa3$export$60332b2344f7fe41);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $dTM5i = parcelRequire("dTM5i");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $2hVNZ = parcelRequire("2hVNZ");

var $ecTjf = parcelRequire("ecTjf");
class $d3908a2451a76fa3$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ecTjf.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
            locale: "en"
        }, content);
    }
}
const $d3908a2451a76fa3$export$60332b2344f7fe41 = (0, $2usNr.default)((0, $2hVNZ.context))((0, $kIbto.default)()((0, $fK3tS.default)($d3908a2451a76fa3$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("ecTjf", function(module, exports) {
$parcel$export(module.exports, "CardWithURLRenderer", () => $c12d5a494601b347$export$e00a7788e30dc998);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $7RHfd = parcelRequire("7RHfd");

var $gdUUy = parcelRequire("gdUUy");

var $2fwRK = parcelRequire("2fwRK");

var $iq8lm = parcelRequire("iq8lm");

var $jERMp = parcelRequire("jERMp");

var $LOjqb = parcelRequire("LOjqb");

var $7sj52 = parcelRequire("7sj52");

var $5seE2 = parcelRequire("5seE2");

var $9JG1z = parcelRequire("9JG1z");

var $83rwn = parcelRequire("83rwn");

var $1xHS2 = parcelRequire("1xHS2");

const $c12d5a494601b347$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(0, $9JG1z.importWithRetry)(()=>(parcelRequire("hrNqq"))));
function $c12d5a494601b347$export$e00a7788e30dc998(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $bSJIT.useState)(()=>props.id ? props.id : (0, $7RHfd.default)());
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $7sj52.clearMarks)(id);
            (0, $5seE2.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $83rwn.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $LOjqb.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $bSJIT.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $jERMp.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $iq8lm.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $iq8lm.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(FallbackComponent, null);
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring complete response.
    // Override appearance to 'block' for all FlexibleCards when FG is enabled.
    const effectiveAppearance = isFlexibleUi && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : appearance;
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: effectiveAppearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1xHS2.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($c12d5a494601b347$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}

});
parcelRegister("7sj52", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $4a0dccbd6ddd71e0$export$1a717feb4df1a945);

var $aRrJU = parcelRequire("aRrJU");
const $4a0dccbd6ddd71e0$export$1a717feb4df1a945 = (id)=>{
    if (0, $aRrJU.hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};

});

parcelRegister("5seE2", function(module, exports) {
$parcel$export(module.exports, "clearMeasures", () => $c95a763738f02d93$export$de42547d395c8271);

var $aRrJU = parcelRequire("aRrJU");
const $c95a763738f02d93$export$de42547d395c8271 = (id)=>{
    if (0, $aRrJU.hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};

});

parcelRegister("9JG1z", function(module, exports) {
$parcel$export(module.exports, "importWithRetry", () => $71e8d22abc4428a3$export$aacbf48ace518c5a);

var $fzEnh = parcelRequire("fzEnh");
const $71e8d22abc4428a3$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await (0, $fzEnh.sleep)(interval);
            return $71e8d22abc4428a3$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};

});
parcelRegister("fzEnh", function(module, exports) {
$parcel$export(module.exports, "sleep", () => $c8f7d00a9946e9e7$export$e772c8ff12451969);
const $c8f7d00a9946e9e7$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};

});


parcelRegister("hrNqq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9TfiK"),
    $kOunM("hxYvx"),
    $kOunM("2iKrl"),
    $kOunM("eo13b"),
    $kOunM("d3ovF"),
    $kOunM("1jZR6"),
    $kOunM("ef2p4"),
    $kOunM("2OWEg"),
    $kOunM("kTcCo"),
    $kOunM("9oDwW"),
    $kOunM("de818"),
    $kOunM("70W5u"),
    $kOunM("l1iNV"),
    $kOunM("4d2X7"),
    $kOunM("dVPBt"),
    $kOunM("hwIr9"),
    $kOunM("buGvX"),
    $kOunM("esjBs"),
    $kOunM("gsQwM"),
    $kOunM("ktLtf"),
    $kOunM("5jac6"),
    $kOunM("272yQ"),
    $kOunM("2wCFs"),
    $kOunM("8vIDD"),
    $kOunM("ivHaC")
]).then(()=>parcelRequire('49yhE'));

});



parcelRegister("9H9S7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd047031fc1ab3dc653f8f0d4a9b3992>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70efc98d623afa2c$var$_react = $70efc98d623afa2c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $70efc98d623afa2c$var$_iconNew = $70efc98d623afa2c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $70efc98d623afa2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-generative-text-summary
 * Usage guidance:
 * Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70efc98d623afa2c$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $70efc98d623afa2c$var$_react.default.createElement($70efc98d623afa2c$var$_iconNew.default, Object.assign({
        name: "AiGenerativeTextSummaryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 12.5V14H1v-1.5zm3.5-5.25v1.5H1v-1.5zM15 2v1.5H1V2zm-2.5 7a.75.75 0 0 1 .71.49l.61 1.69 1.69.62a.75.75 0 0 1 .49.7l-.01.12a.75.75 0 0 1-.48.59l-1.69.61-.61 1.69a.75.75 0 0 1-.59.48l-.12.01a.75.75 0 0 1-.7-.49l-.61-1.69-1.69-.61a.75.75 0 0 1-.48-.59L9 12.5a.75.75 0 0 1 .49-.7l1.69-.61.62-1.69a.75.75 0 0 1 .59-.48z"/>`
    }, props));
$70efc98d623afa2c$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $70efc98d623afa2c$var$_default = module.exports.default = $70efc98d623afa2c$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("3Vt8T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c19cab1662745293e5bf052395df909>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dbd4d077a551a40$var$_react = $2dbd4d077a551a40$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $2dbd4d077a551a40$var$_iconNew = $2dbd4d077a551a40$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $2dbd4d077a551a40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RovoChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/rovo-chat
 * Usage guidance:
 * Reserved for branded Rovo chat experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dbd4d077a551a40$var$RovoChatIcon = (props)=>/*#__PURE__*/ $2dbd4d077a551a40$var$_react.default.createElement($2dbd4d077a551a40$var$_iconNew.default, Object.assign({
        name: "RovoChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 3.125A2.625 2.625 0 0 1 2.625.5H8V2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125V8.5H16v2.875A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25z"/><path fill="currentcolor" d="M12.616.509a.75.75 0 0 1 .59.484l.613 1.687 1.688.615A.75.75 0 0 1 16 4l-.009.116a.75.75 0 0 1-.484.59l-1.688.613-.614 1.688a.75.75 0 0 1-.589.484L12.5 7.5a.75.75 0 0 1-.705-.493l-.615-1.688-1.687-.614a.75.75 0 0 1-.484-.589L9 4a.75.75 0 0 1 .493-.705l1.687-.615.615-1.687a.75.75 0 0 1 .589-.484L12.5.5z"/>`
    }, props));
$2dbd4d077a551a40$var$RovoChatIcon.displayName = 'RovoChatIcon';
var $2dbd4d077a551a40$var$_default = module.exports.default = $2dbd4d077a551a40$var$RovoChatIcon;

});

parcelRegister("fAjRj", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $5f1a931271985f4e$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4ebbb5ba469a9ff5e91d5204f2f881d>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $5f1a931271985f4e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $5f1a931271985f4e$export$e23ae35269442b4f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $5f1a931271985f4e$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9ucZp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4cbed98e1315ed66b53561d54056b7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e80fdd58f8a0073$var$_react = $6e80fdd58f8a0073$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6e80fdd58f8a0073$var$_iconNew = $6e80fdd58f8a0073$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6e80fdd58f8a0073$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/automation
 * Usage guidance:
 * Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e80fdd58f8a0073$var$AutomationIcon = (props)=>/*#__PURE__*/ $6e80fdd58f8a0073$var$_react.default.createElement($6e80fdd58f8a0073$var$_iconNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$6e80fdd58f8a0073$var$AutomationIcon.displayName = 'AutomationIcon';
var $6e80fdd58f8a0073$var$_default = module.exports.default = $6e80fdd58f8a0073$var$AutomationIcon;

});

parcelRegister("j7FKK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60d7e5eb448902fa99721011ff901f9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $debf0f0bdec4faaa$var$_react = $debf0f0bdec4faaa$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $debf0f0bdec4faaa$var$_iconNew = $debf0f0bdec4faaa$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $debf0f0bdec4faaa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-diagonal
 * Usage guidance:
 * Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $debf0f0bdec4faaa$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $debf0f0bdec4faaa$var$_react.default.createElement($debf0f0bdec4faaa$var$_iconNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$debf0f0bdec4faaa$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $debf0f0bdec4faaa$var$_default = module.exports.default = $debf0f0bdec4faaa$var$GrowDiagonalIcon;

});

parcelRegister("hpM3n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a7f4603a3394939adafb491e3ee704e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cada0be3f09f2f32$var$_react = $cada0be3f09f2f32$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cada0be3f09f2f32$var$_iconNew = $cada0be3f09f2f32$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cada0be3f09f2f32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/panel-right
 * Usage guidance:
 * Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cada0be3f09f2f32$var$PanelRightIcon = (props)=>/*#__PURE__*/ $cada0be3f09f2f32$var$_react.default.createElement($cada0be3f09f2f32$var$_iconNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.25 4a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 8.75 4z"/><path fill="currentcolor" fill-rule="evenodd" d="M14 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$cada0be3f09f2f32$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $cada0be3f09f2f32$var$_default = module.exports.default = $cada0be3f09f2f32$var$PanelRightIcon;

});

parcelRegister("87EHs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e9e8c548b7c6c82$var$_react = $5e9e8c548b7c6c82$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5e9e8c548b7c6c82$var$_iconNew = $5e9e8c548b7c6c82$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5e9e8c548b7c6c82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e9e8c548b7c6c82$var$ClockIcon = (props)=>/*#__PURE__*/ $5e9e8c548b7c6c82$var$_react.default.createElement($5e9e8c548b7c6c82$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$5e9e8c548b7c6c82$var$ClockIcon.displayName = 'ClockIcon';
var $5e9e8c548b7c6c82$var$_default = module.exports.default = $5e9e8c548b7c6c82$var$ClockIcon;

});

parcelRegister("ifdjD", function(module, exports) {
$parcel$export(module.exports, "getCurrentSiteCloudId", () => $7839f2f29108aec8$export$143af22820ae9de);

var $cSlyz = parcelRequire("cSlyz");
const $7839f2f29108aec8$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>(0, $cSlyz.currentSiteCloudIdService).get(baseUriWithNoTrailingSlash);

});
parcelRegister("cSlyz", function(module, exports) {
$parcel$export(module.exports, "currentSiteCloudIdService", () => $5e93f517eb2791b8$export$1956112846aa829e);

var $1nbxS = parcelRequire("1nbxS");

var $1JCSH = parcelRequire("1JCSH");
const $5e93f517eb2791b8$export$b4b75b5ce5d33ae5 = (0, $1JCSH.getCurrentSiteCloudIdLocalStorageKey)();
const $5e93f517eb2791b8$export$1956112846aa829e = new (0, $1nbxS.CurrentSiteCloudIdService)();

});
parcelRegister("1nbxS", function(module, exports) {
$parcel$export(module.exports, "CurrentSiteCloudIdService", () => $5dc383eeba36749c$export$a15da722a3b05509);

var $hYVMR = parcelRequire("hYVMR");

var $hyP0z = parcelRequire("hyP0z");

var $aRfYO = parcelRequire("aRfYO");

var $8lJR8 = parcelRequire("8lJR8");

var $3QMmL = parcelRequire("3QMmL");
const $5dc383eeba36749c$var$smartCardStorage = new (0, $hYVMR.StorageClient)((0, $8lJR8.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE);
class $5dc383eeba36749c$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $5dc383eeba36749c$var$smartCardStorage.getItem((0, $aRfYO.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $5dc383eeba36749c$var$smartCardStorage.setItemWithExpiry((0, $aRfYO.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash), cloudId, (0, $8lJR8.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_TTL_MS);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = (0, $3QMmL.normalizeBaseUri)(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $hyP0z.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response === null || response === void 0 ? void 0 : response.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}

});
parcelRegister("aRfYO", function(module, exports) {
$parcel$export(module.exports, "cloudIdStorageItemKey", () => $78ff159a6303b4d5$export$87f317e381996380);

var $8lJR8 = parcelRequire("8lJR8");

var $3QMmL = parcelRequire("3QMmL");
function $78ff159a6303b4d5$export$87f317e381996380(baseUriWithNoTrailingSlash = '') {
    return `${(0, $8lJR8.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent((0, $3QMmL.normalizeBaseUri)(baseUriWithNoTrailingSlash))}`;
}

});
parcelRegister("8lJR8", function(module, exports) {
$parcel$export(module.exports, "currentSiteCloudIdConstants", () => $8a8d20d40000a71a$export$a05eb2f7d4daba17);
const $8a8d20d40000a71a$export$a05eb2f7d4daba17 = {
    SMART_CARD_STORAGE_SCOPE: 'smart-card-social-proof',
    CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX: 'site-cloud-id:v1:',
    CURRENT_SITE_CLOUD_ID_TTL_MS: 86400000
};

});

parcelRegister("3QMmL", function(module, exports) {
$parcel$export(module.exports, "normalizeBaseUri", () => $156d8d62d933c013$export$d01aa4af38c023bb);
function $156d8d62d933c013$export$d01aa4af38c023bb(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}

});



parcelRegister("1JCSH", function(module, exports) {
$parcel$export(module.exports, "getCurrentSiteCloudIdLocalStorageKey", () => $11bbefa4763da85f$export$dea1a8bc5840f118);

var $aRfYO = parcelRequire("aRfYO");

var $8lJR8 = parcelRequire("8lJR8");
const $11bbefa4763da85f$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${(0, $8lJR8.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE}_${(0, $aRfYO.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash)}`;

});



parcelRegister("imwtU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe170e3e7b80264b949b54a1ecf34342>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5e37a3838d61ed5$var$_react = $d5e37a3838d61ed5$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d5e37a3838d61ed5$var$_iconNew = $d5e37a3838d61ed5$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d5e37a3838d61ed5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/angle-brackets
 * Usage guidance:
 * Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5e37a3838d61ed5$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $d5e37a3838d61ed5$var$_react.default.createElement($d5e37a3838d61ed5$var$_iconNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$d5e37a3838d61ed5$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $d5e37a3838d61ed5$var$_default = module.exports.default = $d5e37a3838d61ed5$var$AngleBracketsIcon;

});

parcelRegister("fEGwx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2d6fdb4f53040efa$export$2e2bcd8739ae039);

var $lwuFt = parcelRequire("lwuFt");

var $bMeS5 = parcelRequire("bMeS5");
// `grayBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `grayBold` directly with `gray`.
const $2d6fdb4f53040efa$var$FileIconWithColor = (0, $bMeS5.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), 'grayBold');
$2d6fdb4f53040efa$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $2d6fdb4f53040efa$export$2e2bcd8739ae039 = $2d6fdb4f53040efa$var$FileIconWithColor;

});
parcelRegister("lwuFt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2381f0cfc7f82e9041a16cf397e08d17>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab460208a85e275$var$_react = $fab460208a85e275$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $fab460208a85e275$var$_iconNew = $fab460208a85e275$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $fab460208a85e275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/file
 * Usage guidance:
 * Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab460208a85e275$var$FileIcon = (props)=>/*#__PURE__*/ $fab460208a85e275$var$_react.default.createElement($fab460208a85e275$var$_iconNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$fab460208a85e275$var$FileIcon.displayName = 'FileIcon';
var $fab460208a85e275$var$_default = module.exports.default = $fab460208a85e275$var$FileIcon;

});


parcelRegister("g6NyP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f608a9535844c97ef8ab19c5a3e36362>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bba3a69c0101ac85$var$_react = $bba3a69c0101ac85$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $bba3a69c0101ac85$var$_iconNew = $bba3a69c0101ac85$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $bba3a69c0101ac85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/image
 * Usage guidance:
 * Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bba3a69c0101ac85$var$ImageIcon = (props)=>/*#__PURE__*/ $bba3a69c0101ac85$var$_react.default.createElement($bba3a69c0101ac85$var$_iconNew.default, Object.assign({
        name: "ImageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$bba3a69c0101ac85$var$ImageIcon.displayName = 'ImageIcon';
var $bba3a69c0101ac85$var$_default = module.exports.default = $bba3a69c0101ac85$var$ImageIcon;

});

parcelRegister("fnYUT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $adab60d354a6b8a7$export$2e2bcd8739ae039);

var $fTN3Z = parcelRequire("fTN3Z");

var $bMeS5 = parcelRequire("bMeS5");
// `purpleBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `purpleBold` directly with `purple`.
const $adab60d354a6b8a7$var$ChartBarIconWithColor = (0, $bMeS5.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($fTN3Z))), 'purpleBold');
$adab60d354a6b8a7$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $adab60d354a6b8a7$export$2e2bcd8739ae039 = $adab60d354a6b8a7$var$ChartBarIconWithColor;

});
parcelRegister("fTN3Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d0e12c208abbb78a0f55c6c4c303feb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9320d0df4b41607$var$_react = $b9320d0df4b41607$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $b9320d0df4b41607$var$_iconNew = $b9320d0df4b41607$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $b9320d0df4b41607$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-bar
 * Usage guidance:
 * Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9320d0df4b41607$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b9320d0df4b41607$var$_react.default.createElement($b9320d0df4b41607$var$_iconNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$b9320d0df4b41607$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b9320d0df4b41607$var$_default = module.exports.default = $b9320d0df4b41607$var$ChartBarIcon;

});


parcelRegister("70tZA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8571dd8b0cc2c213$export$2e2bcd8739ae039);

var $kUZ0E = parcelRequire("kUZ0E");

var $bMeS5 = parcelRequire("bMeS5");
// `greenBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `greenBold` directly with `green`.
const $8571dd8b0cc2c213$var$ListBulletedIconWithColor = (0, $bMeS5.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), 'greenBold');
$8571dd8b0cc2c213$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $8571dd8b0cc2c213$export$2e2bcd8739ae039 = $8571dd8b0cc2c213$var$ListBulletedIconWithColor;

});
parcelRegister("kUZ0E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23389d96ad47534eee0427de6a1854fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3a85ccd67667dd7$var$_react = $f3a85ccd67667dd7$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f3a85ccd67667dd7$var$_iconNew = $f3a85ccd67667dd7$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f3a85ccd67667dd7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-bulleted
 * Usage guidance:
 * Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3a85ccd67667dd7$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $f3a85ccd67667dd7$var$_react.default.createElement($f3a85ccd67667dd7$var$_iconNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$f3a85ccd67667dd7$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $f3a85ccd67667dd7$var$_default = module.exports.default = $f3a85ccd67667dd7$var$ListBulletedIcon;

});


parcelRegister("3lVND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e827695d12a93239784734f306ed1225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27102b0786fc183c$var$_react = $27102b0786fc183c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $27102b0786fc183c$var$_iconNew = $27102b0786fc183c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $27102b0786fc183c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/people-group
 * Usage guidance:
 * Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27102b0786fc183c$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $27102b0786fc183c$var$_react.default.createElement($27102b0786fc183c$var$_iconNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$27102b0786fc183c$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $27102b0786fc183c$var$_default = module.exports.default = $27102b0786fc183c$var$PeopleGroupIcon;

});

parcelRegister("5PeKn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dee10bb7d40cfcc19f635db898b5b8fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43dd279e9f57b22e$var$_react = $43dd279e9f57b22e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $43dd279e9f57b22e$var$_iconNew = $43dd279e9f57b22e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $43dd279e9f57b22e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/attachment
 * Usage guidance:
 * Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43dd279e9f57b22e$var$AttachmentIcon = (props)=>/*#__PURE__*/ $43dd279e9f57b22e$var$_react.default.createElement($43dd279e9f57b22e$var$_iconNew.default, Object.assign({
        name: "AttachmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$43dd279e9f57b22e$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $43dd279e9f57b22e$var$_default = module.exports.default = $43dd279e9f57b22e$var$AttachmentIcon;

});

parcelRegister("4ujxi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::037384548dae3362b5016ccfe4fa350d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34491e3bbeba79fd$var$_react = $34491e3bbeba79fd$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $34491e3bbeba79fd$var$_iconNew = $34491e3bbeba79fd$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $34491e3bbeba79fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/task
 * Usage guidance:
 * Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34491e3bbeba79fd$var$TaskIcon = (props)=>/*#__PURE__*/ $34491e3bbeba79fd$var$_react.default.createElement($34491e3bbeba79fd$var$_iconNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34491e3bbeba79fd$var$TaskIcon.displayName = 'TaskIcon';
var $34491e3bbeba79fd$var$_default = module.exports.default = $34491e3bbeba79fd$var$TaskIcon;

});

parcelRegister("7j6fq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90fbd5da1cedf8ab72cfec6643bf73aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $551f276acbf284ed$var$_react = $551f276acbf284ed$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $551f276acbf284ed$var$_iconNew = $551f276acbf284ed$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $551f276acbf284ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/subtasks
 * Usage guidance:
 * Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $551f276acbf284ed$var$SubtasksIcon = (props)=>/*#__PURE__*/ $551f276acbf284ed$var$_react.default.createElement($551f276acbf284ed$var$_iconNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$551f276acbf284ed$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $551f276acbf284ed$var$_default = module.exports.default = $551f276acbf284ed$var$SubtasksIcon;

});

parcelRegister("96QwL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5b0eb0f949d78abc$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cMjTV = parcelRequire("cMjTV");

var $4ENS3 = parcelRequire("4ENS3");
function $5b0eb0f949d78abc$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMjTV))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("cMjTV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efe1ac521db6624f24d88867703638c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94d967aa3bda583d$var$_react = $94d967aa3bda583d$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $94d967aa3bda583d$var$_iconNew = $94d967aa3bda583d$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $94d967aa3bda583d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/branch
 * Usage guidance:
 * Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94d967aa3bda583d$var$BranchIcon = (props)=>/*#__PURE__*/ $94d967aa3bda583d$var$_react.default.createElement($94d967aa3bda583d$var$_iconNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$94d967aa3bda583d$var$BranchIcon.displayName = 'BranchIcon';
var $94d967aa3bda583d$var$_default = module.exports.default = $94d967aa3bda583d$var$BranchIcon;

});

parcelRegister("4ENS3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b78bd5eb1e99e088$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $b78bd5eb1e99e088$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});


parcelRegister("dP2AR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d823bf3c5760e191$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jCkxO = parcelRequire("jCkxO");

var $4VsjU = parcelRequire("4VsjU");
function $d823bf3c5760e191$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $jCkxO.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4VsjU.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("8Qale", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $89495f407391f580$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $2mB1C = parcelRequire("2mB1C");

var $4ENS3 = parcelRequire("4ENS3");
function $89495f407391f580$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2mB1C))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});
parcelRegister("2mB1C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4043daf294edfb6e9fedbae382cffb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b8a5b3ee77ab9d2$var$_react = $1b8a5b3ee77ab9d2$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $1b8a5b3ee77ab9d2$var$_iconNew = $1b8a5b3ee77ab9d2$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $1b8a5b3ee77ab9d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/commit
 * Usage guidance:
 * Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b8a5b3ee77ab9d2$var$CommitIcon = (props)=>/*#__PURE__*/ $1b8a5b3ee77ab9d2$var$_react.default.createElement($1b8a5b3ee77ab9d2$var$_iconNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$1b8a5b3ee77ab9d2$var$CommitIcon.displayName = 'CommitIcon';
var $1b8a5b3ee77ab9d2$var$_default = module.exports.default = $1b8a5b3ee77ab9d2$var$CommitIcon;

});


parcelRegister("2Lzug", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ea8909d2c1fa9021$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $lj1wZ = parcelRequire("lj1wZ");

var $4ENS3 = parcelRequire("4ENS3");
function $ea8909d2c1fa9021$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lj1wZ))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});
parcelRegister("lj1wZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e259fbb9cff618a518c8297911744c36>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f82c8f5fcad92809$var$_react = $f82c8f5fcad92809$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f82c8f5fcad92809$var$_iconNew = $f82c8f5fcad92809$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f82c8f5fcad92809$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pull-request
 * Usage guidance:
 * Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f82c8f5fcad92809$var$PullRequestIcon = (props)=>/*#__PURE__*/ $f82c8f5fcad92809$var$_react.default.createElement($f82c8f5fcad92809$var$_iconNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$f82c8f5fcad92809$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $f82c8f5fcad92809$var$_default = module.exports.default = $f82c8f5fcad92809$var$PullRequestIcon;

});


parcelRegister("5XnaM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f39fcc93b90910ea$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $imwtU = parcelRequire("imwtU");

var $4ENS3 = parcelRequire("4ENS3");
function $f39fcc93b90910ea$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($imwtU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("5GXrT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a340831178a178b6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ccTIL = parcelRequire("ccTIL");

var $4ENS3 = parcelRequire("4ENS3");
function $a340831178a178b6$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ccTIL))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("ccTIL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffd9ef1cff51ae8bc69ef502364c6257>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e31d411e5b56745$var$_react = $8e31d411e5b56745$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8e31d411e5b56745$var$_iconNew = $8e31d411e5b56745$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8e31d411e5b56745$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/bug
 * Usage guidance:
 * Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e31d411e5b56745$var$BugIcon = (props)=>/*#__PURE__*/ $8e31d411e5b56745$var$_react.default.createElement($8e31d411e5b56745$var$_iconNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$8e31d411e5b56745$var$BugIcon.displayName = 'BugIcon';
var $8e31d411e5b56745$var$_default = module.exports.default = $8e31d411e5b56745$var$BugIcon;

});


parcelRegister("fmxSi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f1435513d3c23ee6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $6KOKW = parcelRequire("6KOKW");

var $4ENS3 = parcelRequire("4ENS3");
function $f1435513d3c23ee6$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6KOKW))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});
parcelRegister("6KOKW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86e4cb0cec8e9e12166c70b4519c936c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4eae69139caf303a$var$_react = $4eae69139caf303a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4eae69139caf303a$var$_iconNew = $4eae69139caf303a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4eae69139caf303a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/changes
 * Usage guidance:
 * Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4eae69139caf303a$var$ChangesIcon = (props)=>/*#__PURE__*/ $4eae69139caf303a$var$_react.default.createElement($4eae69139caf303a$var$_iconNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$4eae69139caf303a$var$ChangesIcon.displayName = 'ChangesIcon';
var $4eae69139caf303a$var$_default = module.exports.default = $4eae69139caf303a$var$ChangesIcon;

});


parcelRegister("k0n7D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $281dd9e939f7f01a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $h6YPS = parcelRequire("h6YPS");

var $4ENS3 = parcelRequire("4ENS3");
function $281dd9e939f7f01a$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h6YPS))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});
parcelRegister("h6YPS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78c27fbf0b4dfca713ea16873edeb9da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7522fedf8a44f30$var$_react = $c7522fedf8a44f30$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c7522fedf8a44f30$var$_iconNew = $c7522fedf8a44f30$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c7522fedf8a44f30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/epic
 * Usage guidance:
 * Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7522fedf8a44f30$var$EpicIcon = (props)=>/*#__PURE__*/ $c7522fedf8a44f30$var$_react.default.createElement($c7522fedf8a44f30$var$_iconNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$c7522fedf8a44f30$var$EpicIcon.displayName = 'EpicIcon';
var $c7522fedf8a44f30$var$_default = module.exports.default = $c7522fedf8a44f30$var$EpicIcon;

});


parcelRegister("lQdGj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4bcc389ce3159538$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $icouc = parcelRequire("icouc");

var $4ENS3 = parcelRequire("4ENS3");
function $4bcc389ce3159538$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($icouc))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("icouc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::272e3b8843112479f54c710862304c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3fc576401a37019$var$_react = $d3fc576401a37019$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d3fc576401a37019$var$_iconNew = $d3fc576401a37019$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d3fc576401a37019$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/incident
 * Usage guidance:
 * Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3fc576401a37019$var$IncidentIcon = (props)=>/*#__PURE__*/ $d3fc576401a37019$var$_react.default.createElement($d3fc576401a37019$var$_iconNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$d3fc576401a37019$var$IncidentIcon.displayName = 'IncidentIcon';
var $d3fc576401a37019$var$_default = module.exports.default = $d3fc576401a37019$var$IncidentIcon;

});


parcelRegister("bF3dv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1410218a6b980a54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $2SnUZ = parcelRequire("2SnUZ");

var $4ENS3 = parcelRequire("4ENS3");
function $1410218a6b980a54$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2SnUZ))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("2SnUZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0e2f4aa13758d0bfd9dbdbb60ec6216>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21832d9109bf9752$var$_react = $21832d9109bf9752$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $21832d9109bf9752$var$_iconNew = $21832d9109bf9752$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $21832d9109bf9752$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/problem
 * Usage guidance:
 * Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21832d9109bf9752$var$ProblemIcon = (props)=>/*#__PURE__*/ $21832d9109bf9752$var$_react.default.createElement($21832d9109bf9752$var$_iconNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343A8 8 0 1 1 13.658 13.66 8 8 0 0 1 2.343 2.343m.562 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.692-.561a6.5 6.5 0 0 0-8.632-.5l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$21832d9109bf9752$var$ProblemIcon.displayName = 'ProblemIcon';
var $21832d9109bf9752$var$_default = module.exports.default = $21832d9109bf9752$var$ProblemIcon;

});


parcelRegister("24J67", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d0e1854144de04cb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $6tpTY = parcelRequire("6tpTY");

var $4ENS3 = parcelRequire("4ENS3");
function $d0e1854144de04cb$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6tpTY))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("6tpTY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c0c4ad146353612d795bc46242b9b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b698b110b5fbd63$var$_react = $4b698b110b5fbd63$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4b698b110b5fbd63$var$_iconNew = $4b698b110b5fbd63$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4b698b110b5fbd63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-item
 * Usage guidance:
 * Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b698b110b5fbd63$var$WorkItemIcon = (props)=>/*#__PURE__*/ $4b698b110b5fbd63$var$_react.default.createElement($4b698b110b5fbd63$var$_iconNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$4b698b110b5fbd63$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $4b698b110b5fbd63$var$_default = module.exports.default = $4b698b110b5fbd63$var$WorkItemIcon;

});


parcelRegister("f4EgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ab8be12877de7137$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3C6hN = parcelRequire("3C6hN");

var $4ENS3 = parcelRequire("4ENS3");
function $ab8be12877de7137$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3C6hN))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});
parcelRegister("3C6hN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e54e25b96851fc60bdb723a0652ff9cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a19cbf532d4351b$var$_react = $2a19cbf532d4351b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $2a19cbf532d4351b$var$_iconNew = $2a19cbf532d4351b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $2a19cbf532d4351b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/story
 * Usage guidance:
 * Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a19cbf532d4351b$var$StoryIcon = (props)=>/*#__PURE__*/ $2a19cbf532d4351b$var$_react.default.createElement($2a19cbf532d4351b$var$_iconNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$2a19cbf532d4351b$var$StoryIcon.displayName = 'StoryIcon';
var $2a19cbf532d4351b$var$_default = module.exports.default = $2a19cbf532d4351b$var$StoryIcon;

});


parcelRegister("fbMo8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $324010780599648c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7j6fq = parcelRequire("7j6fq");

var $4ENS3 = parcelRequire("4ENS3");
function $324010780599648c$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7j6fq))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("iLUhj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a4c0f76ed09084ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4ujxi = parcelRequire("4ujxi");

var $4ENS3 = parcelRequire("4ENS3");
function $a4c0f76ed09084ab$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ujxi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("5L1nf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $771f3b9f3257cb88$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jHVBL = parcelRequire("jHVBL");

var $4ENS3 = parcelRequire("4ENS3");
function $771f3b9f3257cb88$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jHVBL))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("jHVBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a997026dcaaf883b169150a2776c7ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e58eb83cfef61e5f$var$_react = $e58eb83cfef61e5f$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e58eb83cfef61e5f$var$_iconNew = $e58eb83cfef61e5f$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e58eb83cfef61e5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/quotation-mark
 * Usage guidance:
 * Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e58eb83cfef61e5f$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $e58eb83cfef61e5f$var$_react.default.createElement($e58eb83cfef61e5f$var$_iconNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$e58eb83cfef61e5f$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $e58eb83cfef61e5f$var$_default = module.exports.default = $e58eb83cfef61e5f$var$QuotationMarkIcon;

});


parcelRegister("7nxoy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e6225a934ec27d96$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jHVBL = parcelRequire("jHVBL");

var $dP2AR = parcelRequire("dP2AR");
function $e6225a934ec27d96$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dP2AR.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jHVBL))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("58h91", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7663c34cf6145416$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cM0zk = parcelRequire("cM0zk");

var $4ENS3 = parcelRequire("4ENS3");
function $7663c34cf6145416$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cM0zk))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});
parcelRegister("cM0zk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94ca68aa4b067e02$var$_react = $94ca68aa4b067e02$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $94ca68aa4b067e02$var$_iconNew = $94ca68aa4b067e02$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $94ca68aa4b067e02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94ca68aa4b067e02$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $94ca68aa4b067e02$var$_react.default.createElement($94ca68aa4b067e02$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$94ca68aa4b067e02$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $94ca68aa4b067e02$var$_default = module.exports.default = $94ca68aa4b067e02$var$PageLiveDocIcon;

});


parcelRegister("gv8eX", function(module, exports) {
$parcel$export(module.exports, "selectUnit", () => $c035eeec7c69d467$export$b8f7189986dd5395);
var $c035eeec7c69d467$var$__assign = undefined && undefined.__assign || function() {
    $c035eeec7c69d467$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c035eeec7c69d467$var$__assign.apply(this, arguments);
};
var $c035eeec7c69d467$var$MS_PER_SECOND = 1e3;
var $c035eeec7c69d467$var$SECS_PER_MIN = 60;
var $c035eeec7c69d467$var$SECS_PER_HOUR = $c035eeec7c69d467$var$SECS_PER_MIN * 60;
var $c035eeec7c69d467$var$SECS_PER_DAY = $c035eeec7c69d467$var$SECS_PER_HOUR * 24;
var $c035eeec7c69d467$var$SECS_PER_WEEK = $c035eeec7c69d467$var$SECS_PER_DAY * 7;
function $c035eeec7c69d467$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $c035eeec7c69d467$var$__assign($c035eeec7c69d467$var$__assign({}, $c035eeec7c69d467$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $c035eeec7c69d467$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $c035eeec7c69d467$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $c035eeec7c69d467$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $c035eeec7c69d467$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $c035eeec7c69d467$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $c035eeec7c69d467$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};

});

parcelRegister("iajVF", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $e85778b27383fe20$export$8a485e2e7ed91e8f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ceb9s = parcelRequire("ceb9s");

var $5FVII = parcelRequire("5FVII");

var $9QfUU = parcelRequire("9QfUU");

var $1ptKc = parcelRequire("1ptKc");
const $e85778b27383fe20$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $1ptKc.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $e85778b27383fe20$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $5FVII.defaultLogoParams).size, iconColor: iconColor = (0, $5FVII.defaultLogoParams).iconColor, textColor: textColor = (0, $5FVII.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9QfUU.default), {
        appearance: appearance,
        label: label,
        svg: $e85778b27383fe20$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("5FVII", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $579f97cf87f17b21$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $579f97cf87f17b21$export$793fba32aed8942a);
const $579f97cf87f17b21$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $579f97cf87f17b21$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("9QfUU", function(module, exports) {
$parcel$export(module.exports, "default", () => $681341283cd7169a$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $681341283cd7169a$var$CSS_VAR_COLOR = '--logo-color';
const $681341283cd7169a$var$CSS_VAR_FILL = '--logo-fill';
const $681341283cd7169a$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $681341283cd7169a$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": testId,
        style: {
            [$681341283cd7169a$var$CSS_VAR_COLOR]: iconColor,
            [$681341283cd7169a$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $9fU1q.default)([
            $681341283cd7169a$var$styles.root,
            shouldApplyStopColor && $681341283cd7169a$var$styles.stop,
            size && $681341283cd7169a$var$styles[size]
        ])
    });
};
var $681341283cd7169a$export$2e2bcd8739ae039 = $681341283cd7169a$var$Wrapper;

});

parcelRegister("1ptKc", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearance", () => $4c4b9c08f6b2e699$export$bbacc3980e0f3029);
const $4c4b9c08f6b2e699$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});


parcelRegister("bN9Su", function(module, exports) {
$parcel$export(module.exports, "getPreviewUrlWithEmbedContext", () => $f2cd1f4074bef9b4$export$736a7b9a8e50ca01);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $f2cd1f4074bef9b4$export$4470f298c61a79da);

var $kZ1cC = parcelRequire("kZ1cC");
const $f2cd1f4074bef9b4$export$736a7b9a8e50ca01 = (previewUrl, { hostProduct: hostProduct, themeState: themeState })=>{
    try {
        const url = new URL(previewUrl);
        if (themeState) url.searchParams.append('themeState', (0, $kZ1cC.themeObjectToString)(themeState));
        if (hostProduct) url.searchParams.set('hostProduct', hostProduct);
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $f2cd1f4074bef9b4$export$4470f298c61a79da = (previewUrl, themeState)=>$f2cd1f4074bef9b4$export$736a7b9a8e50ca01(previewUrl, {
        themeState: themeState
    });

});

parcelRegister("3H40Y", function(module, exports) {
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $571b41eabb063284$export$9b7e6a102056a387);
const $571b41eabb063284$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};

});

parcelRegister("akSvW", function(module, exports) {
$parcel$export(module.exports, "IFrame", () => $7e3ced49c5aef9de$export$b32b5f1ee4493319);

var $bSJIT = parcelRequire("bSJIT");

var $2HWse = parcelRequire("2HWse");

var $kNPcI = parcelRequire("kNPcI");

var $eSqdg = parcelRequire("eSqdg");
const $7e3ced49c5aef9de$var$LazyEmbeddedConfluencePage = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(0, $eSqdg.loadEmbeddedConfluencePage)().then((Page)=>({
            default: Page
        })));
const $7e3ced49c5aef9de$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $2HWse.useConfluencePageData)(props.src || '', extensionKey || '');
    const InjectedPage = (0, $kNPcI.useEmbeddedConfluencePage)();
    const Page = InjectedPage ?? $7e3ced49c5aef9de$var$LazyEmbeddedConfluencePage;
    const fallbackIframe = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: fallbackIframe
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Page, {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    })) : fallbackIframe;
};

});
parcelRegister("2HWse", function(module, exports) {
$parcel$export(module.exports, "useConfluencePageData", () => $fc283226bf268ec2$export$10fb2803bc7b79fc);

var $bSJIT = parcelRequire("bSJIT");

var $jddJj = parcelRequire("jddJj");

var $6pHJy = parcelRequire("6pHJy");
var $fc283226bf268ec2$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $fc283226bf268ec2$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $fc283226bf268ec2$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $fc283226bf268ec2$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $bSJIT.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($fc283226bf268ec2$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('hostname')) || '';
        const contentId = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('contentId')) || '';
        const spaceKey = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('spaceKey')) || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('themeState')) || '';
        const themeMode = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('themeMode');
        const enableInlineComments = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('enableInlineComments')) === 'true';
        const enablePageComments = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('enablePageComments')) === 'true';
        const userId = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('userId')) || '';
        const userIdType = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('userInfo')) || undefined;
        const parentProduct = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('parentProduct')) || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $6pHJy.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $bSJIT.useEffect)(()=>{
        if (parsedData !== null && parsedData !== void 0 && parsedData.themeStateObject) (0, $jddJj.setGlobalTheme)(parsedData.themeStateObject);
    }, [
        parsedData === null || parsedData === void 0 ? void 0 : parsedData.themeStateObject
    ]);
    return parsedData;
};

});

parcelRegister("kNPcI", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedConfluencePage", () => $338587184c0cb1e2$export$95a59d66783a54b3);

var $bSJIT = parcelRequire("bSJIT");
const $338587184c0cb1e2$var$EmbeddedConfluencePageContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $338587184c0cb1e2$export$542af7a009641f95 = $338587184c0cb1e2$var$EmbeddedConfluencePageContext.Provider;
const $338587184c0cb1e2$export$95a59d66783a54b3 = ()=>(0, $bSJIT.useContext)($338587184c0cb1e2$var$EmbeddedConfluencePageContext);

});

parcelRegister("eSqdg", function(module, exports) {
$parcel$export(module.exports, "loadEmbeddedConfluencePage", () => $35b15dc71bba4195$export$61cc2a15eefecd0b);
/**
 * Async factory for the Confluence embed `Page` component.
 *
 * Kept in its own module so `@atlaskit/embedded-confluence/page` is a dynamic
 * import only — hosts that never render a Confluence embed URL do not
 * download this chunk.
 */ 
async function $35b15dc71bba4195$export$61cc2a15eefecd0b() {
    const { Page: Page } = await (parcelRequire("hh1ZQ"));
    return Page;
}

});
parcelRegister("hh1ZQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("aHc5N"),
    $kOunM("bw2W2"),
    $kOunM("4Wxq5")
]).then(()=>parcelRequire('eGGdt'));

});



parcelRegister("92LrB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d917ba19410d867502f4eac87befeea4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69591a6021d3d3cd$var$_react = $69591a6021d3d3cd$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $69591a6021d3d3cd$var$_iconNew = $69591a6021d3d3cd$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $69591a6021d3d3cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-external
 * Usage guidance:
 * Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69591a6021d3d3cd$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $69591a6021d3d3cd$var$_react.default.createElement($69591a6021d3d3cd$var$_iconNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$69591a6021d3d3cd$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $69591a6021d3d3cd$var$_default = module.exports.default = $69591a6021d3d3cd$var$LinkExternalIcon;

});

parcelRegister("7oVIU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ead01486df0b1ba139b3dab1cc3c69d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56378cee6a4762ed$var$_react = $56378cee6a4762ed$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $56378cee6a4762ed$var$_iconNew = $56378cee6a4762ed$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $56378cee6a4762ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLink".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link
 * Usage guidance:
 * Reserved for representing Smart links.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56378cee6a4762ed$var$SmartLinkIcon = (props)=>/*#__PURE__*/ $56378cee6a4762ed$var$_react.default.createElement($56378cee6a4762ed$var$_iconNew.default, Object.assign({
        name: "SmartLinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.117 1.547a3.933 3.933 0 0 1 4.663 6.234l-2.25 2.25-1.06-1.061 2.25-2.25a2.432 2.432 0 0 0-2.604-3.986q.132.361.134.766a2.25 2.25 0 1 1-1.133-1.953M8 2.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 2.604 3.987 2.25 2.25 0 1 1 .998 1.187A3.933 3.933 0 0 1 2.22 8.22M8 11.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$56378cee6a4762ed$var$SmartLinkIcon.displayName = 'SmartLinkIcon';
var $56378cee6a4762ed$var$_default = module.exports.default = $56378cee6a4762ed$var$SmartLinkIcon;

});

parcelRegister("5OPcB", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $e6280d667fa60a02$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5c93f8ff183bcc446a98330515d8d99>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e6280d667fa60a02$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $e6280d667fa60a02$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $e6280d667fa60a02$export$5fc1066e677788d4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $e6280d667fa60a02$var$svg,
        customThemeSvg: $e6280d667fa60a02$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lR9hI", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $865c3a9c03adafe1$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8862141676163c22cf5b4279aef2ba3>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $865c3a9c03adafe1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $865c3a9c03adafe1$export$5ed3e1bb3b04fc02({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $865c3a9c03adafe1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d8PXx", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $f473be2a61f8d2de$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::054729aad56b6ee279fe5ea9583ae1d3>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $a1hMn = parcelRequire("a1hMn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f473be2a61f8d2de$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $f473be2a61f8d2de$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $f473be2a61f8d2de$export$4384da9b8b140bf4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1hMn.IconWrapper), {
        svg: $f473be2a61f8d2de$var$svg,
        customThemeSvg: $f473be2a61f8d2de$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Irvz", function(module, exports) {
$parcel$export(module.exports, "embedHeaderHeight", () => $6e3a68e541c96960$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "EmbedResizeMessageListener", () => $6e3a68e541c96960$export$3482036c37e627f4);

var $bSJIT = parcelRequire("bSJIT");
const $6e3a68e541c96960$export$8f5a73ba0d077b01 = 32;
class $6e3a68e541c96960$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        }, this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $6e3a68e541c96960$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}

});

parcelRegister("iOHZU", function(module, exports) {
$parcel$export(module.exports, "CardSSR", () => $f31fcb4f19cf74cd$export$7b5e1b7f9a325b6);

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $dwOcU = parcelRequire("dwOcU");

var $gdUUy = parcelRequire("gdUUy");

var $2hVNZ = parcelRequire("2hVNZ");

var $83rwn = parcelRequire("83rwn");

var $hKAVi = parcelRequire("hKAVi");

var $8l4nR = parcelRequire("8l4nR");
const $f31fcb4f19cf74cd$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $bSJIT.useState)(()=>props.id ?? (0, $7RHfd.default)());
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring a complete response.
    // Override appearance to 'block' for FlexibleCards when FG is enabled.
    const effectiveAppearance = (0, $83rwn.isFlexibleUiCard)(props.children, props.ui) && (0, $gdUUy.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : props.appearance;
    const propsWithId = {
        ...props,
        id: id,
        appearance: effectiveAppearance
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: (0, $2hVNZ.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hKAVi.default), propsWithId, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8l4nR.CardWithUrl), propsWithId)));
};

});
parcelRegister("hKAVi", function(module, exports) {
$parcel$export(module.exports, "default", () => $30f1fc98c4ed5422$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $1xHS2 = parcelRequire("1xHS2");
const $30f1fc98c4ed5422$var$CardErrorBoundary = ({ children: children, ...props })=>{
    // TODO: NAVX-4682: Add feature parity to CardWithURLRenderer
    const ErrorFallbackComponent = props.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1xHS2.LoadingCardLink), props);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, children);
};
var $30f1fc98c4ed5422$export$2e2bcd8739ae039 = $30f1fc98c4ed5422$var$CardErrorBoundary;

});


parcelRegister("8XENo", function(module, exports) {
$parcel$export(module.exports, "canRenderDatasource", () => $d2903224a2a17e7d$export$1974047c293dd52e);

var $1wpTP = parcelRequire("1wpTP");
const $d2903224a2a17e7d$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = (0, $1wpTP.getDatasourceType)(datasourceId);
    switch(datasourceType){
        case 'jira':
        case 'assets':
            return true;
        default:
            return defaultValue;
    }
};

});
parcelRegister("1wpTP", function(module, exports) {
$parcel$export(module.exports, "getDatasourceType", () => $021e893dfa9aa605$export$19af9860957ca153);

var $a2Ugg = parcelRequire("a2Ugg");

var $6yEAN = parcelRequire("6yEAN");

var $ka4gR = parcelRequire("ka4gR");
const $021e893dfa9aa605$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $ka4gR.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $a2Ugg.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $6yEAN.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};

});
parcelRegister("a2Ugg", function(module, exports) {
$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $f1e8b8c8bcba6124$export$34a6fbdd67f09ff6);

var $G916T = parcelRequire("G916T");
const $f1e8b8c8bcba6124$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';
var $f1e8b8c8bcba6124$export$2e2bcd8739ae039 = (0, $G916T.AssetsConfigModalWithWrappers);

});
parcelRegister("G916T", function(module, exports) {
$parcel$export(module.exports, "AssetsConfigModalWithWrappers", () => $864e88f2b4c5feb4$export$22622bb648794f66);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

const $864e88f2b4c5feb4$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("fE0dc")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $864e88f2b4c5feb4$export$22622bb648794f66 = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($864e88f2b4c5feb4$var$LazyAssetsConfigModal, {
            ...props
        })
    });
};

});
parcelRegister("fE0dc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fXeMz"),
    $kOunM("k93PB"),
    $kOunM("coIBk"),
    $kOunM("3dX2x"),
    $kOunM("itmHl"),
    $kOunM("ifhJn")
]).then(()=>parcelRequire('5cnrv'));

});



parcelRegister("6yEAN", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $fc7a56c5bcd5c173$export$d9788d6cf1867282);

var $7Vty7 = parcelRequire("7Vty7");
const $fc7a56c5bcd5c173$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';
var $fc7a56c5bcd5c173$export$2e2bcd8739ae039 = (0, $7Vty7.ConfluenceSearchConfigModalWithWrappers);

});
parcelRegister("7Vty7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSearchConfigModalWithWrappers", () => $6c03c4d900dfb510$export$354a4025961c00ab);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

const $6c03c4d900dfb510$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("1Y873")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $6c03c4d900dfb510$export$354a4025961c00ab = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($6c03c4d900dfb510$var$LazyConfluenceSearchConfigModal, {
            ...props
        })
    });
};

});
parcelRegister("1Y873", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("1C6c6"),
    $kOunM("gng0x"),
    $kOunM("bcBIK"),
    $kOunM("fXeMz"),
    $kOunM("k93PB"),
    $kOunM("coIBk"),
    $kOunM("3dX2x"),
    $kOunM("itmHl"),
    $kOunM("6AJh5")
]).then(()=>parcelRequire('559QK'));

});



parcelRegister("ka4gR", function(module, exports) {
$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $4090f2a155c43a45$export$8ce19958117ece5c);

var $8jcko = parcelRequire("8jcko");
const $4090f2a155c43a45$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';
var $4090f2a155c43a45$export$2e2bcd8739ae039 = (0, $8jcko.JiraIssuesConfigModalWithWrappers);

});
parcelRegister("8jcko", function(module, exports) {
$parcel$export(module.exports, "JiraIssuesConfigModalWithWrappers", () => $e6c93eb72bc82a6b$export$1cd9f81ef4050ddb);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

const $e6c93eb72bc82a6b$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("3mL1G")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $e6c93eb72bc82a6b$export$1cd9f81ef4050ddb = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-testid": 'jira-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($e6c93eb72bc82a6b$var$LazyJiraIssuesConfigModal, {
            ...props
        })
    });
};

});
parcelRegister("3mL1G", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("hZ8jy"),
    $kOunM("ls6Rv"),
    $kOunM("8olLW"),
    $kOunM("h0IiQ"),
    $kOunM("eScBj"),
    $kOunM("aI0tF"),
    $kOunM("2Tbxw"),
    $kOunM("lwsFR"),
    $kOunM("jnLeB"),
    $kOunM("5eLG8"),
    $kOunM("iZJsN"),
    $kOunM("eTibs"),
    $kOunM("bcBIK"),
    $kOunM("fXeMz"),
    $kOunM("k93PB"),
    $kOunM("coIBk"),
    $kOunM("3dX2x"),
    $kOunM("6QYMh"),
    $kOunM("kwMqK"),
    $kOunM("itmHl"),
    $kOunM("8L9qK")
]).then(()=>parcelRequire('9xMXp'));

});





parcelRegister("jqvxO", function(module, exports) {
$parcel$export(module.exports, "buildDatasourceAdf", () => $722c3c26872087ed$export$1de3504963fc32f2);
const $722c3c26872087ed$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};

});

parcelRegister("jX24c", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", () => $9335311611a725ac$export$5e074c0b68e2ce03);
$parcel$export(module.exports, "useDatasourceClientExtension", () => $9335311611a725ac$export$7d812bb756889442);

var $bSJIT = parcelRequire("bSJIT");

var $5j6lg = parcelRequire("5j6lg");

var $6bOBo = parcelRequire("6bOBo");

var $hyP0z = parcelRequire("hyP0z");

var $59hb7 = parcelRequire("59hb7");
const $9335311611a725ac$var$URL_RESPONSE_CACHE_SIZE = 50;
const $9335311611a725ac$export$f82fcd766a8daa7f = new (0, $5j6lg.LRUMap)($9335311611a725ac$var$URL_RESPONSE_CACHE_SIZE);
const $9335311611a725ac$export$40b1dd31340bd5c2 = new (0, $5j6lg.LRUMap)($9335311611a725ac$var$URL_RESPONSE_CACHE_SIZE);
const $9335311611a725ac$export$15cd58682efec5a5 = new (0, $5j6lg.LRUMap)($9335311611a725ac$var$URL_RESPONSE_CACHE_SIZE);
const $9335311611a725ac$export$5e074c0b68e2ce03 = 20;
const $9335311611a725ac$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $6bOBo.useSmartLinkContext)();
    const resolverUrl = (0, $59hb7.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $hyP0z.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $hyP0z.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $bSJIT.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $9335311611a725ac$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $bSJIT.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $9335311611a725ac$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $bSJIT.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $9335311611a725ac$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $bSJIT.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $bSJIT.useCallback)((ari)=>{
        $9335311611a725ac$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                var _item$ari;
                return ((_item$ari = item['ari']) === null || _item$ari === void 0 ? void 0 : _item$ari.data) === ari;
            });
            if (targetFound) $9335311611a725ac$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $bSJIT.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};

});

parcelRegister("udzoQ", function(module, exports) {
$parcel$export(module.exports, "mergeStyles", () => $cbcfb2125af51b5b$export$e618dc39ac9ad607);
function $cbcfb2125af51b5b$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("jMnqZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1dc8de20280b4683a2b844103e1b1c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e664ad9ab344a8d4$var$_react = $e664ad9ab344a8d4$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e664ad9ab344a8d4$var$_iconNew = $e664ad9ab344a8d4$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e664ad9ab344a8d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-columns-distribute
 * Usage guidance:
 * Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e664ad9ab344a8d4$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $e664ad9ab344a8d4$var$_react.default.createElement($e664ad9ab344a8d4$var$_iconNew.default, Object.assign({
        name: "TableColumnsDistributeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$e664ad9ab344a8d4$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $e664ad9ab344a8d4$var$_default = module.exports.default = $e664ad9ab344a8d4$var$TableColumnsDistributeIcon;

});

parcelRegister("lthDJ", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $50e71806477b7945$export$62ed72bc21f6b8a6);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $eDC06 = parcelRequire("eDC06");

var $dTESn = parcelRequire("dTESn");
function $50e71806477b7945$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eDC06.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $dTESn.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$50e71806477b7945$export$2e2bcd8739ae039 = $50e71806477b7945$export$62ed72bc21f6b8a6;

});
parcelRegister("eDC06", function(module, exports) {
$parcel$export(module.exports, "Line", () => $e74c3e5c37c5bf4f$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $dTESn = parcelRequire("dTESn");
const $e74c3e5c37c5bf4f$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $e74c3e5c37c5bf4f$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $e74c3e5c37c5bf4f$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $e74c3e5c37c5bf4f$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $e74c3e5c37c5bf4f$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $e74c3e5c37c5bf4f$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $dTESn.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $dTESn.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $e74c3e5c37c5bf4f$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $e74c3e5c37c5bf4f$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $9fU1q.default)([
            $e74c3e5c37c5bf4f$var$baseStyles.root,
            $e74c3e5c37c5bf4f$var$orientationStyles[orientation],
            $e74c3e5c37c5bf4f$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e74c3e5c37c5bf4f$export$2e2bcd8739ae039 = $e74c3e5c37c5bf4f$export$17d680238e50603e;

});
parcelRegister("dTESn", function(module, exports) {
$parcel$export(module.exports, "presetStrokeColors", () => $4f61ee599d5f60aa$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $4f61ee599d5f60aa$export$45db03aa04b685e3);
const $4f61ee599d5f60aa$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4f61ee599d5f60aa$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";

});



parcelRegister("1emwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e58924c85879528$export$2e2bcd8739ae039);

var $cPnJw = parcelRequire("cPnJw");

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $0e58924c85879528$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $OPOsJ.default)(2, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var amount = (0, $cPnJw.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("8CjxI", function(module, exports) {
$parcel$export(module.exports, "default", () => $6461082416317552$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $6461082416317552$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("6e6mu", function(module, exports) {
$parcel$export(module.exports, "default", () => $4888fc2b243053f9$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $8CjxI = parcelRequire("8CjxI");

var $2Reo5 = parcelRequire("2Reo5");

var $OPOsJ = parcelRequire("OPOsJ");
function $4888fc2b243053f9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    return (0, $8CjxI.default)(date).getTime() === (0, $2Reo5.default)(date).getTime();
}

});
parcelRegister("2Reo5", function(module, exports) {
$parcel$export(module.exports, "default", () => $214bb10f1207fa91$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $214bb10f1207fa91$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});


parcelRegister("7hBaz", function(module, exports) {
$parcel$export(module.exports, "default", () => $54d6f40691757d42$export$2e2bcd8739ae039);

var $4R2QU = parcelRequire("4R2QU");

var $OPOsJ = parcelRequire("OPOsJ");
function $54d6f40691757d42$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $OPOsJ.default)(2, arguments);
    var dateLeftStartOfDay = (0, $4R2QU.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $4R2QU.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("bxzRa", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkDestinationUrl", () => $73fb3ba3606447fe$export$30500dfe8339eafd);

var $6Wkby = parcelRequire("6Wkby");

var $2TtjQ = parcelRequire("2TtjQ");

var $7jLk8 = parcelRequire("7jLk8");
/**
 * Returns the resolved destination URL for a Smart Link, with cross-product analytics
 * parameters appended when applicable.
 *
 * This is the same URL that SmartCard would navigate to when clicked. Use this as an `href`
 * wherever you render a link to a Smart Link URL outside of the SmartCard component itself
 * (e.g. toolbar buttons, overlays).
 *
 * Falls back to the raw `url` when:
 * - The link has not yet resolved
 * - The link is not a first-party Atlassian link
 *
 * @example
 * const href = useSmartLinkDestinationUrl(url);
 *
 * Use as <a href={href} target="_blank">Open link</a>
 */ const $73fb3ba3606447fe$export$30500dfe8339eafd = (url)=>{
    const state = (0, $2TtjQ.useSmartCardState)(url);
    const appendCrossProductAnalyticsParams = (0, $7jLk8.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const resolvedUrl = (0, $6Wkby.getClickUrl)(url, state.details);
    return appendCrossProductAnalyticsParams(resolvedUrl);
};

});

parcelRegister("lPSjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdcfaadd200b1558cd21a6be22e04743>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe587ef1109f0ffe$var$_react = $fe587ef1109f0ffe$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $fe587ef1109f0ffe$var$_iconNew = $fe587ef1109f0ffe$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $fe587ef1109f0ffe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe587ef1109f0ffe$var$CalendarIcon = (props)=>/*#__PURE__*/ $fe587ef1109f0ffe$var$_react.default.createElement($fe587ef1109f0ffe$var$_iconNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$fe587ef1109f0ffe$var$CalendarIcon.displayName = 'CalendarIcon';
var $fe587ef1109f0ffe$var$_default = module.exports.default = $fe587ef1109f0ffe$var$CalendarIcon;

});

parcelRegister("7q8Sl", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $f43436c87ad73102$export$ea56ca58f08ffa52);

var $l8vXm = parcelRequire("l8vXm");

var $h8Z36 = parcelRequire("h8Z36");

var $9AtYB = parcelRequire("9AtYB");

var $d99bn = parcelRequire("d99bn");
const $f43436c87ad73102$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $l8vXm.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>getDays(weekStartDay, 'short');
    const getDaysLong = (weekStartDay = 0)=>getDays(weekStartDay, 'long');
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $h8Z36.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $d99bn.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $d99bn.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    let intlLocale;
    const getFirstDayOfWeek = ()=>{
        if (!intlLocale) intlLocale = new Intl.Locale(normalizedLocale);
        const weekInfo = (0, $9AtYB.getWeekInfo)(intlLocale);
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};

});
parcelRegister("l8vXm", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $ed2c35611702ec77$export$dca0327c9b9c6498);
const $ed2c35611702ec77$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("h8Z36", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $0e2297f33a926e8b$export$cfa2ef2687faeda2);

var $l8vXm = parcelRequire("l8vXm");

var $dKI0s = parcelRequire("dKI0s");

var $d07Xd = parcelRequire("d07Xd");

var $kMsXO = parcelRequire("kMsXO");
const $0e2297f33a926e8b$var$INVALID_DATE = new Date(NaN);
const $0e2297f33a926e8b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $0e2297f33a926e8b$var$INVARIANT_DATE = (0, $kMsXO.toDate)($0e2297f33a926e8b$var$INVARIANT);
const $0e2297f33a926e8b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $0e2297f33a926e8b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $0e2297f33a926e8b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $0e2297f33a926e8b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $0e2297f33a926e8b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $l8vXm.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($0e2297f33a926e8b$var$INVARIANT_DATE);
    const shortDate = $0e2297f33a926e8b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($0e2297f33a926e8b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $0e2297f33a926e8b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($0e2297f33a926e8b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($0e2297f33a926e8b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($0e2297f33a926e8b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $0e2297f33a926e8b$var$stripExtras(date).match($0e2297f33a926e8b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $0e2297f33a926e8b$var$INVALID_DATE;
        const dateParts = $0e2297f33a926e8b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $d07Xd.normalizeDate)(extractedDate, options === null || options === void 0 ? void 0 : options.defaultFirstDay);
        if (!(0, $dKI0s.isValid)(normalizedDate)) return $0e2297f33a926e8b$var$INVALID_DATE;
        return (0, $kMsXO.toDate)(normalizedDate);
    };
};

});
parcelRegister("dKI0s", function(module, exports) {
$parcel$export(module.exports, "isValid", () => $216db60c3470d53d$export$1ea939691cdc45b8);

var $fwflj = parcelRequire("fwflj");
const $216db60c3470d53d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $fwflj.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};

});
parcelRegister("fwflj", function(module, exports) {
$parcel$export(module.exports, "getDaysInMonth", () => $a6f1ab3c6b4589ac$export$f645ddd439eb259d);

var $dg3Dp = parcelRequire("dg3Dp");
const $a6f1ab3c6b4589ac$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $dg3Dp.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};

});
parcelRegister("dg3Dp", function(module, exports) {
$parcel$export(module.exports, "isLeapYear", () => $500c511414fc08a4$export$553d7fa8e3805fc0);
const $500c511414fc08a4$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};

});



parcelRegister("d07Xd", function(module, exports) {
$parcel$export(module.exports, "normalizeDate", () => $e3f935399e6d6f38$export$fcc71269590ba0a8);

var $bvndw = parcelRequire("bvndw");
const $e3f935399e6d6f38$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $bvndw.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});
parcelRegister("bvndw", function(module, exports) {
$parcel$export(module.exports, "toDateObj", () => $3f539fdc47230322$export$abe96da78d4f59dd);
const $3f539fdc47230322$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });

});


parcelRegister("kMsXO", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $5e75c2cbeeb25144$export$e67a095c620b86fe);
const $5e75c2cbeeb25144$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);

});


parcelRegister("9AtYB", function(module, exports) {
$parcel$export(module.exports, "getWeekInfo", () => $ec535144da9dd70a$export$837830ce0c77272);
// Regional exceptions from Unicode CLDR 48; all other regions use Monday.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-core/supplemental/weekData.json
const $ec535144da9dd70a$var$firstDays = {
    AF: 6,
    AG: 7,
    AS: 7,
    BD: 7,
    BH: 6,
    BR: 7,
    BS: 7,
    BT: 7,
    BW: 7,
    BZ: 7,
    CA: 7,
    CO: 7,
    DJ: 6,
    DM: 7,
    DO: 7,
    DZ: 6,
    EG: 6,
    ET: 7,
    GT: 7,
    GU: 7,
    HK: 7,
    HN: 7,
    ID: 7,
    IL: 7,
    IN: 7,
    IQ: 6,
    IR: 6,
    IS: 7,
    JM: 7,
    JO: 6,
    JP: 7,
    KE: 7,
    KH: 7,
    KR: 7,
    KW: 6,
    LA: 7,
    LY: 6,
    MH: 7,
    MM: 7,
    MO: 7,
    MT: 7,
    MV: 5,
    MX: 7,
    MZ: 7,
    NI: 7,
    NP: 7,
    OM: 6,
    PA: 7,
    PE: 7,
    PH: 7,
    PK: 7,
    PR: 7,
    PT: 7,
    PY: 7,
    QA: 6,
    SA: 7,
    SD: 6,
    SG: 7,
    SV: 7,
    SY: 6,
    TH: 7,
    TT: 7,
    TW: 7,
    UM: 7,
    US: 7,
    VE: 7,
    VI: 7,
    WS: 7,
    YE: 7,
    ZA: 7,
    ZW: 7
};
// Only regular territories may override a locale's region (CLDR 48 region validity data).
// https://github.com/unicode-org/cldr/blob/release-48/common/validity/region.xml
const $ec535144da9dd70a$var$regularRegions = new Set([
    'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF',
    'BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH',
    'CI CK CL CM CN CO CP CQ CR CU CV CW CX CY CZ DE DG DJ DK DM DO DZ',
    'EA EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI',
    'GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU IC ID IE IL IM',
    'IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA',
    'LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO',
    'MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU',
    'NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW',
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA',
    'TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ',
    'VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
].join(' ').split(' '));
// Read only Unicode keywords, excluding other extensions and private-use subtags.
const $ec535144da9dd70a$var$getUnicodeKeyword = (locale, key)=>{
    const extensions = locale.toString().split('-');
    const start = extensions.indexOf('u');
    const privateUse = extensions.indexOf('x');
    if (start === -1 || privateUse !== -1 && privateUse < start) return undefined;
    for(let index = start + 1; index < extensions.length; index++){
        if (extensions[index].length === 1) break;
        if (extensions[index] === key) {
            const value = [];
            while(((_extensions = extensions[index + 1]) === null || _extensions === void 0 ? void 0 : _extensions.length) > 2){
                var _extensions;
                value.push(extensions[++index]);
            }
            return value.join('-');
        }
    }
    return undefined;
};
// Canonicalize aliases before rejecting unknown, private-use, and macroregion overrides.
const $ec535144da9dd70a$var$getOverrideRegion = (value)=>{
    if (!value) return undefined;
    const region = new Intl.Locale(`und-${value}`).region;
    return region && $ec535144da9dd70a$var$regularRegions.has(region) ? region : undefined;
};
const $ec535144da9dd70a$export$837830ce0c77272 = (locale)=>{
    var _getUnicodeKeyword, _getUnicodeKeyword2;
    if (typeof locale.getWeekInfo === 'function') return locale.getWeekInfo();
    const legacyWeekInfo = locale.weekInfo;
    if (legacyWeekInfo) return legacyWeekInfo;
    const regionOverride = $ec535144da9dd70a$var$getOverrideRegion((_getUnicodeKeyword = $ec535144da9dd70a$var$getUnicodeKeyword(locale, 'rg')) === null || _getUnicodeKeyword === void 0 || (_getUnicodeKeyword = _getUnicodeKeyword.match(/^([a-z]{2}|[0-9]{3})zzzz$/)) === null || _getUnicodeKeyword === void 0 ? void 0 : _getUnicodeKeyword[1]);
    const subdivision = $ec535144da9dd70a$var$getOverrideRegion((_getUnicodeKeyword2 = $ec535144da9dd70a$var$getUnicodeKeyword(locale, 'sd')) === null || _getUnicodeKeyword2 === void 0 || (_getUnicodeKeyword2 = _getUnicodeKeyword2.match(/^([a-z]{2}|[0-9]{3})[a-z0-9]+$/)) === null || _getUnicodeKeyword2 === void 0 ? void 0 : _getUnicodeKeyword2[1]);
    const region = regionOverride || locale.region || subdivision || locale.maximize().region || '001';
    const preferredDay = [
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
        'sun'
    ].indexOf($ec535144da9dd70a$var$getUnicodeKeyword(locale, 'fw') || '');
    const firstDay = preferredDay !== -1 ? preferredDay + 1 : !regionOverride && locale.calendar === 'iso8601' ? 1 : $ec535144da9dd70a$var$firstDays[region] || 1;
    return {
        firstDay: firstDay
    };
};

});

parcelRegister("d99bn", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $3a36f4973ea268a4$export$9b7ca29af37c192);
const $3a36f4973ea268a4$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jiTf3", function(module, exports) {
'use strict';

var $e0da8ca06f8b9420$var$hasToStringTag = (parcelRequire("iL8BG"))();

var $azkfu = parcelRequire("azkfu");
var $e0da8ca06f8b9420$var$$toString = $azkfu('Object.prototype.toString');
var $e0da8ca06f8b9420$var$isStandardArguments = function isArguments(value) {
    if ($e0da8ca06f8b9420$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $e0da8ca06f8b9420$var$$toString(value) === '[object Arguments]';
};
var $e0da8ca06f8b9420$var$isLegacyArguments = function isArguments(value) {
    if ($e0da8ca06f8b9420$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $e0da8ca06f8b9420$var$$toString(value) !== '[object Array]' && $e0da8ca06f8b9420$var$$toString(value.callee) === '[object Function]';
};
var $e0da8ca06f8b9420$var$supportsStandardArguments = function() {
    return $e0da8ca06f8b9420$var$isStandardArguments(arguments);
}();
$e0da8ca06f8b9420$var$isStandardArguments.isLegacyArguments = $e0da8ca06f8b9420$var$isLegacyArguments; // for tests
module.exports = $e0da8ca06f8b9420$var$supportsStandardArguments ? $e0da8ca06f8b9420$var$isStandardArguments : $e0da8ca06f8b9420$var$isLegacyArguments;

});
parcelRegister("iL8BG", function(module, exports) {
'use strict';

var $ivYev = parcelRequire("ivYev");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $ivYev() && !!Symbol.toStringTag;
};

});

parcelRegister("azkfu", function(module, exports) {
'use strict';

var $c9Gut = parcelRequire("c9Gut");

var $iBdXg = parcelRequire("iBdXg");
var $7b1ce145d7c6cd8e$var$$indexOf = $iBdXg($c9Gut('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $c9Gut(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $7b1ce145d7c6cd8e$var$$indexOf(name, '.prototype.') > -1) return $iBdXg(intrinsic);
    return intrinsic;
};

});
parcelRegister("iBdXg", function(module, exports) {
'use strict';

var $fUq9m = parcelRequire("fUq9m");

var $f4Yps = parcelRequire("f4Yps");

var $f8At8 = parcelRequire("f8At8");

var $fb5q8 = parcelRequire("fb5q8");
module.exports = function callBind(originalFunction) {
    var func = $f8At8(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $fUq9m(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($f4Yps) $f4Yps(module.exports, 'apply', {
    value: $fb5q8
});
else module.exports.apply = $fb5q8;

});
parcelRegister("fUq9m", function(module, exports) {
'use strict';

var $c9Gut = parcelRequire("c9Gut");

var $8RgdG = parcelRequire("8RgdG");

var $b9505ed2d80f2834$var$hasDescriptors = (parcelRequire("01DxJ"))();

var $9B7nE = parcelRequire("9B7nE");

var $bVAoT = parcelRequire("bVAoT");
var $b9505ed2d80f2834$var$$floor = $c9Gut('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $bVAoT('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b9505ed2d80f2834$var$$floor(length) !== length) throw new $bVAoT('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $9B7nE) {
        var desc = $9B7nE(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b9505ed2d80f2834$var$hasDescriptors) $8RgdG(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $8RgdG(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("8RgdG", function(module, exports) {
'use strict';

var $f4Yps = parcelRequire("f4Yps");

var $D1lVv = parcelRequire("D1lVv");

var $bVAoT = parcelRequire("bVAoT");

var $9B7nE = parcelRequire("9B7nE");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $bVAoT('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $bVAoT('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $bVAoT('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $bVAoT('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $bVAoT('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $bVAoT('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$9B7nE && $9B7nE(obj, property);
    if ($f4Yps) $f4Yps(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $D1lVv('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("01DxJ", function(module, exports) {
'use strict';

var $f4Yps = parcelRequire("f4Yps");
var $004ec48cd56693d6$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$f4Yps;
};
$004ec48cd56693d6$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$f4Yps) return null;
    try {
        return $f4Yps([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $004ec48cd56693d6$var$hasPropertyDescriptors;

});


parcelRegister("fb5q8", function(module, exports) {
'use strict';

var $lssto = parcelRequire("lssto");

var $9t9l6 = parcelRequire("9t9l6");

var $lTOpV = parcelRequire("lTOpV");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $lTOpV($lssto, $9t9l6, arguments);
};

});




parcelRegister("jRIll", function(module, exports) {
'use strict';

var $4sNqZ = parcelRequire("4sNqZ");

var $ilJV9 = parcelRequire("ilJV9");

var $iBdXg = parcelRequire("iBdXg");

var $kdnt5 = parcelRequire("kdnt5");

var $9B7nE = parcelRequire("9B7nE");

var $m9GUf = parcelRequire("m9GUf");
var $e7655d2f0686311b$var$$toString = $kdnt5('Object.prototype.toString');

var $e7655d2f0686311b$var$hasToStringTag = (parcelRequire("iL8BG"))();
var $e7655d2f0686311b$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $e7655d2f0686311b$var$typedArrays = $ilJV9();
var $e7655d2f0686311b$var$$slice = $kdnt5('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $e7655d2f0686311b$var$$indexOf = $kdnt5('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $e7655d2f0686311b$var$cache = {
    __proto__: null
};
if ($e7655d2f0686311b$var$hasToStringTag && $9B7nE && $m9GUf) $4sNqZ($e7655d2f0686311b$var$typedArrays, function(typedArray) {
    var arr = new $e7655d2f0686311b$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $m9GUf) {
        var proto = $m9GUf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $9B7nE(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $m9GUf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $9B7nE(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $e7655d2f0686311b$var$cache['$' + typedArray] = $iBdXg(descriptor.get);
    }
});
else $4sNqZ($e7655d2f0686311b$var$typedArrays, function(typedArray) {
    var arr = new $e7655d2f0686311b$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $e7655d2f0686311b$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $iBdXg(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $e7655d2f0686311b$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $4sNqZ(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $e7655d2f0686311b$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $e7655d2f0686311b$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $e7655d2f0686311b$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $4sNqZ(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $e7655d2f0686311b$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $e7655d2f0686311b$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$e7655d2f0686311b$var$hasToStringTag) {
        /** @type {string} */ var tag = $e7655d2f0686311b$var$$slice($e7655d2f0686311b$var$$toString(value), 8, -1);
        if ($e7655d2f0686311b$var$$indexOf($e7655d2f0686311b$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $e7655d2f0686311b$var$trySlices(value);
    }
    if (!$9B7nE) return null;
     // unknown engine
    return $e7655d2f0686311b$var$tryTypedArrays(value);
};

});
parcelRegister("4sNqZ", function(module, exports) {
'use strict';

var $29S6h = parcelRequire("29S6h");
var $34001f8e5027efbb$var$toStr = Object.prototype.toString;
var $34001f8e5027efbb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $34001f8e5027efbb$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($34001f8e5027efbb$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $34001f8e5027efbb$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $34001f8e5027efbb$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($34001f8e5027efbb$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $34001f8e5027efbb$var$isArray(x) {
    return $34001f8e5027efbb$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$29S6h(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($34001f8e5027efbb$var$isArray(list)) $34001f8e5027efbb$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $34001f8e5027efbb$var$forEachString(list, iterator, receiver);
    else $34001f8e5027efbb$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("29S6h", function(module, exports) {
'use strict';
var $19266338f8a0267b$var$fnToStr = Function.prototype.toString;
var $19266338f8a0267b$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $19266338f8a0267b$var$badArrayLike;
var $19266338f8a0267b$var$isCallableMarker;
if (typeof $19266338f8a0267b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $19266338f8a0267b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $19266338f8a0267b$var$isCallableMarker;
        }
    });
    $19266338f8a0267b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $19266338f8a0267b$var$reflectApply(function() {
        throw 42;
    }, null, $19266338f8a0267b$var$badArrayLike);
} catch (_) {
    if (_ !== $19266338f8a0267b$var$isCallableMarker) $19266338f8a0267b$var$reflectApply = null;
}
else $19266338f8a0267b$var$reflectApply = null;
var $19266338f8a0267b$var$constructorRegex = /^\s*class\b/;
var $19266338f8a0267b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $19266338f8a0267b$var$fnToStr.call(value);
        return $19266338f8a0267b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $19266338f8a0267b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($19266338f8a0267b$var$isES6ClassFn(value)) return false;
        $19266338f8a0267b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $19266338f8a0267b$var$toStr = Object.prototype.toString;
var $19266338f8a0267b$var$objectClass = '[object Object]';
var $19266338f8a0267b$var$fnClass = '[object Function]';
var $19266338f8a0267b$var$genClass = '[object GeneratorFunction]';
var $19266338f8a0267b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $19266338f8a0267b$var$ddaClass2 = '[object HTML document.all class]';
var $19266338f8a0267b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $19266338f8a0267b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $19266338f8a0267b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $19266338f8a0267b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $19266338f8a0267b$var$all = document.all;
    if ($19266338f8a0267b$var$toStr.call($19266338f8a0267b$var$all) === $19266338f8a0267b$var$toStr.call(document.all)) $19266338f8a0267b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($19266338f8a0267b$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $19266338f8a0267b$var$toStr.call(value);
            return (str === $19266338f8a0267b$var$ddaClass || str === $19266338f8a0267b$var$ddaClass2 || str === $19266338f8a0267b$var$ddaClass3 // opera 12.16
             || str === $19266338f8a0267b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $19266338f8a0267b$var$reflectApply ? function isCallable(value) {
    if ($19266338f8a0267b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $19266338f8a0267b$var$reflectApply(value, null, $19266338f8a0267b$var$badArrayLike);
    } catch (e) {
        if (e !== $19266338f8a0267b$var$isCallableMarker) return false;
    }
    return !$19266338f8a0267b$var$isES6ClassFn(value) && $19266338f8a0267b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($19266338f8a0267b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($19266338f8a0267b$var$hasToStringTag) return $19266338f8a0267b$var$tryFunctionObject(value);
    if ($19266338f8a0267b$var$isES6ClassFn(value)) return false;
    var strClass = $19266338f8a0267b$var$toStr.call(value);
    if (strClass !== $19266338f8a0267b$var$fnClass && strClass !== $19266338f8a0267b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $19266338f8a0267b$var$tryFunctionObject(value);
};

});


parcelRegister("ilJV9", function(module, exports) {
'use strict';

var $5nEE8 = parcelRequire("5nEE8");
var $d5bdcf188186a6ea$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $5nEE8.length; i++)if (typeof $d5bdcf188186a6ea$var$g[$5nEE8[i]] === 'function') // @ts-expect-error
    out[out.length] = $5nEE8[i];
    return out;
};

});
parcelRegister("5nEE8", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("3rI5v", function(module, exports) {
'use strict';

var $jRIll = parcelRequire("jRIll");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$jRIll(value);
};

});

parcelRegister("hhO5F", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("lAXvK", function(module, exports) {
'use strict';
var $fb8b1f6ffcb9c7ed$var$slice = Array.prototype.slice;

var $2Mpmm = parcelRequire("2Mpmm");
var $fb8b1f6ffcb9c7ed$var$origKeys = Object.keys;

var $fb8b1f6ffcb9c7ed$var$keysShim = $fb8b1f6ffcb9c7ed$var$origKeys ? function keys(o) {
    return $fb8b1f6ffcb9c7ed$var$origKeys(o);
} : (parcelRequire("1uUqg"));
var $fb8b1f6ffcb9c7ed$var$originalKeys = Object.keys;
$fb8b1f6ffcb9c7ed$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($2Mpmm(object)) return $fb8b1f6ffcb9c7ed$var$originalKeys($fb8b1f6ffcb9c7ed$var$slice.call(object));
            return $fb8b1f6ffcb9c7ed$var$originalKeys(object);
        };
    } else Object.keys = $fb8b1f6ffcb9c7ed$var$keysShim;
    return Object.keys || $fb8b1f6ffcb9c7ed$var$keysShim;
};
module.exports = $fb8b1f6ffcb9c7ed$var$keysShim;

});
parcelRegister("2Mpmm", function(module, exports) {
'use strict';
var $2063bc625da6a4fc$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $2063bc625da6a4fc$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2063bc625da6a4fc$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("1uUqg", function(module, exports) {
'use strict';
var $11745c1fb4f13235$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $11745c1fb4f13235$var$has = Object.prototype.hasOwnProperty;
    var $11745c1fb4f13235$var$toStr = Object.prototype.toString;
    var $11745c1fb4f13235$var$isArgs = (parcelRequire("2Mpmm")); // eslint-disable-line global-require
    var $11745c1fb4f13235$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $11745c1fb4f13235$var$hasDontEnumBug = !$11745c1fb4f13235$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $11745c1fb4f13235$var$hasProtoEnumBug = $11745c1fb4f13235$var$isEnumerable.call(function() {}, 'prototype');
    var $11745c1fb4f13235$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $11745c1fb4f13235$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $11745c1fb4f13235$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $11745c1fb4f13235$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$11745c1fb4f13235$var$excludedKeys['$' + k] && $11745c1fb4f13235$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $11745c1fb4f13235$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $11745c1fb4f13235$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$11745c1fb4f13235$var$hasAutomationEqualityBug) return $11745c1fb4f13235$var$equalsConstructorPrototype(o);
        try {
            return $11745c1fb4f13235$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $11745c1fb4f13235$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $11745c1fb4f13235$var$toStr.call(object) === '[object Function]';
        var isArguments = $11745c1fb4f13235$var$isArgs(object);
        var isString = isObject && $11745c1fb4f13235$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $11745c1fb4f13235$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$11745c1fb4f13235$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $11745c1fb4f13235$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($11745c1fb4f13235$var$hasDontEnumBug) {
            var skipConstructor = $11745c1fb4f13235$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $11745c1fb4f13235$var$dontEnums.length; ++k)if (!(skipConstructor && $11745c1fb4f13235$var$dontEnums[k] === 'constructor') && $11745c1fb4f13235$var$has.call(object, $11745c1fb4f13235$var$dontEnums[k])) theKeys.push($11745c1fb4f13235$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $11745c1fb4f13235$var$keysShim;

});


parcelRegister("jinRP", function(module, exports) {
'use strict';

var $48QMu = parcelRequire("48QMu");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $48QMu;
};

});
parcelRegister("48QMu", function(module, exports) {
'use strict';
var $3040d9fecf57432a$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($3040d9fecf57432a$var$numberIsNaN(a) && $3040d9fecf57432a$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("agMcO", function(module, exports) {
'use strict';

var $lIiYQ = parcelRequire("lIiYQ");

var $iBdXg = parcelRequire("iBdXg");

var $48QMu = parcelRequire("48QMu");

var $jinRP = parcelRequire("jinRP");

var $fToL4 = parcelRequire("fToL4");
var $01edf2c0aad549b0$var$polyfill = $iBdXg($jinRP(), Object);
$lIiYQ($01edf2c0aad549b0$var$polyfill, {
    getPolyfill: $jinRP,
    implementation: $48QMu,
    shim: $fToL4
});
module.exports = $01edf2c0aad549b0$var$polyfill;

});
parcelRegister("lIiYQ", function(module, exports) {
'use strict';

var $lAXvK = parcelRequire("lAXvK");
var $fcec6e1e9e87a12a$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $fcec6e1e9e87a12a$var$toStr = Object.prototype.toString;
var $fcec6e1e9e87a12a$var$concat = Array.prototype.concat;

var $8RgdG = parcelRequire("8RgdG");
var $fcec6e1e9e87a12a$var$isFunction = function(fn) {
    return typeof fn === 'function' && $fcec6e1e9e87a12a$var$toStr.call(fn) === '[object Function]';
};

var $fcec6e1e9e87a12a$var$supportsDescriptors = (parcelRequire("01DxJ"))();
var $fcec6e1e9e87a12a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$fcec6e1e9e87a12a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($fcec6e1e9e87a12a$var$supportsDescriptors) $8RgdG(object, name, value, true);
    else $8RgdG(object, name, value);
};
var $fcec6e1e9e87a12a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $lAXvK(map);
    if ($fcec6e1e9e87a12a$var$hasSymbols) props = $fcec6e1e9e87a12a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$fcec6e1e9e87a12a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$fcec6e1e9e87a12a$var$defineProperties.supportsDescriptors = !!$fcec6e1e9e87a12a$var$supportsDescriptors;
module.exports = $fcec6e1e9e87a12a$var$defineProperties;

});

parcelRegister("fToL4", function(module, exports) {
'use strict';

var $jinRP = parcelRequire("jinRP");

var $lIiYQ = parcelRequire("lIiYQ");
module.exports = function shimObjectIs() {
    var polyfill = $jinRP();
    $lIiYQ(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("kitud", function(module, exports) {
$parcel$export(module.exports, "base", () => $ec6c5c72670ecde0$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $ec6c5c72670ecde0$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $ec6c5c72670ecde0$export$fb33aafd75404f4c);
var $ec6c5c72670ecde0$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $ec6c5c72670ecde0$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $ec6c5c72670ecde0$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $ec6c5c72670ecde0$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $ec6c5c72670ecde0$var$i = 0; $ec6c5c72670ecde0$var$i < 10; $ec6c5c72670ecde0$var$i++)$ec6c5c72670ecde0$export$e2253033e6e1df16[48 + $ec6c5c72670ecde0$var$i] = $ec6c5c72670ecde0$export$e2253033e6e1df16[96 + $ec6c5c72670ecde0$var$i] = String($ec6c5c72670ecde0$var$i);
// The function keys
for(var $ec6c5c72670ecde0$var$i = 1; $ec6c5c72670ecde0$var$i <= 24; $ec6c5c72670ecde0$var$i++)$ec6c5c72670ecde0$export$e2253033e6e1df16[$ec6c5c72670ecde0$var$i + 111] = "F" + $ec6c5c72670ecde0$var$i;
// And the alphabetic keys
for(var $ec6c5c72670ecde0$var$i = 65; $ec6c5c72670ecde0$var$i <= 90; $ec6c5c72670ecde0$var$i++){
    $ec6c5c72670ecde0$export$e2253033e6e1df16[$ec6c5c72670ecde0$var$i] = String.fromCharCode($ec6c5c72670ecde0$var$i + 32);
    $ec6c5c72670ecde0$export$fba63a578e423eb[$ec6c5c72670ecde0$var$i] = String.fromCharCode($ec6c5c72670ecde0$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $ec6c5c72670ecde0$var$code in $ec6c5c72670ecde0$export$e2253033e6e1df16)if (!$ec6c5c72670ecde0$export$fba63a578e423eb.hasOwnProperty($ec6c5c72670ecde0$var$code)) $ec6c5c72670ecde0$export$fba63a578e423eb[$ec6c5c72670ecde0$var$code] = $ec6c5c72670ecde0$export$e2253033e6e1df16[$ec6c5c72670ecde0$var$code];
function $ec6c5c72670ecde0$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $ec6c5c72670ecde0$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $ec6c5c72670ecde0$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $ec6c5c72670ecde0$export$fba63a578e423eb : $ec6c5c72670ecde0$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("dvoJo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15752cbf5c5b8ff3e6a05bbcbc7d40d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d515ab5dc68691d$var$_react = $9d515ab5dc68691d$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $9d515ab5dc68691d$var$_iconNew = $9d515ab5dc68691d$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $9d515ab5dc68691d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-left
 * Usage guidance:
 * Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d515ab5dc68691d$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $9d515ab5dc68691d$var$_react.default.createElement($9d515ab5dc68691d$var$_iconNew.default, Object.assign({
        name: "AlignTextLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$9d515ab5dc68691d$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $9d515ab5dc68691d$var$_default = module.exports.default = $9d515ab5dc68691d$var$AlignTextLeftIcon;

});

parcelRegister("dca9w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64347d86305d18a44e2d07d8a13aff6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99b4456e89e8ac57$var$_react = $99b4456e89e8ac57$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $99b4456e89e8ac57$var$_iconNew = $99b4456e89e8ac57$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $99b4456e89e8ac57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text
 * Usage guidance:
 * Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99b4456e89e8ac57$var$TextIcon = (props)=>/*#__PURE__*/ $99b4456e89e8ac57$var$_react.default.createElement($99b4456e89e8ac57$var$_iconNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.25V15h-1.5V2.5H0V1zm1 12V8h-2V6.5h2V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2"/>`
    }, props));
$99b4456e89e8ac57$var$TextIcon.displayName = 'TextIcon';
var $99b4456e89e8ac57$var$_default = module.exports.default = $99b4456e89e8ac57$var$TextIcon;

});

parcelRegister("h9peu", function(module, exports) {
$parcel$export(module.exports, "default", () => $353e033107263282$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $JD7lD = parcelRequire("JD7lD");

var $7h4V9 = parcelRequire("7h4V9");

var $ewwlR = parcelRequire("ewwlR");
const $353e033107263282$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $353e033107263282$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
function $353e033107263282$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $JD7lD.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7h4V9.AvatarContent), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ewwlR.TeamAvatarImage), {
                src: src,
                testId: testId,
                teamId: teamId
            }, teamId)
        })
    });
}

});
parcelRegister("ewwlR", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", () => $45c88a7929a46093$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $7fm1P = parcelRequire("7fm1P");

var $2t53n = parcelRequire("2t53n");
const $45c88a7929a46093$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $45c88a7929a46093$export$ac3673635a5387be = ({ alt: alt = '', src: src, testId: testId, teamId: teamId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $bSJIT.useState)(false);
    const avatarSrc = (0, $2t53n.getTeamAvatarSrc)(src, teamId);
    const resolvedSrc = hasImageErrored ? (0, $7fm1P.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "img",
        src: resolvedSrc,
        alt: alt,
        testId: testId && `${testId}--image`,
        xcss: $45c88a7929a46093$var$avatarImageStyles.image,
        onError: ()=>setHasImageErrored(true)
    });
};

});
parcelRegister("7fm1P", function(module, exports) {
$parcel$export(module.exports, "TEAM_FALLBACK_AVATAR_DATA_URI", () => $9ebc047d02f8e069$export$215bd25cfab1a96);
const $9ebc047d02f8e069$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;

});

parcelRegister("2t53n", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", () => $36c4fc8c4133cd83$export$59ff7d19feb890b6);

var $7fm1P = parcelRequire("7fm1P");
function $36c4fc8c4133cd83$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return 0, $7fm1P.TEAM_FALLBACK_AVATAR_DATA_URI;
}

});



parcelRegister("7pibM", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd414555e28e90bc$export$2e2bcd8739ae039);
const $cd414555e28e90bc$var$getAppearanceForAppType = (appType)=>{
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
};
var $cd414555e28e90bc$export$2e2bcd8739ae039 = $cd414555e28e90bc$var$getAppearanceForAppType;

});

parcelRegister("1g3fM", function(module, exports) {
$parcel$export(module.exports, "DatasourceTableViewWithWrappers", () => $b1686a8711f1bca1$export$2f5bdb66685d3fb4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dMMwa = parcelRequire("dMMwa");

const $b1686a8711f1bca1$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("gkm5d")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b1686a8711f1bca1$export$2f5bdb66685d3fb4 = /*#__PURE__*/ (0, $bSJIT.memo)(function DatasourceTableViewWithWrappers(props) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($b1686a8711f1bca1$var$LazyDatasourceTableView, {
            ...props
        })
    });
}, (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa))));

});
parcelRegister("gkm5d", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("gZStK"),
    $kOunM("fXeMz"),
    $kOunM("k93PB"),
    $kOunM("coIBk"),
    $kOunM("3dX2x"),
    $kOunM("itmHl"),
    $kOunM("b8LwF")
]).then(()=>parcelRequire('5R4Eq'));

});


parcelRegister("ds6EJ", function(module, exports) {
$parcel$export(module.exports, "ExternalImageBadge", () => $9e70681e177b6516$export$66bf2ed7a5d4691f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $68E0O = parcelRequire("68E0O");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $lavtv = parcelRequire("lavtv");

var $aEzM6 = parcelRequire("aEzM6");
const $9e70681e177b6516$var$baseStyles = (0, $9BVpB.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $9e70681e177b6516$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $9e70681e177b6516$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname === null || pathname === void 0 ? void 0 : pathname.startsWith('image/');
    return Boolean(hostname && $9e70681e177b6516$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $9e70681e177b6516$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $4vLTk.default)();
    const message = intl.formatMessage((0, $aEzM6.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $9e70681e177b6516$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $gUpf2.Box), {
        padding: "space.050",
        xcss: $9e70681e177b6516$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("aEzM6", function(module, exports) {
$parcel$export(module.exports, "externalMediaMessages", () => $c6da9e073452fd49$export$8e36294abfabe45e);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c6da9e073452fd49$export$8e36294abfabe45e = (0, $f0Pt4.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'Displayed as a tooltip and accessibility label for an info icon badge when an externally hosted media file is shown in the editor.'
    }
});

});


parcelRegister("61dYH", function(module, exports) {
$parcel$export(module.exports, "MediaBadges", () => $1233a640239aea17$export$6a31fc38737d0e58);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $b3sQK = parcelRequire("b3sQK");
const $1233a640239aea17$export$6a31fc38737d0e58 = ({ mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, children: children, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $b3sQK.BlockNodeBadges), {
        element: mediaElement,
        width: mediaWidth,
        height: mediaHeight,
        extendedResizeOffset: extendedResizeOffset,
        useMinimumZIndex: useMinimumZIndex,
        children: children
    });

});
parcelRegister("b3sQK", function(module, exports) {
$parcel$export(module.exports, "BlockNodeBadges", () => $1ec50ba67aad0b56$export$d7fda18776ad9a8d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gdUUy = parcelRequire("gdUUy");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $1ec50ba67aad0b56$var$BADGE_VISIBILITY_BREAKPOINT = 200;
const $1ec50ba67aad0b56$var$containerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $1ec50ba67aad0b56$var$hackedZIndexStyles = (0, $9BVpB.xcss)({
    zIndex: '1'
});
const $1ec50ba67aad0b56$var$resizeOffsetStyles = (0, $9BVpB.xcss)({
    right: 'space.150'
});
const $1ec50ba67aad0b56$var$getBadgeVisible = (width, height)=>{
    return width && width < $1ec50ba67aad0b56$var$BADGE_VISIBILITY_BREAKPOINT || height && height < $1ec50ba67aad0b56$var$BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $1ec50ba67aad0b56$export$d7fda18776ad9a8d = ({ children: children, element: element, width: width, height: height, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $bSJIT.useState)($1ec50ba67aad0b56$var$getBadgeVisible(width, height));
    (0, $bSJIT.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($1ec50ba67aad0b56$var$getBadgeVisible(width, height));
        }));
        if (element) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $gdUUy.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!element || (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $1ec50ba67aad0b56$var$containerStyles,
            useMinimumZIndex && $1ec50ba67aad0b56$var$hackedZIndexStyles,
            extendedResizeOffset && $1ec50ba67aad0b56$var$resizeOffsetStyles
        ],
        children: children
    });
};

});


parcelRegister("1eX8N", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $a72174cc80662e0f$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $a72174cc80662e0f$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $a72174cc80662e0f$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $a72174cc80662e0f$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};

});

parcelRegister("7mZGn", function(module, exports) {
$parcel$export(module.exports, "withImageLoader", () => $7307171ae793328f$export$9b0f795b2e33f057);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $7307171ae793328f$export$9b0f795b2e33f057 = (Wrapped)=>class WithImageLoader extends (0, $bSJIT.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $dc70d.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };

});

parcelRegister("Ta6C9", function(module, exports) {
$parcel$export(module.exports, "getDimensionsWithDefault", () => $495ceed8aac696eb$export$36acad525b1fb57b);
const $495ceed8aac696eb$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("cw1fH", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $f6d0df9b2c173384$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $gXAfF = parcelRequire("gXAfF");
const $f6d0df9b2c173384$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: (0, $gXAfF.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("gXAfF", function(module, exports) {
$parcel$export(module.exports, "wrapperStyles", () => $9ee7ec6ea09cf5f4$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $kCE0b = parcelRequire("kCE0b");
const $9ee7ec6ea09cf5f4$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $kCE0b.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $kCE0b.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("kCE0b", function(module, exports) {
$parcel$export(module.exports, "center", () => $e6f3d73a7bae77e8$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $e6f3d73a7bae77e8$export$7a57f79000377ca2);
const $e6f3d73a7bae77e8$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $e6f3d73a7bae77e8$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $e6f3d73a7bae77e8$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $e6f3d73a7bae77e8$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});



parcelRegister("fyJNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $78d3d7a23857cdc1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $gdUUy = parcelRequire("gdUUy");

var $1DGz6 = parcelRequire("1DGz6");

var $b2ees = parcelRequire("b2ees");
const $78d3d7a23857cdc1$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});
const $78d3d7a23857cdc1$var$CardLoadingWithContext = ()=>{
    const props = (0, $bSJIT.useContext)($78d3d7a23857cdc1$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b2ees.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $78d3d7a23857cdc1$var$loadCardWithMediaClient() {
    return (parcelRequire("iGQv0"));
}
const $78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>$78d3d7a23857cdc1$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$CardLoadingWithContext, null)
});
const $78d3d7a23857cdc1$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>$78d3d7a23857cdc1$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $78d3d7a23857cdc1$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1DGz6.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardContext.Provider, {
        value: props
    }, (0, $gdUUy.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable, props)));
};
$78d3d7a23857cdc1$var$CardLoader.preload = ()=>{
    if ((0, $gdUUy.fg)('platform_media_react19_support')) $78d3d7a23857cdc1$var$loadCardWithMediaClient().then(()=>{});
    else {
        var _MediaCardWithMediaCl;
        (_MediaCardWithMediaCl = $78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable.preload) === null || _MediaCardWithMediaCl === void 0 || _MediaCardWithMediaCl.call($78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable);
    }
};
var $78d3d7a23857cdc1$export$2e2bcd8739ae039 = $78d3d7a23857cdc1$var$CardLoader;

});
parcelRegister("b2ees", function(module, exports) {
$parcel$export(module.exports, "CardLoading", () => $5cb084c50dfe3d13$export$5d25853fd6bdf402);

var $bSJIT = parcelRequire("bSJIT");

var $ljFME = parcelRequire("ljFME");

var $Ta6C9 = parcelRequire("Ta6C9");

var $cw1fH = parcelRequire("cw1fH");
const $5cb084c50dfe3d13$export$5d25853fd6bdf402 = ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $Ta6C9.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cw1fH.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljFME.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }));
};

});
parcelRegister("ljFME", function(module, exports) {
$parcel$export(module.exports, "LoadingBar", () => $d7e29441a6d1fe20$export$6665614bc5d690f6);
/* loadingBar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $cyIUy = parcelRequire("cyIUy");
const $d7e29441a6d1fe20$var$TICK_INTERVAL_MS = 1000;
const $d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE = 0.9;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $d7e29441a6d1fe20$var$useLayoutEffect = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
const $d7e29441a6d1fe20$var$messages = (0, $f0Pt4.defineMessages)({
    loadingBarLabel: {
        id: 'fabric.media.loading_bar_label',
        defaultMessage: 'Loading',
        description: 'Aria label for the loading bar shown while a media card is loading'
    }
});
const $d7e29441a6d1fe20$var$trackStyles = null;
const $d7e29441a6d1fe20$var$fillStyles = null;
const $d7e29441a6d1fe20$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $d7e29441a6d1fe20$export$6665614bc5d690f6 = ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $4vLTk.default)();
    const [progress, setProgress] = (0, $bSJIT.useState)(animationDisabled ? $d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $bSJIT.useRef)();
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    $d7e29441a6d1fe20$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $d7e29441a6d1fe20$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($d7e29441a6d1fe20$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: {
            width: `${$d7e29441a6d1fe20$var$clampToPercent(progress)}%`
        },
        className: (0, $9fU1q.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ])
    }));
};

});


parcelRegister("iGQv0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cqzIS"),
    $kOunM("hyEGg"),
    $kOunM("eyRof")
]).then(()=>parcelRequire('3NCBI'));

});


parcelRegister("h1iH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0957fc82dbb4422$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $g6Cb6 = parcelRequire("g6Cb6");

var $jhvwJ = parcelRequire("jhvwJ");

const $b0957fc82dbb4422$var$MediaViewer = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("l38xz")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $b0957fc82dbb4422$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g6Cb6.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jhvwJ.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($b0957fc82dbb4422$var$MediaViewer, props)));
}

});
parcelRegister("g6Cb6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ba4320c95595d17$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $bSJIT = parcelRequire("bSJIT");

var $3tjUk = parcelRequire("3tjUk");

var $ceb9s = parcelRequire("ceb9s");
const $4ba4320c95595d17$export$442b7be89436c101 = '#101214';
const $4ba4320c95595d17$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3tjUk.default), {
        blankedColor: $4ba4320c95595d17$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $4ba4320c95595d17$export$2e2bcd8739ae039 = $4ba4320c95595d17$var$ModalSpinner;

});
parcelRegister("3tjUk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7efea52492beaee9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $g6s0K = parcelRequire("g6s0K");
const $7efea52492beaee9$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g6s0K.default), props);
var $7efea52492beaee9$export$2e2bcd8739ae039 = $7efea52492beaee9$var$ModalSpinner;

});
parcelRegister("g6s0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b49eb551da83dee$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hDkm2 = parcelRequire("hDkm2");
const $2b49eb551da83dee$var$blanketStyles = null;
const $2b49eb551da83dee$var$spinnerStyles = null;
const $2b49eb551da83dee$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $2b49eb551da83dee$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $bSJIT.createElement("div", {
        style: {
            backgroundColor: blankedColor || $2b49eb551da83dee$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $9fU1q.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
        size: "large",
        appearance: invertSpinnerColor || $2b49eb551da83dee$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});



parcelRegister("jhvwJ", function(module, exports) {
$parcel$export(module.exports, "MediaViewerPortal", () => $18bad7678d2ef09e$export$51aee4c01b17acde);

var $bSJIT = parcelRequire("bSJIT");

var $cglph = parcelRequire("cglph");
const $18bad7678d2ef09e$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cglph.default), {
        zIndex: 510
    }, children);

});

parcelRegister("l38xz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9AtoL"),
    $kOunM("hd6wF"),
    $kOunM("dv0rW"),
    $kOunM("92sIe"),
    $kOunM("cqzIS"),
    $kOunM("hyEGg"),
    $kOunM("6FbLK"),
    $kOunM("lcafb"),
    $kOunM("42Pvp"),
    $kOunM("ipAwN"),
    $kOunM("7VIjZ"),
    $kOunM("7EtTP"),
    $kOunM("i4HzU"),
    $kOunM("5JcpR"),
    $kOunM("k2gok"),
    $kOunM("49weT"),
    $kOunM("5IUGi"),
    $kOunM("8scR7"),
    $kOunM("5Q6Lv"),
    $kOunM("2kEJi"),
    $kOunM("9cGC5")
]).then(()=>parcelRequire('dQUZc'));

});


parcelRegister("fRvvl", function(module, exports) {
$parcel$export(module.exports, "isExternalImageIdentifier", () => $85768a2492eeafa2$export$2782f2fbff82f0c9);
const $85768a2492eeafa2$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};

});

parcelRegister("97BF5", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $c3c58bee55e55557$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $c3c58bee55e55557$export$383e8f51978266d);

var $f1Pw2 = parcelRequire("f1Pw2");

var $d8prp = parcelRequire("d8prp");

var $iUEoh = parcelRequire("iUEoh");
const $c3c58bee55e55557$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $c3c58bee55e55557$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $d8prp.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $iUEoh.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $c3c58bee55e55557$export$836625761e76d373 = {
    mediaInline: false
};
function $c3c58bee55e55557$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $f1Pw2.getGenericFeatureFlag)(flagName, $c3c58bee55e55557$export$836625761e76d373, featureFlags);
}

});
parcelRegister("f1Pw2", function(module, exports) {
$parcel$export(module.exports, "getGenericFeatureFlag", () => $c21da4abae8aac1c$export$f2687d0de19e4973);

var $i2hQM = parcelRequire("i2hQM");
function $c21da4abae8aac1c$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $i2hQM.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("i2hQM", function(module, exports) {
$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $53f557e2bc3014e8$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $53f557e2bc3014e8$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});


parcelRegister("d8prp", function(module, exports) {
$parcel$export(module.exports, "getProductKeys", () => $4ee9405dd13d2e21$export$189fe120be7e73fc);
const $4ee9405dd13d2e21$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $4ee9405dd13d2e21$export$189fe120be7e73fc = ()=>$4ee9405dd13d2e21$var$productKeys;

});

parcelRegister("iUEoh", function(module, exports) {
$parcel$export(module.exports, "supportedProducts", () => $93f36a1824f32ea9$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $93f36a1824f32ea9$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});


parcelRegister("kFWau", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0d4c1fa6b7c3106$var$_react = $f0d4c1fa6b7c3106$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f0d4c1fa6b7c3106$var$_iconNew = $f0d4c1fa6b7c3106$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f0d4c1fa6b7c3106$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0d4c1fa6b7c3106$var$AddIcon = (props)=>/*#__PURE__*/ $f0d4c1fa6b7c3106$var$_react.default.createElement($f0d4c1fa6b7c3106$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$f0d4c1fa6b7c3106$var$AddIcon.displayName = 'AddIcon';
var $f0d4c1fa6b7c3106$var$_default = module.exports.default = $f0d4c1fa6b7c3106$var$AddIcon;

});

parcelRegister("g3Ytr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b7b5313441e64074b34abd119ca75dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb1bd5fb5c8050f7$var$_react = $bb1bd5fb5c8050f7$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $bb1bd5fb5c8050f7$var$_iconNew = $bb1bd5fb5c8050f7$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $bb1bd5fb5c8050f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/minus
 * Usage guidance:
 * Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb1bd5fb5c8050f7$var$MinusIcon = (props)=>/*#__PURE__*/ $bb1bd5fb5c8050f7$var$_react.default.createElement($bb1bd5fb5c8050f7$var$_iconNew.default, Object.assign({
        name: "MinusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$bb1bd5fb5c8050f7$var$MinusIcon.displayName = 'MinusIcon';
var $bb1bd5fb5c8050f7$var$_default = module.exports.default = $bb1bd5fb5c8050f7$var$MinusIcon;

});

parcelRegister("gV64P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd451baebec3ee8af80e499b33257918>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c516aeef361d7b8d$var$_react = $c516aeef361d7b8d$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c516aeef361d7b8d$var$_iconNew = $c516aeef361d7b8d$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c516aeef361d7b8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/delete
 * Usage guidance:
 * Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c516aeef361d7b8d$var$DeleteIcon = (props)=>/*#__PURE__*/ $c516aeef361d7b8d$var$_react.default.createElement($c516aeef361d7b8d$var$_iconNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$c516aeef361d7b8d$var$DeleteIcon.displayName = 'DeleteIcon';
var $c516aeef361d7b8d$var$_default = module.exports.default = $c516aeef361d7b8d$var$DeleteIcon;

});

parcelRegister("5xL0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfb96ac8121d6e86aa07f23b47de6511>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $409480e7a540989e$var$_react = $409480e7a540989e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $409480e7a540989e$var$_iconNew = $409480e7a540989e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $409480e7a540989e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $409480e7a540989e$var$SettingsIcon = (props)=>/*#__PURE__*/ $409480e7a540989e$var$_react.default.createElement($409480e7a540989e$var$_iconNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$409480e7a540989e$var$SettingsIcon.displayName = 'SettingsIcon';
var $409480e7a540989e$var$_default = module.exports.default = $409480e7a540989e$var$SettingsIcon;

});

parcelRegister("4rvUe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::441dfad9ee46f29a271b393b57a2f5c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33c26ee61a5da56b$var$_react = $33c26ee61a5da56b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $33c26ee61a5da56b$var$_iconNew = $33c26ee61a5da56b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $33c26ee61a5da56b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/upload
 * Usage guidance:
 * Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33c26ee61a5da56b$var$UploadIcon = (props)=>/*#__PURE__*/ $33c26ee61a5da56b$var$_react.default.createElement($33c26ee61a5da56b$var$_iconNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$33c26ee61a5da56b$var$UploadIcon.displayName = 'UploadIcon';
var $33c26ee61a5da56b$var$_default = module.exports.default = $33c26ee61a5da56b$var$UploadIcon;

});

parcelRegister("gc5WX", function(module, exports) {
$parcel$export(module.exports, "defaultImageCardDimensions", () => $b88ea2afb7691434$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $b88ea2afb7691434$export$ed7b8a4728e9c63);
const $b88ea2afb7691434$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b88ea2afb7691434$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b88ea2afb7691434$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b88ea2afb7691434$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b88ea2afb7691434$export$d87a47989c00f322;
    if (appearance === 'square') return $b88ea2afb7691434$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b88ea2afb7691434$export$aeb48196afcd236a;
    return $b88ea2afb7691434$export$d87a47989c00f322;
};

});

parcelRegister("lyKnc", function(module, exports) {
$parcel$export(module.exports, "isResolvingMentionProvider", () => $7b8bd6c7a8b3845e$export$ae1fce5f69858ef3);
const $7b8bd6c7a8b3845e$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());

});

parcelRegister("5g8DV", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $e94d2e1655ed06c4$export$4369c812aac99591);
const $e94d2e1655ed06c4$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("eBfRL", function(module, exports) {
$parcel$export(module.exports, "AGENT_MENTION_LOAD_ERROR_ID", () => $badcb81cb04dd8d7$export$43bc8ec87115a7b3);
$parcel$export(module.exports, "MentionType", () => $badcb81cb04dd8d7$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $badcb81cb04dd8d7$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $badcb81cb04dd8d7$export$8436e53e45ffe15b);
$parcel$export(module.exports, "ComponentNames", () => $badcb81cb04dd8d7$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "MentionNameStatus", () => $badcb81cb04dd8d7$export$b8fa67dc54502853);
const $badcb81cb04dd8d7$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $badcb81cb04dd8d7$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $badcb81cb04dd8d7$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $badcb81cb04dd8d7$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $badcb81cb04dd8d7$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $badcb81cb04dd8d7$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $badcb81cb04dd8d7$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $badcb81cb04dd8d7$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});

});

parcelRegister("dLOrv", function(module, exports) {
$parcel$export(module.exports, "getUrlForDomainInContext", () => $b5eaa4d6f55df694$export$c162de1e7fecc908);

var $73S6P = parcelRequire("73S6P");
function $b5eaa4d6f55df694$export$c162de1e7fecc908(subdomain, envType) {
    var _globalThis$location;
    const domain = (0, $73S6P.getDomainInContext)(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.protocol) ?? 'https:'}//${domain}`;
}

});
parcelRegister("73S6P", function(module, exports) {
$parcel$export(module.exports, "getDomainInContext", () => $9c37b6d2b735575e$export$3f82b86ecb947bf0);

var $1GOV7 = parcelRequire("1GOV7");

var $dFAlL = parcelRequire("dFAlL");

var $kBNKa = parcelRequire("kBNKa");

var $7bgvS = parcelRequire("7bgvS");

var $jKzBk = parcelRequire("jKzBk");

var $eqcsk = parcelRequire("eqcsk");
function $9c37b6d2b735575e$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $eqcsk.isolatedCloudFunctions)[perimeter];
    if ((0, $eqcsk.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $eqcsk.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
function $9c37b6d2b735575e$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    var _fullDomainOverride$s;
    // First, check if the subdomain is associated with a global domain
    if ((0, $kBNKa.globalDomains)[subdomain]) return (0, $kBNKa.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (_fullDomainOverride$s = (0, $dFAlL.fullDomainOverride)[subdomain]) === null || _fullDomainOverride$s === void 0 || (_fullDomainOverride$s = _fullDomainOverride$s[perimeter]) === null || _fullDomainOverride$s === void 0 ? void 0 : _fullDomainOverride$s[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $eqcsk.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $9c37b6d2b735575e$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $7bgvS.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $jKzBk.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $9c37b6d2b735575e$var$getDomainForIsolatedCloud(subdomain, (0, $1GOV7.COMMERCIAL), domain);
    }
    return $9c37b6d2b735575e$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}

});
parcelRegister("dFAlL", function(module, exports) {
$parcel$export(module.exports, "fullDomainOverride", () => $d4c7ee4040d8a2d2$export$4723232b625f823e);

var $1GOV7 = parcelRequire("1GOV7");
const $d4c7ee4040d8a2d2$export$4723232b625f823e = {
    id: {
        [(0, $1GOV7.COMMERCIAL)]: {
            [(0, $1GOV7.PRODUCTION)]: 'id.atlassian.com',
            [(0, $1GOV7.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $1GOV7.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $1GOV7.FEDRAMP_MODERATE)]: {
            [(0, $1GOV7.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $1GOV7.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};

});

parcelRegister("kBNKa", function(module, exports) {
$parcel$export(module.exports, "globalDomains", () => $20c9ad2287efdbb5$export$cfd430a73d68f4bc);
const $20c9ad2287efdbb5$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    // Atlassian design system documentation
    design: 'design.atlassian.com',
    // Atlassian design system documentation
    extranet: 'extranet.atlassian.com',
    // Old staff intranet (now hello.atlassian.net)
    go: 'go.atlassian.com',
    // Go links
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    // WAC CDN links
    integrations: 'integrations.atlassian.com',
    // Integrations links
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};

});

parcelRegister("7bgvS", function(module, exports) {
$parcel$export(module.exports, "cloudEnvironment", () => $b4026bf24b499987$export$9e04105551ffc5c4);

var $1GOV7 = parcelRequire("1GOV7");

var $8HGg3 = parcelRequire("8HGg3");

var $5GrQ1 = parcelRequire("5GrQ1");
function $b4026bf24b499987$var$cloudEnvironmentSsrLookup() {
    var _globalThis$ssrContex, _globalThis$ssrContex2;
    // @ts-ignore
    if (((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInIC) === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $1GOV7.COMMERCIAL)
    };
    // @ts-ignore
    if (((_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $1GOV7.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $1GOV7.COMMERCIAL)
    };
}
function $b4026bf24b499987$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $5GrQ1.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $1GOV7.COMMERCIAL)
    };
    const isIc = (0, $8HGg3.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $1GOV7.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $1GOV7.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $1GOV7.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}
function $b4026bf24b499987$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $b4026bf24b499987$var$cloudEnvironmentSsrLookup();
    return $b4026bf24b499987$var$cloudEnvironmentCookieLookup();
}

});

parcelRegister("eqcsk", function(module, exports) {
$parcel$export(module.exports, "ReservedNameMapping", () => $6270444cd1fbe5e6$export$5860df3acd1ee020);
$parcel$export(module.exports, "AtlDomainMapping", () => $6270444cd1fbe5e6$export$c6366754aee43afa);
$parcel$export(module.exports, "isolatedCloudFunctions", () => $6270444cd1fbe5e6$export$ad1f7afdb45ad83);
$parcel$export(module.exports, "nonIsolatedCloudFunctions", () => $6270444cd1fbe5e6$export$c3b4bc58a05128d6);

var $1GOV7 = parcelRequire("1GOV7");
const $6270444cd1fbe5e6$export$5860df3acd1ee020 = {
    [(0, $1GOV7.COMMERCIAL)]: [
        'home',
        'team',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $6270444cd1fbe5e6$export$c6366754aee43afa = {
    [(0, $1GOV7.COMMERCIAL)]: [
        'packages'
    ]
};
const $6270444cd1fbe5e6$export$ad1f7afdb45ad83 = {
    [(0, $1GOV7.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $6270444cd1fbe5e6$export$c3b4bc58a05128d6 = {
    [(0, $1GOV7.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $1GOV7.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $1GOV7.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $1GOV7.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $1GOV7.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $1GOV7.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $1GOV7.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};

});



parcelRegister("iosNh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eaee527b5a9128134f2f3ecac1b0a289>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d640cdb8a44aef9a$var$_react = $d640cdb8a44aef9a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d640cdb8a44aef9a$var$_iconNew = $d640cdb8a44aef9a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d640cdb8a44aef9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/information-circle
 * Usage guidance:
 * Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d640cdb8a44aef9a$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $d640cdb8a44aef9a$var$_react.default.createElement($d640cdb8a44aef9a$var$_iconNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d640cdb8a44aef9a$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $d640cdb8a44aef9a$var$_default = module.exports.default = $d640cdb8a44aef9a$var$InformationCircleIcon;

});

parcelRegister("cQ3ZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $958d7052aab502f9$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $g88li = parcelRequire("g88li");

var $jAkEQ = parcelRequire("jAkEQ");

var $OPOsJ = parcelRequire("OPOsJ");

var $6e6mu = parcelRequire("6e6mu");
function $958d7052aab502f9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $OPOsJ.default)(2, arguments);
    var dateLeft = (0, $897M5.default)(dirtyDateLeft);
    var dateRight = (0, $897M5.default)(dirtyDateRight);
    var sign = (0, $jAkEQ.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $g88li.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $jAkEQ.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $6e6mu.default)((0, $897M5.default)(dirtyDateLeft)) && difference === 1 && (0, $jAkEQ.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("g88li", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbe3dd52abfa4ff1$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $bbe3dd52abfa4ff1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $OPOsJ.default)(2, arguments);
    var dateLeft = (0, $897M5.default)(dirtyDateLeft);
    var dateRight = (0, $897M5.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("jAkEQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e421675515bc4673$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $e421675515bc4673$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $OPOsJ.default)(2, arguments);
    var dateLeft = (0, $897M5.default)(dirtyDateLeft);
    var dateRight = (0, $897M5.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});


parcelRegister("hLX8u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58a0b7e350797ce13f4ff95adc3c91f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf04b29834b88fca$var$_react = $cf04b29834b88fca$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cf04b29834b88fca$var$_iconNew = $cf04b29834b88fca$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cf04b29834b88fca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/email
 * Usage guidance:
 * Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf04b29834b88fca$var$EmailIcon = (props)=>/*#__PURE__*/ $cf04b29834b88fca$var$_react.default.createElement($cf04b29834b88fca$var$_iconNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$cf04b29834b88fca$var$EmailIcon.displayName = 'EmailIcon';
var $cf04b29834b88fca$var$_default = module.exports.default = $cf04b29834b88fca$var$EmailIcon;

});

parcelRegister("eYObu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4ae62e142a249651$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $4ae62e142a249651$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $4ae62e142a249651$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $4ae62e142a249651$export$c67faf67c1185cba);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $f0Pt4 = parcelRequire("f0Pt4");

var $5bbjm = parcelRequire("5bbjm");
function $4ae62e142a249651$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4ae62e142a249651$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    loading: {
        id: 'fabric.editor.expand.loading',
        defaultMessage: 'Loading...',
        description: 'Text shown inside an expand node while its content is being loaded, indicating to the user that data is still being fetched.'
    },
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'The text is shown as a tooltip on a button when the user clicks to collapse an expand node in the editor, hiding its content.'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text shown in the title field of an expand node when no title has been entered, prompting the user to click and expand the content.'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'The text is shown as a tooltip on a button when the user clicks to expand a collapsed expand node in the editor, revealing its content.'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    },
    expandArialabel: {
        id: 'fabric.editor.expandAriaLabel',
        defaultMessage: 'Give this expand a title',
        description: 'aria label for an expand node title input field'
    },
    // Clean up with platform_editor_expand_content_a11y_2.
    expandBodyAriaLabelOriginal: {
        id: 'fabric.editor.expandBodyAriaLabel',
        defaultMessage: 'Expand body content',
        description: 'Aria label for the body content of an expand node'
    },
    expandBodyAriaLabel: {
        id: 'editor-common.Expand.expandBodyAriaLabel',
        defaultMessage: 'Body content for {title}',
        description: 'Aria label for the body content of an expand node'
    },
    expandBodyAriaLabelUntitled: {
        id: 'editor-common.Expand.expandBodyAriaLabelUntitled',
        defaultMessage: 'untitled expand',
        description: 'Fallback title for the body content of an expand node without a title'
    },
    expandBodyAriaDescription: {
        id: 'fabric.editor.expandBodyAriaDescription',
        defaultMessage: 'Enter the content that will be revealed when this expand is opened.',
        description: 'Aria description for the body content of an expand node'
    },
    expandBodyRoleDescription: {
        id: 'fabric.editor.expandBodyRoleDescription',
        defaultMessage: 'macro',
        description: 'Aria role description for the body content of an expand node'
    }
});
const $4ae62e142a249651$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: ()=>expanded ? [
                $4ae62e142a249651$var$expandIconWrapperStyle(),
                $4ae62e142a249651$var$expandIconWrapperExpandedStyle
            ] : $4ae62e142a249651$var$expandIconWrapperStyle()
    }, children);
};
const $4ae62e142a249651$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $9dQre.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $5bbjm.akEditorSwoopCubicBezier)}`
        }
    });
const $4ae62e142a249651$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4ae62e142a249651$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4ae62e142a249651$export$c67faf67c1185cba = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4ae62e142a249651$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});

});

parcelRegister("iPH47", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ff8ab7e1427737ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $emsU2 = parcelRequire("emsU2");

var $4ENS3 = parcelRequire("4ENS3");
function $ff8ab7e1427737ab$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ENS3.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($emsU2))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("dLQt5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::572305b998c439047b1ac624fa78e28b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0685d3978ad518a$var$_react = $a0685d3978ad518a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a0685d3978ad518a$var$_iconNew = $a0685d3978ad518a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a0685d3978ad518a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/whiteboard
 * Usage guidance:
 * Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0685d3978ad518a$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $a0685d3978ad518a$var$_react.default.createElement($a0685d3978ad518a$var$_iconNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$a0685d3978ad518a$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $a0685d3978ad518a$var$_default = module.exports.default = $a0685d3978ad518a$var$WhiteboardIcon;

});

parcelRegister("gKziX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab7816171fed87d9a608211bee0e0796>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c31c5407f51f8045$var$_react = $c31c5407f51f8045$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c31c5407f51f8045$var$_iconNew = $c31c5407f51f8045$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c31c5407f51f8045$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-center
 * Usage guidance:
 * Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c31c5407f51f8045$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $c31c5407f51f8045$var$_react.default.createElement($c31c5407f51f8045$var$_iconNew.default, Object.assign({
        name: "AlignTextCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 3.5H4V2h8zm3 5.25H1v-1.5h14zM12 14H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$c31c5407f51f8045$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIcon';
var $c31c5407f51f8045$var$_default = module.exports.default = $c31c5407f51f8045$var$AlignTextCenterIcon;

});

parcelRegister("i7u95", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a36c3184c18665c26dfb7db95698b9af>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d31043bb67764d4e$var$_react = $d31043bb67764d4e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d31043bb67764d4e$var$_iconNew = $d31043bb67764d4e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d31043bb67764d4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-right
 * Usage guidance:
 * Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d31043bb67764d4e$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $d31043bb67764d4e$var$_react.default.createElement($d31043bb67764d4e$var$_iconNew.default, Object.assign({
        name: "AlignTextRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H8v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$d31043bb67764d4e$var$AlignTextRightIcon.displayName = 'AlignTextRightIcon';
var $d31043bb67764d4e$var$_default = module.exports.default = $d31043bb67764d4e$var$AlignTextRightIcon;

});

parcelRegister("btTAJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7e789de9ffb828a5785c4954dbfb813>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85bd866dfc57fc29$var$_react = $85bd866dfc57fc29$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $85bd866dfc57fc29$var$_iconNew = $85bd866dfc57fc29$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $85bd866dfc57fc29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-center
 * Usage guidance:
 * Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85bd866dfc57fc29$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $85bd866dfc57fc29$var$_react.default.createElement($85bd866dfc57fc29$var$_iconNew.default, Object.assign({
        name: "AlignImageCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$85bd866dfc57fc29$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $85bd866dfc57fc29$var$_default = module.exports.default = $85bd866dfc57fc29$var$AlignImageCenterIcon;

});

parcelRegister("7VT7s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f0dc0e9a1d8ab9bc4e6a31098b6f2fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c689cd4c62f96cf$var$_react = $5c689cd4c62f96cf$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5c689cd4c62f96cf$var$_iconNew = $5c689cd4c62f96cf$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5c689cd4c62f96cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-left
 * Usage guidance:
 * Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c689cd4c62f96cf$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $5c689cd4c62f96cf$var$_react.default.createElement($5c689cd4c62f96cf$var$_iconNew.default, Object.assign({
        name: "AlignImageLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$5c689cd4c62f96cf$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $5c689cd4c62f96cf$var$_default = module.exports.default = $5c689cd4c62f96cf$var$AlignImageLeftIcon;

});

parcelRegister("7rvQD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::363ad103c09d1ad4a29a90276bbc91d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56b3c25a9732e1a1$var$_react = $56b3c25a9732e1a1$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $56b3c25a9732e1a1$var$_iconNew = $56b3c25a9732e1a1$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $56b3c25a9732e1a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-right
 * Usage guidance:
 * Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56b3c25a9732e1a1$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $56b3c25a9732e1a1$var$_react.default.createElement($56b3c25a9732e1a1$var$_iconNew.default, Object.assign({
        name: "AlignImageRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$56b3c25a9732e1a1$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $56b3c25a9732e1a1$var$_default = module.exports.default = $56b3c25a9732e1a1$var$AlignImageRightIcon;

});

parcelRegister("lBdWm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f38f1db86e7b7e5a1df46515f47bbd95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb97dde956e334f3$var$_react = $fb97dde956e334f3$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $fb97dde956e334f3$var$_iconNew = $fb97dde956e334f3$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $fb97dde956e334f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/paint-bucket
 * Usage guidance:
 * Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb97dde956e334f3$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $fb97dde956e334f3$var$_react.default.createElement($fb97dde956e334f3$var$_iconNew.default, Object.assign({
        name: "PaintBucketIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 1.94 6.78.66A1.38 1.38 0 0 1 8.62.57l.11.09 5.62 5.62a1.38 1.38 0 0 1 0 1.95l-5.73 5.73a2.63 2.63 0 0 1-3.71 0l-3.85-3.85a2.63 2.63 0 0 1 0-3.71L4.44 3 2.6 1.15 3.66.09zM1.81 8.5c.05.2.14.39.3.55l3.85 3.85c.44.44 1.15.44 1.59 0l4.39-4.39zM6.57 3l1.22 1.22-1.06 1.06L5.5 4.06 2.56 7h10.38L7.75 1.81zm7.68 8.25c.27 0 .52.14.65.38v.01l.01.02.03.06.12.21c.1.18.23.42.36.68s.27.55.37.82c.09.23.21.56.21.86 0 .97-.8 1.73-1.75 1.73s-1.75-.75-1.75-1.72c0-.29.12-.63.21-.86.11-.27.24-.56.37-.82s.26-.5.36-.68l.12-.21.03-.06.01-.02v-.01a.75.75 0 0 1 .65-.38"/>`
    }, props));
$fb97dde956e334f3$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $fb97dde956e334f3$var$_default = module.exports.default = $fb97dde956e334f3$var$PaintBucketIcon;

});

parcelRegister("dY4yK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd19492838c8bf6d2562d3c6e1f4b1c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2b46a62b57ce061$var$_react = $a2b46a62b57ce061$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a2b46a62b57ce061$var$_iconNew = $a2b46a62b57ce061$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a2b46a62b57ce061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-bold
 * Usage guidance:
 * Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2b46a62b57ce061$var$TextBoldIcon = (props)=>/*#__PURE__*/ $a2b46a62b57ce061$var$_react.default.createElement($a2b46a62b57ce061$var$_iconNew.default, Object.assign({
        name: "TextBoldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.125C3 1.504 3.504 1 4.125 1H8.75C11.004 1 13 2.626 13 5.063a3.93 3.93 0 0 1-.855 2.492A3.92 3.92 0 0 1 14 10.938C14 13.374 12.004 15 9.75 15H4.125A1.125 1.125 0 0 1 3 13.875zm5.75 4.75c1.198 0 2-.798 2-1.812s-.802-1.813-2-1.813h-3.5v3.625zm-3.5 2.25h4.5c1.198 0 2 .798 2 1.813s-.802 1.812-2 1.812h-4.5z" clip-rule="evenodd"/>`
    }, props));
$a2b46a62b57ce061$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $a2b46a62b57ce061$var$_default = module.exports.default = $a2b46a62b57ce061$var$TextBoldIcon;

});

parcelRegister("4PSAV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c78712d633a3463bd40c9b97dadf0e09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3856463110c4cc53$var$_react = $3856463110c4cc53$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3856463110c4cc53$var$_iconNew = $3856463110c4cc53$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3856463110c4cc53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shrink-horizontal
 * Usage guidance:
 * Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3856463110c4cc53$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $3856463110c4cc53$var$_react.default.createElement($3856463110c4cc53$var$_iconNew.default, Object.assign({
        name: "ShrinkHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$3856463110c4cc53$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $3856463110c4cc53$var$_default = module.exports.default = $3856463110c4cc53$var$ShrinkHorizontalIcon;

});

parcelRegister("fuLqG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f554af16de9998b4fc80f1fde7a03b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b47e72d7bbcdc7ce$var$_react = $b47e72d7bbcdc7ce$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $b47e72d7bbcdc7ce$var$_iconNew = $b47e72d7bbcdc7ce$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $b47e72d7bbcdc7ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-horizontal
 * Usage guidance:
 * Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b47e72d7bbcdc7ce$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $b47e72d7bbcdc7ce$var$_react.default.createElement($b47e72d7bbcdc7ce$var$_iconNew.default, Object.assign({
        name: "GrowHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$b47e72d7bbcdc7ce$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $b47e72d7bbcdc7ce$var$_default = module.exports.default = $b47e72d7bbcdc7ce$var$GrowHorizontalIcon;

});

parcelRegister("eNuIV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57bb91851f2608c878b3bf5cfef0f2ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac5d7957af0159dc$var$_react = $ac5d7957af0159dc$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $ac5d7957af0159dc$var$_iconNew = $ac5d7957af0159dc$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $ac5d7957af0159dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Maximize".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/maximize
 * Usage guidance:
 * Single purpose - Reserved for resizing screens, panels, modals, or media to its maximum size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac5d7957af0159dc$var$MaximizeIcon = (props)=>/*#__PURE__*/ $ac5d7957af0159dc$var$_react.default.createElement($ac5d7957af0159dc$var$_iconNew.default, Object.assign({
        name: "MaximizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zm-2-.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM8 4H4.75a.75.75 0 0 0-.75.75V8h1.5V5.5H8zm2.5 6.5V8H12v3.25a.75.75 0 0 1-.75.75H8v-1.5z" clip-rule="evenodd"/>`
    }, props));
$ac5d7957af0159dc$var$MaximizeIcon.displayName = 'MaximizeIcon';
var $ac5d7957af0159dc$var$_default = module.exports.default = $ac5d7957af0159dc$var$MaximizeIcon;

});

parcelRegister("7jCvB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c2370ad8f2d629cac1adc2a88058b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55382dc2ea4f91e2$var$_react = $55382dc2ea4f91e2$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $55382dc2ea4f91e2$var$_iconNew = $55382dc2ea4f91e2$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $55382dc2ea4f91e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-right
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55382dc2ea4f91e2$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $55382dc2ea4f91e2$var$_react.default.createElement($55382dc2ea4f91e2$var$_iconNew.default, Object.assign({
        name: "TextIndentRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.03 4.72l2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L3.19 8 .97 5.78zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zm0 2.667V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$55382dc2ea4f91e2$var$TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var $55382dc2ea4f91e2$var$_default = module.exports.default = $55382dc2ea4f91e2$var$TextIndentRightIcon;

});

parcelRegister("ktWlR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::266cfa8a244e6a03d3f71862db1654df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee93c77fa95be879$var$_react = $ee93c77fa95be879$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $ee93c77fa95be879$var$_iconNew = $ee93c77fa95be879$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $ee93c77fa95be879$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-italic
 * Usage guidance:
 * Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee93c77fa95be879$var$TextItalicIcon = (props)=>/*#__PURE__*/ $ee93c77fa95be879$var$_react.default.createElement($ee93c77fa95be879$var$_iconNew.default, Object.assign({
        name: "TextItalicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h6.5v1.5h-2.409l-2.64 11H10V15H3.5v-1.5h2.409l2.64-11H6z" clip-rule="evenodd"/>`
    }, props));
$ee93c77fa95be879$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $ee93c77fa95be879$var$_default = module.exports.default = $ee93c77fa95be879$var$TextItalicIcon;

});

parcelRegister("hu0T0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a646c20da4c58fe32e3018bb3269735d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cba5ecfc66bd087c$var$_react = $cba5ecfc66bd087c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cba5ecfc66bd087c$var$_iconNew = $cba5ecfc66bd087c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cba5ecfc66bd087c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-one-column
 * Usage guidance:
 * Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cba5ecfc66bd087c$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $cba5ecfc66bd087c$var$_react.default.createElement($cba5ecfc66bd087c$var$_iconNew.default, Object.assign({
        name: "LayoutOneColumnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h13.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 15 0 14.384 0 13.625zm1.5.125v11h13v-11z" clip-rule="evenodd"/>`
    }, props));
$cba5ecfc66bd087c$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $cba5ecfc66bd087c$var$_default = module.exports.default = $cba5ecfc66bd087c$var$LayoutOneColumnIcon;

});

parcelRegister("9urRz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c93698a16267611d6fb579c008d00c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e8c8768d5ae94d6$var$_react = $6e8c8768d5ae94d6$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6e8c8768d5ae94d6$var$_iconNew = $6e8c8768d5ae94d6$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6e8c8768d5ae94d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-three-columns
 * Usage guidance:
 * Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e8c8768d5ae94d6$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $6e8c8768d5ae94d6$var$_react.default.createElement($6e8c8768d5ae94d6$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$6e8c8768d5ae94d6$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $6e8c8768d5ae94d6$var$_default = module.exports.default = $6e8c8768d5ae94d6$var$LayoutThreeColumnsIcon;

});

parcelRegister("bSDtt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a2ebfcfec4a83dd52309bf27259f43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a635ba4adbb5105$var$_react = $8a635ba4adbb5105$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8a635ba4adbb5105$var$_iconNew = $8a635ba4adbb5105$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8a635ba4adbb5105$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebars".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-three-columns-sidebars
 * Usage guidance:
 * Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a635ba4adbb5105$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $8a635ba4adbb5105$var$_react.default.createElement($8a635ba4adbb5105$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h3.25C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 15 5 14.384 5 13.625zm1.5.125v11h3v-11zm6-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$8a635ba4adbb5105$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIcon';
var $8a635ba4adbb5105$var$_default = module.exports.default = $8a635ba4adbb5105$var$LayoutThreeColumnsSidebarsIcon;

});

parcelRegister("9ej3u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27a7fabc1fabdcec8784e5ae291a6333>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b8433dea5bc9596$var$_react = $6b8433dea5bc9596$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6b8433dea5bc9596$var$_iconNew = $6b8433dea5bc9596$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6b8433dea5bc9596$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b8433dea5bc9596$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $6b8433dea5bc9596$var$_react.default.createElement($6b8433dea5bc9596$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$6b8433dea5bc9596$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $6b8433dea5bc9596$var$_default = module.exports.default = $6b8433dea5bc9596$var$LayoutTwoColumnsIcon;

});

parcelRegister("gG5nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7426eac0679209b584652b7cacb52d34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c244bf0f09fde023$var$_react = $c244bf0f09fde023$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $c244bf0f09fde023$var$_iconNew = $c244bf0f09fde023$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $c244bf0f09fde023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns-sidebar-left
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c244bf0f09fde023$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $c244bf0f09fde023$var$_react.default.createElement($c244bf0f09fde023$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$c244bf0f09fde023$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $c244bf0f09fde023$var$_default = module.exports.default = $c244bf0f09fde023$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("2Ar87", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::016771fe6116559afc90969f7cd64cf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e23fd034701a791$var$_react = $1e23fd034701a791$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $1e23fd034701a791$var$_iconNew = $1e23fd034701a791$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $1e23fd034701a791$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns-sidebar-right
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e23fd034701a791$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $1e23fd034701a791$var$_react.default.createElement($1e23fd034701a791$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h7.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-7.75C.615 15 0 14.384 0 13.625zm1.5.125v11H9v-11zM12 2.375C12 1.615 12.616 1 13.375 1h1.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1v-11z" clip-rule="evenodd"/>`
    }, props));
$1e23fd034701a791$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $1e23fd034701a791$var$_default = module.exports.default = $1e23fd034701a791$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("bgqD7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f30f1ece100e9c6940f39e1796a26132>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8335d879c3172d0e$var$_react = $8335d879c3172d0e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8335d879c3172d0e$var$_iconNew = $8335d879c3172d0e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8335d879c3172d0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthNarrow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-width-narrow
 * Usage guidance:
 * Single purpose - Reserved for setting media and content to a narrow width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8335d879c3172d0e$var$ContentWidthNarrowIcon = (props)=>/*#__PURE__*/ $8335d879c3172d0e$var$_react.default.createElement($8335d879c3172d0e$var$_iconNew.default, Object.assign({
        name: "ContentWidthNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5H2V1h12zm-10.5 3v5h9v-5zM3.375 4h9.25C13.385 4 14 4.616 14 5.375v5.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 12 2 11.384 2 10.625v-5.25C2 4.615 2.616 4 3.375 4M14 15H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$8335d879c3172d0e$var$ContentWidthNarrowIcon.displayName = 'ContentWidthNarrowIcon';
var $8335d879c3172d0e$var$_default = module.exports.default = $8335d879c3172d0e$var$ContentWidthNarrowIcon;

});

parcelRegister("l94df", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb735195a4450dbae1bbcfc30fb20c7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f64db4c927d5e961$var$_react = $f64db4c927d5e961$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f64db4c927d5e961$var$_iconNew = $f64db4c927d5e961$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f64db4c927d5e961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/expand-horizontal
 * Usage guidance:
 * Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f64db4c927d5e961$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $f64db4c927d5e961$var$_react.default.createElement($f64db4c927d5e961$var$_iconNew.default, Object.assign({
        name: "ExpandHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 1v14H0V1zM16 1v14h-1.5V1zm-1.72 6.47a.75.75 0 0 1 0 1.06l-3.25 3.25-1.06-1.06 1.97-1.97H4.06l1.97 1.97-1.06 1.06-3.25-3.25a.75.75 0 0 1 0-1.06l3.25-3.25 1.06 1.06-1.97 1.97h7.88L9.97 5.28l1.06-1.06z"/>`
    }, props));
$f64db4c927d5e961$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $f64db4c927d5e961$var$_default = module.exports.default = $f64db4c927d5e961$var$ExpandHorizontalIcon;

});

parcelRegister("ebcTd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b906b7c624205e45ee60c81e60477bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a52c175d8c5d0e2d$var$_react = $a52c175d8c5d0e2d$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a52c175d8c5d0e2d$var$_iconNew = $a52c175d8c5d0e2d$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a52c175d8c5d0e2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-width-wide
 * Usage guidance:
 * Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a52c175d8c5d0e2d$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $a52c175d8c5d0e2d$var$_react.default.createElement($a52c175d8c5d0e2d$var$_iconNew.default, Object.assign({
        name: "ContentWidthWideIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$a52c175d8c5d0e2d$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $a52c175d8c5d0e2d$var$_default = module.exports.default = $a52c175d8c5d0e2d$var$ContentWidthWideIcon;

});

parcelRegister("4S97w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b4cab910924222021336600cfef472b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38c347a8439dc23e$var$_react = $38c347a8439dc23e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $38c347a8439dc23e$var$_iconNew = $38c347a8439dc23e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $38c347a8439dc23e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-wrap-left
 * Usage guidance:
 * Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38c347a8439dc23e$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $38c347a8439dc23e$var$_react.default.createElement($38c347a8439dc23e$var$_iconNew.default, Object.assign({
        name: "ContentWrapLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$38c347a8439dc23e$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $38c347a8439dc23e$var$_default = module.exports.default = $38c347a8439dc23e$var$ContentWrapLeftIcon;

});

parcelRegister("4wMHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef7c6107d1b27b47b5ef786d5a90cbe7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34bfee7f692a73a5$var$_react = $34bfee7f692a73a5$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $34bfee7f692a73a5$var$_iconNew = $34bfee7f692a73a5$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $34bfee7f692a73a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-wrap-right
 * Usage guidance:
 * Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34bfee7f692a73a5$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $34bfee7f692a73a5$var$_react.default.createElement($34bfee7f692a73a5$var$_iconNew.default, Object.assign({
        name: "ContentWrapRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M7 6.667H1v-1.5h6zm0 4.166H1v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$34bfee7f692a73a5$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $34bfee7f692a73a5$var$_default = module.exports.default = $34bfee7f692a73a5$var$ContentWrapRightIcon;

});

parcelRegister("73atK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce6a9824d35ee82505b8acded17c6ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5220f11800106311$var$_react = $5220f11800106311$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5220f11800106311$var$_iconNew = $5220f11800106311$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5220f11800106311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/mention
 * Usage guidance:
 * Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5220f11800106311$var$MentionIcon = (props)=>/*#__PURE__*/ $5220f11800106311$var$_react.default.createElement($5220f11800106311$var$_iconNew.default, Object.assign({
        name: "MentionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$5220f11800106311$var$MentionIcon.displayName = 'MentionIcon';
var $5220f11800106311$var$_default = module.exports.default = $5220f11800106311$var$MentionIcon;

});

parcelRegister("3aSEM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb0d2797cf5666e2287eff3bcf39de93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24fcb3f509f695df$var$_react = $24fcb3f509f695df$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $24fcb3f509f695df$var$_iconNew = $24fcb3f509f695df$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $24fcb3f509f695df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-numbered
 * Usage guidance:
 * Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24fcb3f509f695df$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $24fcb3f509f695df$var$_react.default.createElement($24fcb3f509f695df$var$_iconNew.default, Object.assign({
        name: "ListNumberedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 5H6V3.5h10zm0 7.5H6V11h10zM.5 1h1.75a.75.75 0 0 1 .75.75V7H1.5V2.5h-1zM0 8.5h2.63C3.39 8.5 4 9.12 4 9.88v1.25c0 .76-.62 1.38-1.37 1.38H1.5v1H4V15H.75a.75.75 0 0 1-.75-.75v-1.87C0 11.62.62 11 1.38 11H2.5v-1H0z" clip-rule="evenodd"/>`
    }, props));
$24fcb3f509f695df$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $24fcb3f509f695df$var$_default = module.exports.default = $24fcb3f509f695df$var$ListNumberedIcon;

});

parcelRegister("bPSDe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cfb509a7f1979b2b736fe67208d0bad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89ded5e1d29c7e04$var$_react = $89ded5e1d29c7e04$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $89ded5e1d29c7e04$var$_iconNew = $89ded5e1d29c7e04$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $89ded5e1d29c7e04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-left
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89ded5e1d29c7e04$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $89ded5e1d29c7e04$var$_react.default.createElement($89ded5e1d29c7e04$var$_iconNew.default, Object.assign({
        name: "TextIndentLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.81 8l2.22-2.22-1.06-1.06-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75 1.06-1.06zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$89ded5e1d29c7e04$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $89ded5e1d29c7e04$var$_default = module.exports.default = $89ded5e1d29c7e04$var$TextIndentLeftIcon;

});

parcelRegister("b9Jhn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e06a4b64daf6b9c430eec634bed57c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81f3a8791f6f3cd5$var$_react = $81f3a8791f6f3cd5$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $81f3a8791f6f3cd5$var$_iconNew = $81f3a8791f6f3cd5$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $81f3a8791f6f3cd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/redo
 * Usage guidance:
 * Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81f3a8791f6f3cd5$var$RedoIcon = (props)=>/*#__PURE__*/ $81f3a8791f6f3cd5$var$_react.default.createElement($81f3a8791f6f3cd5$var$_iconNew.default, Object.assign({
        name: "RedoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 0 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$81f3a8791f6f3cd5$var$RedoIcon.displayName = 'RedoIcon';
var $81f3a8791f6f3cd5$var$_default = module.exports.default = $81f3a8791f6f3cd5$var$RedoIcon;

});

parcelRegister("jFqMV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b80b485d8f3151e8a189e7a1ca0b045>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e516a038b78cfa5c$var$_react = $e516a038b78cfa5c$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e516a038b78cfa5c$var$_iconNew = $e516a038b78cfa5c$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e516a038b78cfa5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/grid
 * Usage guidance:
 * Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e516a038b78cfa5c$var$GridIcon = (props)=>/*#__PURE__*/ $e516a038b78cfa5c$var$_react.default.createElement($e516a038b78cfa5c$var$_iconNew.default, Object.assign({
        name: "GridIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$e516a038b78cfa5c$var$GridIcon.displayName = 'GridIcon';
var $e516a038b78cfa5c$var$_default = module.exports.default = $e516a038b78cfa5c$var$GridIcon;

});

parcelRegister("aBl4O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0812cf7af63b42bd3bd830103e378223>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b7db57762cc2256$var$_react = $7b7db57762cc2256$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $7b7db57762cc2256$var$_iconNew = $7b7db57762cc2256$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $7b7db57762cc2256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-style
 * Usage guidance:
 * Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b7db57762cc2256$var$TextStyleIcon = (props)=>/*#__PURE__*/ $7b7db57762cc2256$var$_react.default.createElement($7b7db57762cc2256$var$_iconNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$7b7db57762cc2256$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $7b7db57762cc2256$var$_default = module.exports.default = $7b7db57762cc2256$var$TextStyleIcon;

});

parcelRegister("uBKNk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::135f4c7bdbceeb077cf9a8a8ded75f12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05c01690c60fe02e$var$_react = $05c01690c60fe02e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $05c01690c60fe02e$var$_iconNew = $05c01690c60fe02e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $05c01690c60fe02e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/undo
 * Usage guidance:
 * Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05c01690c60fe02e$var$UndoIcon = (props)=>/*#__PURE__*/ $05c01690c60fe02e$var$_react.default.createElement($05c01690c60fe02e$var$_iconNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$05c01690c60fe02e$var$UndoIcon.displayName = 'UndoIcon';
var $05c01690c60fe02e$var$_default = module.exports.default = $05c01690c60fe02e$var$UndoIcon;

});

parcelRegister("2rvGO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d45545d418279a0953f605b02a0f6e7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c76af490de160e3$var$_react = $1c76af490de160e3$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $1c76af490de160e3$var$_iconNew = $1c76af490de160e3$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $1c76af490de160e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-items
 * Usage guidance:
 * Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c76af490de160e3$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $1c76af490de160e3$var$_react.default.createElement($1c76af490de160e3$var$_iconNew.default, Object.assign({
        name: "WorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$1c76af490de160e3$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $1c76af490de160e3$var$_default = module.exports.default = $1c76af490de160e3$var$WorkItemsIcon;

});

parcelRegister("5Mni1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f8dcfcce24cb1cbca3bd0f7d9ea3784>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435380479106cc80$var$_react = $435380479106cc80$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $435380479106cc80$var$_iconNew = $435380479106cc80$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $435380479106cc80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-small
 * Usage guidance:
 * Reserved for representing thin border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435380479106cc80$var$StrokeWeightSmallIcon = (props)=>/*#__PURE__*/ $435380479106cc80$var$_react.default.createElement($435380479106cc80$var$_iconNew.default, Object.assign({
        name: "StrokeWeightSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0" clip-rule="evenodd"/>`
    }, props));
$435380479106cc80$var$StrokeWeightSmallIcon.displayName = 'StrokeWeightSmallIcon';
var $435380479106cc80$var$_default = module.exports.default = $435380479106cc80$var$StrokeWeightSmallIcon;

});

parcelRegister("7k37t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a86f4b205ac22b1546889eacd37f769a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $554cd22812818da0$var$_react = $554cd22812818da0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $554cd22812818da0$var$_iconNew = $554cd22812818da0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $554cd22812818da0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-add
 * Usage guidance:
 * Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $554cd22812818da0$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $554cd22812818da0$var$_react.default.createElement($554cd22812818da0$var$_iconNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$554cd22812818da0$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $554cd22812818da0$var$_default = module.exports.default = $554cd22812818da0$var$EmojiAddIcon;

});

parcelRegister("a2cYt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95e148480949ecb8f2215f7268d6e3a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74e427bbda86d49a$var$_react = $74e427bbda86d49a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $74e427bbda86d49a$var$_iconNew = $74e427bbda86d49a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $74e427bbda86d49a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Accessibility".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/accessibility
 * Usage guidance:
 * Reserved for representing accessibility and accessibility-related features and settings
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74e427bbda86d49a$var$AccessibilityIcon = (props)=>/*#__PURE__*/ $74e427bbda86d49a$var$_react.default.createElement($74e427bbda86d49a$var$_iconNew.default, Object.assign({
        name: "AccessibilityIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A.75.75 0 1 0 8 4a.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.77 8H2V6.5h12V8H9.23l3.18 6.16-1.33.69L8 8.88l-3.08 5.96-1.33-.69z" clip-rule="evenodd"/>`
    }, props));
$74e427bbda86d49a$var$AccessibilityIcon.displayName = 'AccessibilityIcon';
var $74e427bbda86d49a$var$_default = module.exports.default = $74e427bbda86d49a$var$AccessibilityIcon;

});

parcelRegister("kNU38", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5d9d22b41ee491811e82fedd8cf80d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f253dc8c32b64401$var$_react = $f253dc8c32b64401$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f253dc8c32b64401$var$_iconNew = $f253dc8c32b64401$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f253dc8c32b64401$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/apps
 * Usage guidance:
 * Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f253dc8c32b64401$var$AppsIcon = (props)=>/*#__PURE__*/ $f253dc8c32b64401$var$_react.default.createElement($f253dc8c32b64401$var$_iconNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$f253dc8c32b64401$var$AppsIcon.displayName = 'AppsIcon';
var $f253dc8c32b64401$var$_default = module.exports.default = $f253dc8c32b64401$var$AppsIcon;

});

parcelRegister("jOW0B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed3e64ddc98c9818e2b632fa43be9778>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6dfaf23e9abd359$var$_react = $e6dfaf23e9abd359$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e6dfaf23e9abd359$var$_iconNew = $e6dfaf23e9abd359$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e6dfaf23e9abd359$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Assets".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/assets
 * Usage guidance:
 * Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6dfaf23e9abd359$var$AssetsIcon = (props)=>/*#__PURE__*/ $e6dfaf23e9abd359$var$_react.default.createElement($e6dfaf23e9abd359$var$_iconNew.default, Object.assign({
        name: "AssetsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.487 2.013a1.75 1.75 0 1 0-2.474 2.474 1.75 1.75 0 0 0 2.474-2.474M.952.952A3.25 3.25 0 0 1 6.412 2.5H9.5V4H6.413a3.24 3.24 0 0 1-.865 1.548c-.442.442-.98.73-1.548.865V9.5H2.5V6.413A3.25 3.25 0 0 1 .952.953M10.5 3.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m3 3.25v3H12v-3zM1 12.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m9.5 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m-1 .75h-3V12h3z" clip-rule="evenodd"/>`
    }, props));
$e6dfaf23e9abd359$var$AssetsIcon.displayName = 'AssetsIcon';
var $e6dfaf23e9abd359$var$_default = module.exports.default = $e6dfaf23e9abd359$var$AssetsIcon;

});

parcelRegister("4jS0J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff136a20504d88688371d92a86f2c77e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3252d5313e51e6ab$var$_react = $3252d5313e51e6ab$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3252d5313e51e6ab$var$_iconNew = $3252d5313e51e6ab$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3252d5313e51e6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Border".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/border
 * Usage guidance:
 * Reserved for toggling the visibility of a border on an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3252d5313e51e6ab$var$BorderIcon = (props)=>/*#__PURE__*/ $3252d5313e51e6ab$var$_react.default.createElement($3252d5313e51e6ab$var$_iconNew.default, Object.assign({
        name: "BorderIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 8A.75.75 0 1 1 4 8a.75.75 0 0 1 1.5 0M12 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 12 8m-3.25 3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0-6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$3252d5313e51e6ab$var$BorderIcon.displayName = 'BorderIcon';
var $3252d5313e51e6ab$var$_default = module.exports.default = $3252d5313e51e6ab$var$BorderIcon;

});

parcelRegister("1BhEG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da700306fe9346a3fbf34e0d7fc8a9b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a6f1136d495aac$var$_react = $12a6f1136d495aac$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $12a6f1136d495aac$var$_iconNew = $12a6f1136d495aac$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $12a6f1136d495aac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Card".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/card
 * Usage guidance:
 * Known uses: Representing cards in Trello. Toggling card detail in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12a6f1136d495aac$var$CardIcon = (props)=>/*#__PURE__*/ $12a6f1136d495aac$var$_react.default.createElement($12a6f1136d495aac$var$_iconNew.default, Object.assign({
        name: "CardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V9h11v4a.5.5 0 0 1-.5.5zm10.5-6h-11V3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5zM4 12h5v-1.5H4zm6.5 0H12v-1.5h-1.5z" clip-rule="evenodd"/>`
    }, props));
$12a6f1136d495aac$var$CardIcon.displayName = 'CardIcon';
var $12a6f1136d495aac$var$_default = module.exports.default = $12a6f1136d495aac$var$CardIcon;

});

parcelRegister("kg4VT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a5273bf73a300c0a96580f2d60e5eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebf920d4b240fd69$var$_react = $ebf920d4b240fd69$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $ebf920d4b240fd69$var$_iconNew = $ebf920d4b240fd69$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $ebf920d4b240fd69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clipboard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clipboard
 * Usage guidance:
 * Known uses: Pasting content from clipboard.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebf920d4b240fd69$var$ClipboardIcon = (props)=>/*#__PURE__*/ $ebf920d4b240fd69$var$_react.default.createElement($ebf920d4b240fd69$var$_iconNew.default, Object.assign({
        name: "ClipboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.563 1.5A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.937 1.5H12.5a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2zM4.5 3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75zm2-1.5A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$ebf920d4b240fd69$var$ClipboardIcon.displayName = 'ClipboardIcon';
var $ebf920d4b240fd69$var$_default = module.exports.default = $ebf920d4b240fd69$var$ClipboardIcon;

});

parcelRegister("7lqLi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7dc2367d51e33d9821000c60dc59b5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $558f40ecc3cb2c4a$var$_react = $558f40ecc3cb2c4a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $558f40ecc3cb2c4a$var$_iconNew = $558f40ecc3cb2c4a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $558f40ecc3cb2c4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-remove
 * Usage guidance:
 * Reserved for removing emoji.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $558f40ecc3cb2c4a$var$EmojiRemoveIcon = (props)=>/*#__PURE__*/ $558f40ecc3cb2c4a$var$_react.default.createElement($558f40ecc3cb2c4a$var$_iconNew.default, Object.assign({
        name: "EmojiRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.72 13.9 1.12 1.12A8 8 0 0 1 .98 4.16L2.1 5.28a6.5 6.5 0 0 0 8.63 8.63M8 0C6.61 0 5.3.36 4.16.98L5.28 2.1a6.5 6.5 0 0 1 8.63 8.63l1.12 1.12A8 8 0 0 0 8 0"/><path fill="currentcolor" d="m9.06 5.88 1.57 1.57a1.25 1.25 0 1 0-1.57-1.57m-2.97 4.15c.38.3.87.57 1.44.67l1.43 1.43c-.3.07-.62.11-.96.11-1.23 0-2.2-.54-2.83-1.03a6 6 0 0 1-.94-.92l-.06-.07-.02-.02-.01-.01.61-.44.61-.44.01.01.03.04q.05.06.14.16c.13.14.31.33.55.51M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$558f40ecc3cb2c4a$var$EmojiRemoveIcon.displayName = 'EmojiRemoveIcon';
var $558f40ecc3cb2c4a$var$_default = module.exports.default = $558f40ecc3cb2c4a$var$EmojiRemoveIcon;

});

parcelRegister("hvU6C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b14cef514625053097dfa4d10359700b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc00da5dbffcc673$var$_react = $cc00da5dbffcc673$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cc00da5dbffcc673$var$_iconNew = $cc00da5dbffcc673$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cc00da5dbffcc673$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field-checkbox-group
 * Usage guidance:
 * Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc00da5dbffcc673$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $cc00da5dbffcc673$var$_react.default.createElement($cc00da5dbffcc673$var$_iconNew.default, Object.assign({
        name: "FieldCheckboxGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$cc00da5dbffcc673$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $cc00da5dbffcc673$var$_default = module.exports.default = $cc00da5dbffcc673$var$FieldCheckboxGroupIcon;

});

parcelRegister("kGogQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c95e3b2b5922216d1b08416f0f7380e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0ea8e8aa7d0f86f$var$_react = $f0ea8e8aa7d0f86f$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f0ea8e8aa7d0f86f$var$_iconNew = $f0ea8e8aa7d0f86f$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f0ea8e8aa7d0f86f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageFullscreen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/image-fullscreen
 * Usage guidance:
 * Reserved for viewing an image in a fullscreen view or modal.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0ea8e8aa7d0f86f$var$ImageFullscreenIcon = (props)=>/*#__PURE__*/ $f0ea8e8aa7d0f86f$var$_react.default.createElement($f0ea8e8aa7d0f86f$var$_iconNew.default, Object.assign({
        name: "ImageFullscreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 1.5H5V0H1.375C.615 0 0 .616 0 1.375V5h1.5zM3 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h.633l2.892-3.719a1.375 1.375 0 0 1 1.927-.244l1.048.81V5a.5.5 0 0 0-.5-.5zm6.5 5.743L9.633 8.801l-2.1 2.699H11a.5.5 0 0 0 .5-.5zM16 11v3.625c0 .76-.616 1.375-1.375 1.375H11v-1.5h3.5V11z" clip-rule="evenodd"/><path fill="currentcolor" d="M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f0ea8e8aa7d0f86f$var$ImageFullscreenIcon.displayName = 'ImageFullscreenIcon';
var $f0ea8e8aa7d0f86f$var$_default = module.exports.default = $f0ea8e8aa7d0f86f$var$ImageFullscreenIcon;

});

parcelRegister("g6z2B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::558c104ff8faf5b48aac0a9ed58ae604>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb98634abf1d2792$var$_react = $bb98634abf1d2792$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $bb98634abf1d2792$var$_iconNew = $bb98634abf1d2792$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $bb98634abf1d2792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageInline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/image-inline
 * Usage guidance:
 * Reserved for representing inline images in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb98634abf1d2792$var$ImageInlineIcon = (props)=>/*#__PURE__*/ $bb98634abf1d2792$var$_react.default.createElement($bb98634abf1d2792$var$_iconNew.default, Object.assign({
        name: "ImageInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6.375C0 5.615.616 5 1.375 5h3.25C5.385 5 6 5.616 6 6.375v3.25C6 10.385 5.384 11 4.625 11h-3.25C.615 11 0 10.384 0 9.625zm1.5.125v3h3v-3zM16 8.75H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$bb98634abf1d2792$var$ImageInlineIcon.displayName = 'ImageInlineIcon';
var $bb98634abf1d2792$var$_default = module.exports.default = $bb98634abf1d2792$var$ImageInlineIcon;

});

parcelRegister("jE5M0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98a7fb9d1f8215942557835e8fe15757>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4d63b339b8a3521$var$_react = $e4d63b339b8a3521$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e4d63b339b8a3521$var$_iconNew = $e4d63b339b8a3521$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e4d63b339b8a3521$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/megaphone
 * Usage guidance:
 * Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4d63b339b8a3521$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $e4d63b339b8a3521$var$_react.default.createElement($e4d63b339b8a3521$var$_iconNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$e4d63b339b8a3521$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $e4d63b339b8a3521$var$_default = module.exports.default = $e4d63b339b8a3521$var$MegaphoneIcon;

});

parcelRegister("kVyVP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a080bf20295b7d277e5525fa21e7a7cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3c43a3db3cadb4d$var$_react = $f3c43a3db3cadb4d$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f3c43a3db3cadb4d$var$_iconNew = $f3c43a3db3cadb4d$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f3c43a3db3cadb4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/note
 * Usage guidance:
 * Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3c43a3db3cadb4d$var$NoteIcon = (props)=>/*#__PURE__*/ $f3c43a3db3cadb4d$var$_react.default.createElement($f3c43a3db3cadb4d$var$_iconNew.default, Object.assign({
        name: "NoteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$f3c43a3db3cadb4d$var$NoteIcon.displayName = 'NoteIcon';
var $f3c43a3db3cadb4d$var$_default = module.exports.default = $f3c43a3db3cadb4d$var$NoteIcon;

});

parcelRegister("lPEMY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::094fe57c93517a6ea39f3973813cfaec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe4e003ecdf579a2$var$_react = $fe4e003ecdf579a2$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $fe4e003ecdf579a2$var$_iconNew = $fe4e003ecdf579a2$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $fe4e003ecdf579a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pin".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pin
 * Usage guidance:
 * Known uses: unpinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe4e003ecdf579a2$var$PinIcon = (props)=>/*#__PURE__*/ $fe4e003ecdf579a2$var$_react.default.createElement($fe4e003ecdf579a2$var$_iconNew.default, Object.assign({
        name: "PinIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864a.75.75 0 0 0-.106.386V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$fe4e003ecdf579a2$var$PinIcon.displayName = 'PinIcon';
var $fe4e003ecdf579a2$var$_default = module.exports.default = $fe4e003ecdf579a2$var$PinIcon;

});

parcelRegister("7XtiO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25371e7e1c229a6eed686770dc07063d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb4c5f1f9b1d4b6$var$_react = $5cb4c5f1f9b1d4b6$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5cb4c5f1f9b1d4b6$var$_iconNew = $5cb4c5f1f9b1d4b6$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5cb4c5f1f9b1d4b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pin-filled
 * Usage guidance:
 * Known uses: pinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb4c5f1f9b1d4b6$var$PinFilledIcon = (props)=>/*#__PURE__*/ $5cb4c5f1f9b1d4b6$var$_react.default.createElement($5cb4c5f1f9b1d4b6$var$_iconNew.default, Object.assign({
        name: "PinFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/><path fill="currentcolor" d="m9.606 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$5cb4c5f1f9b1d4b6$var$PinFilledIcon.displayName = 'PinFilledIcon';
var $5cb4c5f1f9b1d4b6$var$_default = module.exports.default = $5cb4c5f1f9b1d4b6$var$PinFilledIcon;

});

parcelRegister("lWuWs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfa2cf486e4aacf3a93b8dc816f49bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff97042862e412e1$var$_react = $ff97042862e412e1$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $ff97042862e412e1$var$_iconNew = $ff97042862e412e1$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $ff97042862e412e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkCard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-card
 * Usage guidance:
 * Reserved for representing Smart link preview cards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff97042862e412e1$var$SmartLinkCardIcon = (props)=>/*#__PURE__*/ $ff97042862e412e1$var$_react.default.createElement($ff97042862e412e1$var$_iconNew.default, Object.assign({
        name: "SmartLinkCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8v-7zm9.5 0v7H14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5H3V6h5.5zM6 10H3V8.5h3z" clip-rule="evenodd"/>`
    }, props));
$ff97042862e412e1$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
var $ff97042862e412e1$var$_default = module.exports.default = $ff97042862e412e1$var$SmartLinkCardIcon;

});

parcelRegister("lqWtA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::91eb3cc88ce44a200106439f98b1c931>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9a962da428c4752$var$_react = $f9a962da428c4752$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f9a962da428c4752$var$_iconNew = $f9a962da428c4752$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f9a962da428c4752$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-embed
 * Usage guidance:
 * Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9a962da428c4752$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $f9a962da428c4752$var$_react.default.createElement($f9a962da428c4752$var$_iconNew.default, Object.assign({
        name: "SmartLinkEmbedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$f9a962da428c4752$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $f9a962da428c4752$var$_default = module.exports.default = $f9a962da428c4752$var$SmartLinkEmbedIcon;

});

parcelRegister("jaXwU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37aef58481faa7bf408ae8e16cd35331>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df5d20d9cf55bcd7$var$_react = $df5d20d9cf55bcd7$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $df5d20d9cf55bcd7$var$_iconNew = $df5d20d9cf55bcd7$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $df5d20d9cf55bcd7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkInline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-inline
 * Usage guidance:
 * Reserved for representing inline Smart link lozenges.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df5d20d9cf55bcd7$var$SmartLinkInlineIcon = (props)=>/*#__PURE__*/ $df5d20d9cf55bcd7$var$_react.default.createElement($df5d20d9cf55bcd7$var$_iconNew.default, Object.assign({
        name: "SmartLinkInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3zm4 0v3h8a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$df5d20d9cf55bcd7$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
var $df5d20d9cf55bcd7$var$_default = module.exports.default = $df5d20d9cf55bcd7$var$SmartLinkInlineIcon;

});

parcelRegister("d6RFo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc3dca90319e7388db9e2dce4ed3d07c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98b576f4cb58965a$var$_react = $98b576f4cb58965a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $98b576f4cb58965a$var$_iconNew = $98b576f4cb58965a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $98b576f4cb58965a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-list
 * Usage guidance:
 * Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98b576f4cb58965a$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $98b576f4cb58965a$var$_react.default.createElement($98b576f4cb58965a$var$_iconNew.default, Object.assign({
        name: "SmartLinkListIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$98b576f4cb58965a$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $98b576f4cb58965a$var$_default = module.exports.default = $98b576f4cb58965a$var$SmartLinkListIcon;

});

parcelRegister("8Mmfj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b21529f89f7d042240b8c37cbada8167>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66440ffd4f12f0db$var$_react = $66440ffd4f12f0db$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $66440ffd4f12f0db$var$_iconNew = $66440ffd4f12f0db$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $66440ffd4f12f0db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightLarge".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-large
 * Usage guidance:
 * Reserved for representing thick border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66440ffd4f12f0db$var$StrokeWeightLargeIcon = (props)=>/*#__PURE__*/ $66440ffd4f12f0db$var$_react.default.createElement($66440ffd4f12f0db$var$_iconNew.default, Object.assign({
        name: "StrokeWeightLargeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0" clip-rule="evenodd"/>`
    }, props));
$66440ffd4f12f0db$var$StrokeWeightLargeIcon.displayName = 'StrokeWeightLargeIcon';
var $66440ffd4f12f0db$var$_default = module.exports.default = $66440ffd4f12f0db$var$StrokeWeightLargeIcon;

});

parcelRegister("cUD3Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18d5d901ba554d7c6cf9038d41b45bd8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $966904281d3456c5$var$_react = $966904281d3456c5$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $966904281d3456c5$var$_iconNew = $966904281d3456c5$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $966904281d3456c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-medium
 * Usage guidance:
 * Reserved for representing medium border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $966904281d3456c5$var$StrokeWeightMediumIcon = (props)=>/*#__PURE__*/ $966904281d3456c5$var$_react.default.createElement($966904281d3456c5$var$_iconNew.default, Object.assign({
        name: "StrokeWeightMediumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0" clip-rule="evenodd"/>`
    }, props));
$966904281d3456c5$var$StrokeWeightMediumIcon.displayName = 'StrokeWeightMediumIcon';
var $966904281d3456c5$var$_default = module.exports.default = $966904281d3456c5$var$StrokeWeightMediumIcon;

});

parcelRegister("dbIlo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37466cf4f5caccf974d8190845f39f40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $999eb33a7511d453$var$_react = $999eb33a7511d453$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $999eb33a7511d453$var$_iconNew = $999eb33a7511d453$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $999eb33a7511d453$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellClear".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-clear
 * Usage guidance:
 * Reserved for clearing the contents of table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $999eb33a7511d453$var$TableCellClearIcon = (props)=>/*#__PURE__*/ $999eb33a7511d453$var$_react.default.createElement($999eb33a7511d453$var$_iconNew.default, Object.assign({
        name: "TableCellClearIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.94 4L5.22 6.28l1.06-1.06L8 6.94l1.72-1.72 1.06 1.06L9.06 8l1.72 1.72-1.06 1.06L8 9.06l-1.72 1.72-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$999eb33a7511d453$var$TableCellClearIcon.displayName = 'TableCellClearIcon';
var $999eb33a7511d453$var$_default = module.exports.default = $999eb33a7511d453$var$TableCellClearIcon;

});

parcelRegister("hNjgW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd158ed63accbc15b06434c09d1e7688>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf45f654df385105$var$_react = $cf45f654df385105$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cf45f654df385105$var$_iconNew = $cf45f654df385105$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cf45f654df385105$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellMerge".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-merge
 * Usage guidance:
 * Reserved for merging table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf45f654df385105$var$TableCellMergeIcon = (props)=>/*#__PURE__*/ $cf45f654df385105$var$_react.default.createElement($cf45f654df385105$var$_iconNew.default, Object.assign({
        name: "TableCellMergeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zm12 0H9V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M5.19 8 3.47 6.28l1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06zm4.03-.53 2.25-2.25 1.06 1.06L10.81 8l1.72 1.72-1.06 1.06-2.25-2.25a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$cf45f654df385105$var$TableCellMergeIcon.displayName = 'TableCellMergeIcon';
var $cf45f654df385105$var$_default = module.exports.default = $cf45f654df385105$var$TableCellMergeIcon;

});

parcelRegister("ifAKO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6901c67cca80c8242be2d93fe8d4eb3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4962349506576bf$var$_react = $d4962349506576bf$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d4962349506576bf$var$_iconNew = $d4962349506576bf$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d4962349506576bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-split
 * Usage guidance:
 * Reserved for splitting joined table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4962349506576bf$var$TableCellSplitIcon = (props)=>/*#__PURE__*/ $d4962349506576bf$var$_react.default.createElement($d4962349506576bf$var$_iconNew.default, Object.assign({
        name: "TableCellSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 3.5H0V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5m6 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zM.22 7.47l2.25-2.25 1.06 1.06L1.81 8l1.72 1.72-1.06 1.06L.22 8.53a.75.75 0 0 1 0-1.06M14.19 8l-1.72-1.72 1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$d4962349506576bf$var$TableCellSplitIcon.displayName = 'TableCellSplitIcon';
var $d4962349506576bf$var$_default = module.exports.default = $d4962349506576bf$var$TableCellSplitIcon;

});

parcelRegister("g3xgW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e99802f2e737020f4d265f3fccc6feba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb06bc5061bcffb2$var$_react = $bb06bc5061bcffb2$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $bb06bc5061bcffb2$var$_iconNew = $bb06bc5061bcffb2$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $bb06bc5061bcffb2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-add-left
 * Usage guidance:
 * Reserved for adding a table column to the left of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb06bc5061bcffb2$var$TableColumnAddLeftIcon = (props)=>/*#__PURE__*/ $bb06bc5061bcffb2$var$_react.default.createElement($bb06bc5061bcffb2$var$_iconNew.default, Object.assign({
        name: "TableColumnAddLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.75 8.75V11h-1.5V8.75H0v-1.5h2.25V5h1.5v2.25H6v1.5z" clip-rule="evenodd"/>`
    }, props));
$bb06bc5061bcffb2$var$TableColumnAddLeftIcon.displayName = 'TableColumnAddLeftIcon';
var $bb06bc5061bcffb2$var$_default = module.exports.default = $bb06bc5061bcffb2$var$TableColumnAddLeftIcon;

});

parcelRegister("7NMrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d25eddbd59369a4dc35dfe0ed526458c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ae2aeaed9704875$var$_react = $5ae2aeaed9704875$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5ae2aeaed9704875$var$_iconNew = $5ae2aeaed9704875$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5ae2aeaed9704875$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-add-right
 * Usage guidance:
 * Reserved for adding a table column to the right of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ae2aeaed9704875$var$TableColumnAddRightIcon = (props)=>/*#__PURE__*/ $5ae2aeaed9704875$var$_react.default.createElement($5ae2aeaed9704875$var$_iconNew.default, Object.assign({
        name: "TableColumnAddRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.25 6.25V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5z" clip-rule="evenodd"/>`
    }, props));
$5ae2aeaed9704875$var$TableColumnAddRightIcon.displayName = 'TableColumnAddRightIcon';
var $5ae2aeaed9704875$var$_default = module.exports.default = $5ae2aeaed9704875$var$TableColumnAddRightIcon;

});

parcelRegister("aahno", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d83f078545a7bbec3d743a76d746955>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76685122a6dafb64$var$_react = $76685122a6dafb64$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $76685122a6dafb64$var$_iconNew = $76685122a6dafb64$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $76685122a6dafb64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-delete
 * Usage guidance:
 * Reserved for deleting a table column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76685122a6dafb64$var$TableColumnDeleteIcon = (props)=>/*#__PURE__*/ $76685122a6dafb64$var$_react.default.createElement($76685122a6dafb64$var$_iconNew.default, Object.assign({
        name: "TableColumnDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm11 6.25h-6v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$76685122a6dafb64$var$TableColumnDeleteIcon.displayName = 'TableColumnDeleteIcon';
var $76685122a6dafb64$var$_default = module.exports.default = $76685122a6dafb64$var$TableColumnDeleteIcon;

});

parcelRegister("4OzNK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f88c9202ad41652af953a050b1c0148>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38179a55766a7cd2$var$_react = $38179a55766a7cd2$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $38179a55766a7cd2$var$_iconNew = $38179a55766a7cd2$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $38179a55766a7cd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-move-left
 * Usage guidance:
 * Reserved for moving a table column to the left of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38179a55766a7cd2$var$TableColumnMoveLeftIcon = (props)=>/*#__PURE__*/ $38179a55766a7cd2$var$_react.default.createElement($38179a55766a7cd2$var$_iconNew.default, Object.assign({
        name: "TableColumnMoveLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.22 4.47l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72H6v-1.5H2.56l1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$38179a55766a7cd2$var$TableColumnMoveLeftIcon.displayName = 'TableColumnMoveLeftIcon';
var $38179a55766a7cd2$var$_default = module.exports.default = $38179a55766a7cd2$var$TableColumnMoveLeftIcon;

});

parcelRegister("9hqkg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a13e9eb392e23a5cb46d94f5457326ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c1a1f607327dee0$var$_react = $6c1a1f607327dee0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6c1a1f607327dee0$var$_iconNew = $6c1a1f607327dee0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6c1a1f607327dee0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-move-right
 * Usage guidance:
 * Reserved for moving a table column to the right of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c1a1f607327dee0$var$TableColumnMoveRightIcon = (props)=>/*#__PURE__*/ $6c1a1f607327dee0$var$_react.default.createElement($6c1a1f607327dee0$var$_iconNew.default, Object.assign({
        name: "TableColumnMoveRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.78 1.97 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06 1.72-1.72H10v-1.5h3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$6c1a1f607327dee0$var$TableColumnMoveRightIcon.displayName = 'TableColumnMoveRightIcon';
var $6c1a1f607327dee0$var$_default = module.exports.default = $6c1a1f607327dee0$var$TableColumnMoveRightIcon;

});

parcelRegister("hNLr3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd7ac2615482fa596dfe409d6ad2a75c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf5bcef28a5d5e1b$var$_react = $cf5bcef28a5d5e1b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cf5bcef28a5d5e1b$var$_iconNew = $cf5bcef28a5d5e1b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cf5bcef28a5d5e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddAbove".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-add-above
 * Usage guidance:
 * Reserved for adding a table row above the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf5bcef28a5d5e1b$var$TableRowAddAboveIcon = (props)=>/*#__PURE__*/ $cf5bcef28a5d5e1b$var$_react.default.createElement($cf5bcef28a5d5e1b$var$_iconNew.default, Object.assign({
        name: "TableRowAddAboveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm6.25-7.25H11v-1.5H8.75V0h-1.5v2.25H5v1.5h2.25V6h1.5z" clip-rule="evenodd"/>`
    }, props));
$cf5bcef28a5d5e1b$var$TableRowAddAboveIcon.displayName = 'TableRowAddAboveIcon';
var $cf5bcef28a5d5e1b$var$_default = module.exports.default = $cf5bcef28a5d5e1b$var$TableRowAddAboveIcon;

});

parcelRegister("9oT08", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::088f872458a9690a9677799fea659be0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d81050d7a5576fe$var$_react = $6d81050d7a5576fe$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $6d81050d7a5576fe$var$_iconNew = $6d81050d7a5576fe$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $6d81050d7a5576fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddBelow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-add-below
 * Usage guidance:
 * Reserved for adding a table row below the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d81050d7a5576fe$var$TableRowAddBelowIcon = (props)=>/*#__PURE__*/ $6d81050d7a5576fe$var$_react.default.createElement($6d81050d7a5576fe$var$_iconNew.default, Object.assign({
        name: "TableRowAddBelowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm6.25 7.25H11v1.5H8.75V16h-1.5v-2.25H5v-1.5h2.25V10h1.5z" clip-rule="evenodd"/>`
    }, props));
$6d81050d7a5576fe$var$TableRowAddBelowIcon.displayName = 'TableRowAddBelowIcon';
var $6d81050d7a5576fe$var$_default = module.exports.default = $6d81050d7a5576fe$var$TableRowAddBelowIcon;

});

parcelRegister("6r6BE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0fcf16ec81cff8b9c1d330cfed0d8da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4afa639111a373ab$var$_react = $4afa639111a373ab$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4afa639111a373ab$var$_iconNew = $4afa639111a373ab$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4afa639111a373ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-delete
 * Usage guidance:
 * Reserved for deleting a table row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4afa639111a373ab$var$TableRowDeleteIcon = (props)=>/*#__PURE__*/ $4afa639111a373ab$var$_react.default.createElement($4afa639111a373ab$var$_iconNew.default, Object.assign({
        name: "TableRowDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm8.5 7.25H5v1.5h6z" clip-rule="evenodd"/>`
    }, props));
$4afa639111a373ab$var$TableRowDeleteIcon.displayName = 'TableRowDeleteIcon';
var $4afa639111a373ab$var$_default = module.exports.default = $4afa639111a373ab$var$TableRowDeleteIcon;

});

parcelRegister("7NVl9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bd0fd11ae86554914d37c1f7853fb66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ae9968a7130ade0$var$_react = $5ae9968a7130ade0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5ae9968a7130ade0$var$_iconNew = $5ae9968a7130ade0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5ae9968a7130ade0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveDown".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-move-down
 * Usage guidance:
 * Reserved for moving a table row below its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ae9968a7130ade0$var$TableRowMoveDownIcon = (props)=>/*#__PURE__*/ $5ae9968a7130ade0$var$_react.default.createElement($5ae9968a7130ade0$var$_iconNew.default, Object.assign({
        name: "TableRowMoveDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm1.97 7.78 3 3a.75.75 0 0 0 1.06 0l3-3-1.06-1.06-1.72 1.72V10h-1.5v3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$5ae9968a7130ade0$var$TableRowMoveDownIcon.displayName = 'TableRowMoveDownIcon';
var $5ae9968a7130ade0$var$_default = module.exports.default = $5ae9968a7130ade0$var$TableRowMoveDownIcon;

});

parcelRegister("bQXky", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6658efa410614a3df4d5545c16ea7387>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a1292d5775f1cfc$var$_react = $8a1292d5775f1cfc$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8a1292d5775f1cfc$var$_iconNew = $8a1292d5775f1cfc$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8a1292d5775f1cfc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveUp".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-move-up
 * Usage guidance:
 * Reserved for moving a table row above its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a1292d5775f1cfc$var$TableRowMoveUpIcon = (props)=>/*#__PURE__*/ $8a1292d5775f1cfc$var$_react.default.createElement($8a1292d5775f1cfc$var$_iconNew.default, Object.assign({
        name: "TableRowMoveUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm1.97-7.78 3-3a.75.75 0 0 1 1.06 0l3 3-1.06 1.06-1.72-1.72V6h-1.5V2.56L5.53 4.28z" clip-rule="evenodd"/>`
    }, props));
$8a1292d5775f1cfc$var$TableRowMoveUpIcon.displayName = 'TableRowMoveUpIcon';
var $8a1292d5775f1cfc$var$_default = module.exports.default = $8a1292d5775f1cfc$var$TableRowMoveUpIcon;

});

parcelRegister("74hnl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::078cb0504cec10813042110e5e382485>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52566289f9643cc7$var$_react = $52566289f9643cc7$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $52566289f9643cc7$var$_iconNew = $52566289f9643cc7$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $52566289f9643cc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStrikethrough".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-strikethrough
 * Usage guidance:
 * Reserved for strikethrough text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52566289f9643cc7$var$TextStrikethroughIcon = (props)=>/*#__PURE__*/ $52566289f9643cc7$var$_react.default.createElement($52566289f9643cc7$var$_iconNew.default, Object.assign({
        name: "TextStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.47 2.5a2.12 2.12 0 0 0-1.79 3.25H4.03a3.59 3.59 0 0 1 .5-3.25A3.62 3.62 0 0 1 7.47 1h.93a4.08 4.08 0 0 1 3.19 1.53l-1.17.94A2.58 2.58 0 0 0 8.4 2.5zm3.51 7.75h1.58A3.82 3.82 0 0 1 8.86 15h-.67a4.5 4.5 0 0 1-4.11-2.67l-.01-.02 1.37-.61.01.02a3 3 0 0 0 2.74 1.78h.67a2.32 2.32 0 0 0 2.12-3.25m4.02-3H1v1.5h14z"/>`
    }, props));
$52566289f9643cc7$var$TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
var $52566289f9643cc7$var$_default = module.exports.default = $52566289f9643cc7$var$TextStrikethroughIcon;

});

parcelRegister("dTdDF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8428ad3e966f216a91f320cc6db50f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1cafdd207f52c95$var$_react = $a1cafdd207f52c95$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a1cafdd207f52c95$var$_iconNew = $a1cafdd207f52c95$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a1cafdd207f52c95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-underline
 * Usage guidance:
 * Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1cafdd207f52c95$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $a1cafdd207f52c95$var$_react.default.createElement($a1cafdd207f52c95$var$_iconNew.default, Object.assign({
        name: "TextUnderlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$a1cafdd207f52c95$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $a1cafdd207f52c95$var$_default = module.exports.default = $a1cafdd207f52c95$var$TextUnderlineIcon;

});

parcelRegister("1egeT", function(module, exports) {
$parcel$export(module.exports, "Bleed", () => $1a5dd194f25ecf05$export$a8307195dd50fcbf);
/* bleed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $1a5dd194f25ecf05$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
const $1a5dd194f25ecf05$export$a8307195dd50fcbf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $1a5dd194f25ecf05$var$styles.root,
            all && $1a5dd194f25ecf05$var$styles[`inline.${all}`],
            inline && $1a5dd194f25ecf05$var$styles[`inline.${inline}`],
            all && $1a5dd194f25ecf05$var$styles[`block.${all}`],
            block && $1a5dd194f25ecf05$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$1a5dd194f25ecf05$export$a8307195dd50fcbf.displayName = 'Bleed';

});

parcelRegister("hdHtB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad0e0e4987ec36f6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $dvdNF = parcelRequire("dvdNF");
function $ad0e0e4987ec36f6$export$2e2bcd8739ae039() {
    const tabPanelData = (0, $bSJIT.useContext)((0, $dvdNF.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
}

});

parcelRegister("lABnJ", function(module, exports) {
$parcel$export(module.exports, "isValidEmail", () => $a71107e356516c77$export$371e338370561054);
const $a71107e356516c77$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $a71107e356516c77$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $a71107e356516c77$export$371e338370561054 = (inputText)=>{
    if (inputText.match($a71107e356516c77$var$validRegex)) return 'VALID';
    if (inputText.match($a71107e356516c77$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});

parcelRegister("cBisG", function(module, exports) {
$parcel$export(module.exports, "NodeDataProvider", () => $24a7edf60eac467d$export$1185db7a00c13eed);

var $7lseo = parcelRequire("7lseo");
class $24a7edf60eac467d$export$1185db7a00c13eed {
    constructor(){
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $7lseo.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if ((dataFromCache === null || dataFromCache === void 0 ? void 0 : dataFromCache.source) !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = (options === null || options === void 0 ? void 0 : options.strategy) ?? 'merge';
        const source = (options === null || options === void 0 ? void 0 : options.source) ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
}

});

parcelRegister("Rm7pg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a061b9dfaab765a$export$2e2bcd8739ae039);

var $7hBaz = parcelRequire("7hBaz");

var $eS4ZU = parcelRequire("eS4ZU");

var $OPOsJ = parcelRequire("OPOsJ");
function $0a061b9dfaab765a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $OPOsJ.default)(1, arguments);
    return (0, $7hBaz.default)(dirtyDate, (0, $eS4ZU.default)(Date.now(), 1));
}

});
parcelRegister("eS4ZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad39fc3c41088fc8$export$2e2bcd8739ae039);

var $k6vQB = parcelRequire("k6vQB");

var $OPOsJ = parcelRequire("OPOsJ");

var $cPnJw = parcelRequire("cPnJw");
function $ad39fc3c41088fc8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $OPOsJ.default)(2, arguments);
    var amount = (0, $cPnJw.default)(dirtyAmount);
    return (0, $k6vQB.default)(dirtyDate, -amount);
}

});
parcelRegister("k6vQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea2d126e66a5dae8$export$2e2bcd8739ae039);

var $cPnJw = parcelRequire("cPnJw");

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $ea2d126e66a5dae8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $OPOsJ.default)(2, arguments);
    var date = (0, $897M5.default)(dirtyDate);
    var amount = (0, $cPnJw.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});



parcelRegister("c7jdP", function(module, exports) {
$parcel$export(module.exports, "default", () => $634ca929304d3d46$export$2e2bcd8739ae039);
function $634ca929304d3d46$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("fS68E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20ca6fda7b1aa7cbbe1381bbd0504e95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8e0a9239986777e$var$_react = $b8e0a9239986777e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $b8e0a9239986777e$var$_iconNew = $b8e0a9239986777e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $b8e0a9239986777e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionCenterVertical".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-center-vertical
 * Usage guidance:
 * Center-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8e0a9239986777e$var$AlignPositionCenterVerticalIcon = (props)=>/*#__PURE__*/ $b8e0a9239986777e$var$_react.default.createElement($b8e0a9239986777e$var$_iconNew.default, Object.assign({
        name: "AlignPositionCenterVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-7 12.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 7.25h16v1.5H0z" clip-rule="evenodd"/>`
    }, props));
$b8e0a9239986777e$var$AlignPositionCenterVerticalIcon.displayName = 'AlignPositionCenterVerticalIcon';
var $b8e0a9239986777e$var$_default = module.exports.default = $b8e0a9239986777e$var$AlignPositionCenterVerticalIcon;

});

parcelRegister("4dKmO", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $312c57da24e5ee74$export$c9058316764c140e);

var $abgtU = parcelRequire("abgtU");

var $lRIHl = parcelRequire("lRIHl");
function $312c57da24e5ee74$export$c9058316764c140e(refs) {
    return (0, $lRIHl.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $abgtU.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("lRIHl", function(module, exports) {
$parcel$export(module.exports, "createCallbackRef", () => $feb1385498501a5a$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $feb1385498501a5a$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("3q3fP", function(module, exports) {
$parcel$export(module.exports, "isImagePreview", () => $2cb66b909bfbf90e$export$5fe5572478566289);
const $2cb66b909bfbf90e$export$5fe5572478566289 = (preview)=>!!preview.dimensions;

});

parcelRegister("8AI2A", function(module, exports) {
$parcel$export(module.exports, "BrowserLoader", () => $0b4bb44b5957561c$export$3ce634ac4a869e2c);

var $bSJIT = parcelRequire("bSJIT");


class $0b4bb44b5957561c$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncBrowser';
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("hTzgT"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("hTzgT", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("eqf5q")
]).then(()=>parcelRequire('iB3wS'));

});


parcelRegister("ewM8s", function(module, exports) {
$parcel$export(module.exports, "ClipboardLoader", () => $11d77a6318f80c12$export$d7936799bf32b554);

var $bSJIT = parcelRequire("bSJIT");


class $11d77a6318f80c12$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncClipboard';
    componentDidMount() {
        if (!this.state.Clipboard) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("53xKg"))
        ]).then(([mediaClient, clipboardModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $11d77a6318f80c12$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $11d77a6318f80c12$export$d7936799bf32b554.Clipboard
            });
        });
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $11d77a6318f80c12$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("53xKg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("2KVrZ")
]).then(()=>parcelRequire('jng1z'));

});


parcelRegister("7tc9a", function(module, exports) {
$parcel$export(module.exports, "DropzoneLoader", () => $a3a0cb02c40d3d21$export$66201d263cd6342);

var $bSJIT = parcelRequire("bSJIT");



class $a3a0cb02c40d3d21$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncDropzone';
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("V4wSv")),
            (parcelRequire("agaIQ"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("V4wSv", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("dwvI2")
]).then(()=>parcelRequire('esQLv'));

});

parcelRegister("agaIQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gCHew").then(()=>parcelRequire('8gt2G'));

});


parcelRegister("2nt4W", function(module, exports) {
$parcel$export(module.exports, "default", () => $e059f7361b25064b$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $e059f7361b25064b$var$_default_1 = (0, $f0Pt4.defineMessages)({
    white: {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Tooltip label for the white color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-blue': {
        id: 'fabric.theme.light-blue',
        defaultMessage: 'Light blue',
        description: 'Tooltip label for the light blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-teal': {
        id: 'fabric.theme.light-teal',
        defaultMessage: 'Light teal',
        description: 'Tooltip label for the light teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-green': {
        id: 'fabric.theme.light-green',
        defaultMessage: 'Light green',
        description: 'Tooltip label for the light green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-lime': {
        id: 'fabric.theme.light-lime',
        defaultMessage: 'Light lime',
        description: 'Tooltip label for the light lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-yellow': {
        id: 'fabric.theme.light-yellow',
        defaultMessage: 'Light yellow',
        description: 'Tooltip label for the light yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-orange': {
        id: 'fabric.theme.light-orange',
        defaultMessage: 'Light orange',
        description: 'Tooltip label for the light orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-red': {
        id: 'fabric.theme.light-red',
        defaultMessage: 'Light red',
        description: 'Tooltip label for the light red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-magenta': {
        id: 'fabric.theme.light-magenta',
        defaultMessage: 'Light magenta',
        description: 'Tooltip label for the light magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-purple': {
        id: 'fabric.theme.light-purple',
        defaultMessage: 'Light purple',
        description: 'Tooltip label for the light purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-gray': {
        id: 'fabric.theme.light-gray',
        defaultMessage: 'Light gray',
        description: 'Tooltip label for the light gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    blue: {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Tooltip label for the blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    teal: {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Tooltip label for the teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    green: {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Tooltip label for the green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    yellow: {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Tooltip label for the yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    red: {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Tooltip label for the red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    orange: {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Tooltip label for the orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    purple: {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Tooltip label for the purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    gray: {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Tooltip label for the gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-blue': {
        id: 'fabric.theme.dark-blue',
        defaultMessage: 'Dark blue',
        description: 'Tooltip label for the dark blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-teal': {
        id: 'fabric.theme.dark-teal',
        defaultMessage: 'Dark teal',
        description: 'Tooltip label for the dark teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-green': {
        id: 'fabric.theme.dark-green',
        defaultMessage: 'Dark green',
        description: 'Tooltip label for the dark green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-lime': {
        id: 'fabric.theme.dark-lime',
        defaultMessage: 'Dark lime',
        description: 'Tooltip label for the dark lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-yellow': {
        id: 'fabric.theme.dark-yellow',
        defaultMessage: 'Dark yellow',
        description: 'Tooltip label for the dark yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-orange': {
        id: 'fabric.theme.dark-orange',
        defaultMessage: 'Dark orange',
        description: 'Tooltip label for the dark orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-red': {
        id: 'fabric.theme.dark-red',
        defaultMessage: 'Dark red',
        description: 'Tooltip label for the dark red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-magenta': {
        id: 'fabric.theme.dark-magenta',
        defaultMessage: 'Dark magenta',
        description: 'Tooltip label for the dark magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-purple': {
        id: 'fabric.theme.dark-purple',
        defaultMessage: 'Dark purple',
        description: 'Tooltip label for the dark purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-gray': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Tooltip label for the subtle gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-gray': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Tooltip label for the bold gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-lime': {
        id: 'fabric.theme.subtle-lime',
        defaultMessage: 'Subtle lime',
        description: 'Tooltip label for the subtle lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-lime': {
        id: 'fabric.theme.bold-lime',
        defaultMessage: 'Bold lime',
        description: 'Tooltip label for the bold lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-orange': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'Tooltip label for the subtle orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-orange': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Tooltip label for the bold orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-magenta': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'Tooltip label for the subtle magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-magenta': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'Tooltip label for the bold magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-blue': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Tooltip label for the bold blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-teal': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Tooltip label for the bold teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-green': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Tooltip label for the bold green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-yellow': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Tooltip label for the bold yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-red': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Tooltip label for the bold red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-purple': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Tooltip label for the bold purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    // Colors only used in highlight palette
    'no-color': {
        id: 'fabric.theme.no-color',
        defaultMessage: 'No highlight',
        description: 'Tooltip for the no color option in the highlight color palette in the main editor toolbar'
    },
    lime: {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: "Tooltip for the lime color used in the main toolbar's highlight color palette"
    },
    magenta: {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: "Tooltip for the magenta color used in the main toolbar's highlight color palette"
    }
});
var $e059f7361b25064b$export$2e2bcd8739ae039 = $e059f7361b25064b$var$_default_1;

});

parcelRegister("kbO7u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb2bb6747a7c826a$var$_react = $eb2bb6747a7c826a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $eb2bb6747a7c826a$var$_iconNew = $eb2bb6747a7c826a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $eb2bb6747a7c826a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb2bb6747a7c826a$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $eb2bb6747a7c826a$var$_react.default.createElement($eb2bb6747a7c826a$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$eb2bb6747a7c826a$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $eb2bb6747a7c826a$var$_default = module.exports.default = $eb2bb6747a7c826a$var$WarningOutlineIcon;

});

parcelRegister("6nCvv", function(module, exports) {
$parcel$export(module.exports, "mapPaletteColor", () => $294a790deb07cdb9$export$cf81161afbd9f18c);

var $c7jdP = parcelRequire("c7jdP");

var $2nt4W = parcelRequire("2nt4W");
const $294a790deb07cdb9$export$cf81161afbd9f18c = (label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $c7jdP.default)((0, $2nt4W.default), key);
    return {
        value: color,
        label: label,
        border: "var(--ds-border, #0B120E24)",
        message: message
    };
};

});

parcelRegister("94635", function(module, exports) {
$parcel$export(module.exports, "default", () => $252267473ef01ab0$export$2e2bcd8739ae039);

var $c8L22 = parcelRequire("c8L22");

var $c7jdP = parcelRequire("c7jdP");

var $2nt4W = parcelRequire("2nt4W");
const $252267473ef01ab0$var$cellBackgroundColorPalette = [];
(0, $c8L22.tableBackgroundColorPalette).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $c7jdP.default)((0, $2nt4W.default), key);
    $252267473ef01ab0$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $c8L22.tableBackgroundBorderColor),
        message: message
    });
});
var $252267473ef01ab0$export$2e2bcd8739ae039 = $252267473ef01ab0$var$cellBackgroundColorPalette;

});

parcelRegister("evw0j", function(module, exports) {
$parcel$export(module.exports, "textColorPalette", () => $2944f6d75b0a24cd$export$25c6a5f643998d29);

var $3e3xK = parcelRequire("3e3xK");

var $6nCvv = parcelRequire("6nCvv");

const $2944f6d75b0a24cd$export$25c6a5f643998d29 = [];
(0, $3e3xK.colorPalette).forEach((label, color)=>{
    $2944f6d75b0a24cd$export$25c6a5f643998d29.push((0, $6nCvv.mapPaletteColor)(label, color));
});

});


//# sourceMappingURL=rich-text-editor-v2.20fffea7.js.map
